/* global angular */
/**
 * @ngdoc overview
 * @module wageCalculator
 * @description
 * # Initializes main application
 *
 * Main module of the application.
 *
 * @author Marius Schmidt <marius@denktmit.de>
 * @author Julian Schlarb <js@project-deadline.com>
 */
(function () {
  'use strict'; //NOSONAR

  angular
    .module('wageCalculator', [
      'ngAnimate',
      'ngTouch',
      'ngSanitize',
      'ui.router',
      'ui.bootstrap',
      'toastr',
      'vcRecaptcha',
      'wageCalculator.config',
      'wageCalculator.staticPages',
      'wageCalculator.calculator',
      'wageCalculator.contact',
      'wageCalculator.survey',
      'rzModule',
      'ngMeta'
    ]);
})();

/* global angular */
/**
 * @ngdoc overview
 * @module wageCalculator.config
 * @description
 * # Initializes main application
 *
 * Main module of the application.
 *
 * @author Marius Schmidt <marius@denktmit.de>
 * @author Julian Schlarb <js@project-deadline.com>
 */
(function () {
  'use strict'; //NOSONAR

  angular
    .module('wageCalculator.config', []);
})();

/* global angular */
/**
 * @ngdoc overview
 * @module wageCalculator.api
 * @description
 * # Initializes api module
 *
 * Api is a sub module of the application.
 *
 * @author Marius Schmidt <marius@denktmit.de>
 * @author Julian Schlarb <js@project-deadline.com>
 */
(function () {
  'use strict'; //NOSONAR

  angular
    .module('wageCalculator.api', [
      'wageCalculator.api.models'
    ]);
})();

/* global angular */
/**
 * @ngdoc overview
 * @module wageCalculator.calculator
 * @description
 * # Initializes calculator module
 *
 * Calculator is a sub module of the application.
 *
 * @author Marius Schmidt <marius@denktmit.de>
 * @author Julian Schlarb <js@project-deadline.com>
 */
(function () {
  'use strict'; //NOSONAR

  angular
    .module('wageCalculator.calculator', [
      'ui.router',
      'vcRecaptcha',
      'wageCalculator.config',
      'wageCalculator.api'
    ]);
})();

/* global angular */
/**
 * @ngdoc overview
 * @module wageCalculator.contact
 * @description
 * # Initializes contact module
 *
 * Contact is a sub module of the application.
 *
 * @author Marius Schmidt <marius@denktmit.de>
 * @author Julian Schlarb <js@project-deadline.com>
 */
(function () {
  'use strict'; //NOSONAR

  angular
    .module('wageCalculator.contact', [
      'ui.router',
      'wageCalculator.config',
      'wageCalculator.api',
      'schemaForm'
    ])
})();

/* global angular */
/**
 * @ngdoc overview
 * @module wageCalculator.staticPages
 * @description
 * # Initializes staticPages module
 *
 * Static pages is a sub module of the application and contains only static content
 *
 * @author Marius Schmidt <marius@denktmit.de>
 * @author Julian Schlarb <js@project-deadline.com>
 */
(function () {
  'use strict'; //NOSONAR

  angular
    .module('wageCalculator.staticPages', [
      'ui.router',
      'wageCalculator.config'
    ]);
})();

/* global angular */
/**
 * @ngdoc overview
 * @module wageCalculator.survey
 * @description
 * # Initializes survey module
 *
 * Survey is a sub module of the application.
 *
 * @author Marius Schmidt <marius@denktmit.de>
 * @author Julian Schlarb <js@project-deadline.com>
 */
(function () {
  'use strict'; //NOSONAR

  angular
    .module('wageCalculator.survey', [
      'ui.router',
      'wageCalculator.config',
      'bootstrapLightbox'
    ]);
})();

/* global angular */
/**
 * @ngdoc overview
 * @module wageCalculator.api.models
 * @description
 * # Initializes api module
 *
 * Api.models is a sub module of the application.
 *
 * @author Marius Schmidt <marius@denktmit.de>
 * @author Julian Schlarb <js@project-deadline.com>
 */
(function () {
  'use strict'; //NOSONAR

  angular
    .module('wageCalculator.api.models', []);
})();

/* global angular */
/**
 * @ngdoc overview
 * @name wageCalculator:config
 * @description
 * # Initializes main config
 *
 * @author Julian Schlarb <js@project-deadline.com>
 */
(function () {
  'use strict'; //NOSONAR

  angular
    .module('wageCalculator')
    .config(config);

  /** @ngInject */
  function config($logProvider, toastrConfig, vcRecaptchaServiceProvider, RECAPTCHA_KEY) {
    // Enable log
    $logProvider.debugEnabled(true);

    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 3000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = true;
    toastrConfig.progressBar = true;

    // Set options for recaptcha
    vcRecaptchaServiceProvider.setDefaults({
      // @TODO must be replaced
      key: RECAPTCHA_KEY,
      theme: 'light',
      size: 'normal',
      type: 'image'
    });
  }
})();

/* global angular */
/**
 * @ngdoc overview
 * @name wageCalculator:route
 * @description
 * # Initializes main routing
 *
 * @author Marius Schmidt <marius@denktmit.de>
 * @author Julian Schlarb <js@project-deadline.com>
 */
(function () {
  'use strict'; //NOSONAR

  angular
    .module('wageCalculator')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider, $locationProvider) {
    // @TODO default route must provided

    /*
    $stateProvider
      .state('default', {
        url: '/index.html',
        templateUrl: 'app/components/calculator/controllers/finalcalculator/finalcalculator.html',
        controller: 'FinalCalculatorController',
        controllerAs: 'calculator',
        data: {
          meta: {
            'title': 'Callidus Vergütungsrechner Energie',
            'author': 'Callidus Energie GmbH',
            'og:title': 'Callidus Vergütungsrechner Energie',
            'og:description': 'Der Callidus Vergütungsrechner Energie berechnet anhand Ihrer Angaben eine Gehaltsspanne für Positionen in der Energiewirtschaft.',
            'og:type': 'website',
            'og:image': '../assets/images/facebook-image.png',
            'og:url': 'https://verguetung-energie.de/preview.html',
            'og:locale': 'de_DE'
          }
        }
      });
      */

    $urlRouterProvider.otherwise('/index.html'); //uses calculator/calculator.route.js

    $locationProvider.html5Mode(true);
  }
})();

/* global angular */
/**
 * @ngdoc overview
 * @name wageCalculator:run
 * @description
 * # Initializes main run block
 *
 * @author Julian Schlarb <js@project-deadline.com>
 */
(function () {
  'use strict'; //NOSONAR

  angular
    .module('wageCalculator')
    .run(runBlock);

  /** @ngInject */
  function runBlock($rootScope, $location, $window, ngMeta) {
    // initialise google analytics
    //$window.ga('create', 'UA-90897333-1', 'auto');

    // track pageview on state change
    //var deregistrationCallback = $rootScope.$on('$stateChangeSuccess', function () {
    //  $window.ga('send', 'pageview', $location.path());
    //});
    //$rootScope.$on('$destroy', deregistrationCallback);

    ngMeta.init();

    $rootScope.$on('$stateChangeSuccess', function() {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    });

  }
})();

/* global angular */
/**
 * @ngdoc overview
 * @name wageCalculator.config:constant
 * @description
 * # Initializes constant
 *
 * @author Julian Schlarb <js@project-deadline.com>
 */
(function () {
  'use strict'; //NOSONAR

  angular
    .module('wageCalculator.config')
    .constant('BASE_PATH', 'https://tqqq5tflra.execute-api.eu-central-1.amazonaws.com/prod')
    .constant('HOST_BASE_PATH', 'https://verguetung-energie.de')
    //.constant('RECAPTCHA_KEY', '6LffXwgUAAAAACZ1wi1t-dPvema7732nCYWIi2wa');
    //.constant('RECAPTCHA_KEY', '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI');
    .constant('RECAPTCHA_KEY', '6LffXwgUAAAAACZ1wi1t-dPvema7732nCYWIi2wa');
})();

/* global angular */
/**
 * @ngdoc function
 * @name wageCalculator.api.service:WageCalculationService
 * @description
 * # @TODO Provide docs
 *
 * @author Marius Schmidt <marius@denktmit.de>
 * @author Julian Schlarb <js@project-deadline.com>
 */
(function () {
  'use strict'; //NOSONAR

  angular.module('wageCalculator.api')
    .service('WageCalculationService', WageCalculationService);

  /** @ngInject */
  function WageCalculationService($http, CalculationResponseModel, SummaryOrderResponseModel, BASE_PATH) {

    var service = {};

    var headers = {'Content-Type': 'application/json'};

    /**
     * @ngdoc method
     * @name calculateWageForSimpleInput
     * @methodOf wageCalculator.api.service:WageCalculationService
     *
     * @description
     * @TODO Provide docs
     *
     * @returns {object}
     */
    function calculateWageForSimpleInput(simpleInput) {
      return $http.post(BASE_PATH, simpleInput, {headers: headers}).then(function (response) {
        return CalculationResponseModel.build(response.data);
      });
    }

    /**
     * @ngdoc method
     * @name calculateWageForSimpleInput
     * @methodOf wageCalculator.api.service:WageCalculationService
     *
     * @description
     * @TODO Provide docs
     *
     * @returns {object}
     */
    function calculateWage(calculatorInput) {
      var endpoint = BASE_PATH + '/calculator';
      return $http.post(endpoint, calculatorInput, {headers: headers}).then(function (response) {
        return CalculationResponseModel.build(response.data);
      });
    }

    /**
     * @ngdoc method
     * @name sendContactMessage
     * @methodOf wageCalculator.api.service:WageCalculationService
     *
     * @description
     * @TODO Provide docs
     *
     * @returns {object}
     */
    function sendContactMessage(contactMessage) {
      var endpoint = BASE_PATH + '/contactmessages';
      return $http.post(endpoint, contactMessage, {headers: headers}).then(function (response) {
        return SummaryOrderResponseModel.build(response.data);
      });
    }

    /**
     * @ngdoc method
     * @name sendSurveySummaryOrder
     * @methodOf wageCalculator.api.service:WageCalculationService
     *
     * @description
     * @TODO Provide docs
     *
     * @returns {object}
     */
    function sendSurveySummaryOrder(surveyOrder) {
      var endpoint = BASE_PATH + '/summaryorders';
      return $http.post(endpoint, surveyOrder, {headers: headers}).then(function (response) {
        return SummaryOrderResponseModel.build(response.data);
      });
    }

    /**
     * @ngdoc method
     * @name sendSurveySummaryOrder
     * @methodOf wageCalculator.api.service:WageCalculationService
     *
     * @description
     * @TODO Provide docs
     *
     * @returns {object}
     */
    function sendSurveyOrder(surveyOrder) {
      var endpoint = BASE_PATH + '/surveyorders';
      return $http.post(endpoint, surveyOrder, {headers: headers}).then(function (response) {
        return SummaryOrderResponseModel.build(response.data);
      });
    }

    service.calculateWageForSimpleInput = calculateWageForSimpleInput;
    service.sendContactMessage = sendContactMessage;
    service.sendSurveySummaryOrder = sendSurveySummaryOrder;
    service.calculateWage = calculateWage;
    service.sendSurveyOrder = sendSurveyOrder;

    return service;
  }
})();

/* global angular */
/**
 * @ngdoc overview
 * @name wageCalculator.calculator:route
 * @description
 * # Initializes routing for calculator
 *
 * @author Marius Schmidt <marius@denktmit.de>
 * @author Julian Schlarb <js@project-deadline.com>
 */
(function () {
  'use strict'; //NOSONAR

  angular
    .module('wageCalculator.calculator')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, HOST_BASE_PATH) {
    $stateProvider
      .state('finalcalculator', {
        url: '/index.html',
        templateUrl: 'app/components/calculator/controllers/finalcalculator/finalcalculator.html',
        controller: 'FinalCalculatorController',
        controllerAs: 'calculator',
        data: {
          meta: {
            'title': 'Callidus Vergütungsrechner Energie',
            'author': 'Callidus Energie GmbH',
            'og:title': 'Callidus Vergütungsrechner Energie',
            'og:description': 'Der Callidus Vergütungsrechner Energie berechnet anhand Ihrer Angaben eine Gehaltsspanne für Positionen in der Energiewirtschaft.',
            'og:type': 'website',
            'og:image': HOST_BASE_PATH + '/assets/images/facebook-image.png',
            'og:image:width': '536',
            'og:image:height': '366',
            'og:url': HOST_BASE_PATH + '/index.html',
            'og:locale': 'de_DE'
          }
        }
      });
  }
})();

/* global angular */
/**
 * @ngdoc overview
 * @name wageCalculator.contact:route
 * @description
 * # Initializes routing for contact
 *
 * @author Marius Schmidt <marius@denktmit.de>
 * @author Julian Schlarb <js@project-deadline.com>
 */
(function () {
  'use strict'; //NOSONAR

  angular
    .module('wageCalculator.contact')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, HOST_BASE_PATH) {
    $stateProvider
      .state('contact', {
        url: '/kontakt.html?contactReason',
        params: {
          contactReason: {
            value: 'Sonstiges',
            squash: false
          }
        },
        templateUrl: 'app/components/contact/controllers/contact/contact.html',
        controller: 'ContactController',
        controllerAs: 'contact',
        data: {
          meta: {
            'title': 'Callidus Vergütungsrechner Energie | Kontaktformular',
            'author': 'Callidus Energie GmbH',
            'og:title': 'Callidus Vergütungsrechner Energie | Kontaktformular',
            'og:description': 'Kontaktieren Sie das Team hinter dem Callidus Vergütungsrechner Energie',
            'og:type': 'website',
            'og:image': HOST_BASE_PATH + '/assets/images/facebook-image.png',
            'og:image:width': '536',
            'og:image:height': '366',
            'og:url': HOST_BASE_PATH + '/kontakt.html',
            'og:locale': 'de_DE'
          }
        }
      })
  }
})();

/* global angular */
/**
 * @ngdoc overview
 * @name wageCalculator.staticPages:route
 * @description
 * # Initializes routing for static pages
 *
 * @author Marius Schmidt <marius@denktmit.de>
 * @author Julian Schlarb <js@project-deadline.com>
 */
(function () {
  'use strict'; //NOSONAR

  angular
    .module('wageCalculator.staticPages')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, HOST_BASE_PATH) {
    $stateProvider
      .state('faq', {
        url: '/haeufige_frage.html',
        templateUrl: 'app/components/static/view/faq.html',
        data: {
          meta: {
            'title': 'Callidus Vergütungsrechner Energie | Häufige Fragen',
            'author': 'Callidus Energie GmbH',
            'og:title': 'Callidus Vergütungsrechner Energie',
            'og:description': 'Häufige Fragen zum Callidus Vergütungsrechner Energie',
            'og:type': 'website',
            'og:image': HOST_BASE_PATH + '/assets/images/facebook-image.png',
            'og:image:width': '536',
            'og:image:height': '366',
            'og:url': HOST_BASE_PATH + '/haeufige_frage.html',
            'og:locale': 'de_DE'
          }
        }
      })
      .state('terms_and_conditions', {
        url: '/allgemeine_geschaeftsbedingungen.html',
        templateUrl: 'app/components/static/view/terms_and_conditions.html',
        data: {
          meta: {
            'title': 'Callidus Vergütungsrechner Energie | Allgemeine Geschäftsbedingungen',
            'author': 'Callidus Energie GmbH',
            'og:title': 'Callidus Vergütungsrechner Energie | Allgemeine Geschäftsbedingungen',
            'og:description': 'Allgemeine Geschäftsbedingungen (AGB) zum Callidus Vergütungsrechner Energie',
            'og:type': 'website',
            'og:image': HOST_BASE_PATH + '/assets/images/facebook-image.png',
            'og:image:width': '536',
            'og:image:height': '366',
            'og:url': HOST_BASE_PATH + '/allgemeine_geschaeftsbedingungen.html',
            'og:locale': 'de_DE'
          }
        }
      })
      .state('legal_information', {
        url: '/impressum.html',
        templateUrl: 'app/components/static/view/legal_information.html',
        data: {
          meta: {
            'title': 'Callidus Vergütungsrechner Energie | Rechtliche Informationen und Impressum',
            'author': 'Callidus Energie GmbH',
            'og:title': 'Callidus Vergütungsrechner Energie | Rechtliche Informationen und Impressum',
            'og:description': 'Rechtliche Informationen und Impressum zum Callidus Vergütungsrechner Energie',
            'og:type': 'website',
            'og:image': HOST_BASE_PATH + '/assets/images/facebook-image.png',
            'og:image:width': '536',
            'og:image:height': '366',
            'og:url': HOST_BASE_PATH + '/impressum.html',
            'og:locale': 'de_DE'
          }
        }
      })
      .state('data_privacy', {
        url: '/datenschutzerklaerung.html',
        templateUrl: 'app/components/static/view/data_privacy.html',
        data: {
          meta: {
            'title': 'Callidus Vergütungsrechner Energie | Datenschutzerklärung',
            'author': 'Callidus Energie GmbH',
            'og:title': 'Callidus Vergütungsrechner Energie | Datenschutzerklärung',
            'og:description': 'Die Datenschutzerklärung zum Callidus Vergütungsrechner Energie',
            'og:type': 'website',
            'og:image': HOST_BASE_PATH + '/assets/images/facebook-image.png',
            'og:image:width': '536',
            'og:image:height': '366',
            'og:url': HOST_BASE_PATH + '/datenschutzerklaerung.html',
            'og:locale': 'de_DE'
          }
        }
      })
      .state('interview_dahlke', {
        url: '/interview_dahlke.html',
        templateUrl: 'app/components/static/view/interview_dahlke.html',
        data: {
          meta: {
            'title': 'Callidus Vergütungsrechner Energie 2016/2017 | Interview mit Dr. Kay Dahlke, UKA Meissen',
            'author': 'Callidus Energie GmbH',
            'og:title': 'Callidus Vergütungsrechner Energie 2016/2017 | Interview mit Dr. Kay Dahlke, UKA Meissen',
            'og:description': 'Interview mit Dr. Kay Dahlke, Geschäftsführer bei der UKA Meißen. Geführt im Rahmen der Callidus Vergütungsstudie Energie 2016/2017',
            'og:type': 'website',
            'og:image': HOST_BASE_PATH + '/assets/images/facebook-image.png',
            'og:image:width': '536',
            'og:image:height': '366',
            'og:url': HOST_BASE_PATH + '/interview_dahlke.html',
            'og:locale': 'de_DE'
          }
        }
      })
      .state('interview_graefrath', {
        url: '/interview_graefrath.html',
        templateUrl: 'app/components/static/view/interview_graefrath.html',
        data: {
          meta: {
            'title': 'Callidus Vergütungsrechner Energie 2016/2017 | Interview mit Norbert Graefrath, Arbeitsdirektor Rheinenergie AG',
            'author': 'Callidus Energie GmbH',
            'og:title': 'Callidus Vergütungsrechner Energie 2016/2017 | Interview mit Norbert Graefrath, Arbeitsdirektor Rheinenergie AG',
            'og:description': 'Interview mit Norbert Graefrath, Arbeitsdirektor bei der Rheinenergie AG. Geführt im Rahmen der Callidus Vergütungsstudie Energie 2016/2017',
            'og:type': 'website',
            'og:image': HOST_BASE_PATH + '/assets/images/facebook-image.png',
            'og:image:width': '536',
            'og:image:height': '366',
            'og:url': HOST_BASE_PATH + '/interview_graefrath.html',
            'og:locale': 'de_DE'
          }
        }
      })
      .state('interview_heim', {
        url: '/interview_heim.html',
        templateUrl: 'app/components/static/view/interview_heim.html',
        data: {
          meta: {
            'title': 'Callidus Vergütungsrechner Energie 2016/2017 | Interview mit Heike Heim, Vorstandsvorsitzende EVO AG Offenbach',
            'author': 'Callidus Energie GmbH',
            'og:title': 'Callidus Vergütungsrechner Energie 2016/2017 | Interview mit Heike Heim, Vorstandsvorsitzende EVO AG Offenbach',
            'og:description': 'Interview mit Heike Heim, Vorstandsvorsitzende der EVO AG Offenbach. Geführt im Rahmen der Callidus Vergütungsstudie Energie 2016/2017',
            'og:type': 'website',
            'og:image': HOST_BASE_PATH + '/assets/images/facebook-image.png',
            'og:image:width': '536',
            'og:image:height': '366',
            'og:url': HOST_BASE_PATH + '/interview_heim.html',
            'og:locale': 'de_DE'
          }
        }
      })
      .state('interview_ruecker', {
        url: '/interview_ruecker.html',
        templateUrl: 'app/components/static/view/interview_ruecker.html',
        data: {
          meta: {
            'title': 'Callidus Vergütungsrechner Energie 2016/2017 | Interview mit Jan Rücker, Betriebsratsvorsitzender Avacon AG',
            'author': 'Callidus Energie GmbH',
            'og:title': 'Callidus Vergütungsrechner Energie 2016/2017 | Interview mit Jan Rücker, Betriebsratsvorsitzender Avacon AG',
            'og:description': 'Jan Rücker, Betriebsratsvorsitzender der Avacon AG. Geführt im Rahmen der Callidus Vergütungsstudie Energie 2016/2017',
            'og:type': 'website',
            'og:image': HOST_BASE_PATH + '/assets/images/facebook-image.png',
            'og:image:width': '536',
            'og:image:height': '366',
            'og:url': HOST_BASE_PATH + '/interview_ruecker.html',
            'og:locale': 'de_DE'
          }
        }
      })
  }
})();

/* global angular */
/**
 * @ngdoc overview
 * @name wageCalculator.survey:route
 * @description
 * # Initializes routing for survey
 *
 * @author Marius Schmidt <marius@denktmit.de>
 * @author Julian Schlarb <js@project-deadline.com>
 */
(function () {
  'use strict'; //NOSONAR

  angular
    .module('wageCalculator.survey')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, HOST_BASE_PATH) {
    $stateProvider
      .state('survey', {
        url: '/studie.html',
        templateUrl: 'app/components/survey/view/survey.html',
        controller: 'SurveyController',
        controllerAs: 'survey',
        data: {
          meta: {
            'title': 'Callidus Vergütungsrechner Energie 2016/2017 | Die Vergütungsstudiue',
            'author': 'Callidus Energie GmbH',
            'og:title': 'Callidus Vergütungsrechner Energie 2016/2017 | Die Vergütungsstudie',
            'og:description': 'Hier finden Sie weiterführende Informationen zur Methodik der Callidus Vergütungsstudie Energie 2016/2017',
            'og:type': 'website',
            'og:image': HOST_BASE_PATH + '/assets/images/facebook-image.png',
            'og:image:width': '536',
            'og:image:height': '366',
            'og:url': HOST_BASE_PATH + '/studie.html',
            'og:locale': 'de_DE'
          }
        }
      })
      .state('surveySummaryorder', {
        url: '/bestellung_zusammenfassung.html',
        templateUrl: 'app/components/survey/controllers/summary/summaryorder.html',
        controller: 'SummaryOrderController',
        controllerAs: 'summaryOrder',
        data: {
          meta: {
            'title': 'Callidus Vergütungsrechner Energie 2016/2017 | Bestellung der Zusammenfassung',
            'author': 'Callidus Energie GmbH',
            'og:title': 'Callidus Vergütungsrechner Energie 2016/2017 | Bestellung der Zusammenfassung',
            'og:description': 'Bestellen Sie hier ein PDF mit der Zusammenfassung der Callidus Vergütungsstudie Energie 2016/2017',
            'og:type': 'website',
            'og:image': HOST_BASE_PATH + '/assets/images/facebook-image.png',
            'og:image:width': '536',
            'og:image:height': '366',
            'og:url': HOST_BASE_PATH + '/bestellung_zusammenfassung.html',
            'og:locale': 'de_DE'
          }
        }
      })
      .state('surveySurveyOrder', {
        url: '/bestellung_printstudie.html',
        templateUrl: 'app/components/survey/controllers/survey/surveyorder.html',
        controller: 'SurveyOrderController',
        controllerAs: 'surveyOrder',
        data: {
          meta: {
            'title': 'Callidus Vergütungsrechner Energie 2016/2017 | Bestellung der Printstudie',
            'author': 'Callidus Energie GmbH',
            'og:title': 'Callidus Vergütungsrechner Energie 2016/2017 | Bestellung der Printstudie',
            'og:description': 'Bestellen Sie hier ein Printexemplar der Callidus Vergütungsstudie Energie 2016/2017',
            'og:type': 'website',
            'og:image': HOST_BASE_PATH + '/assets/images/facebook-image.png',
            'og:image:width': '536',
            'og:image:height': '366',
            'og:url': HOST_BASE_PATH + '/bestellung_printstudie.html',
            'og:locale': 'de_DE'
          }
        }
      });
  }
})();

/* global angular */
/**
 * @ngdoc function
 * @name wageCalculator.directive:footer
 * @description
 * # the directive for injection footer into the main template
 *
 * @author Julian Schlarb <js@project-deadline.com>
 */
(function () {
  'use strict'; //NOSONAR

  angular.module('wageCalculator')
    .directive('footer', footer);

  /** @ngInject */
  function footer() {
    return {
      templateUrl: 'app/shared/footer/footer.html',
      restrict: 'E'
    };
  }
})();

/* global angular */
/**
 * @ngdoc function
 * @name gRecaptcha
 * @description
 * # Provides Google Recaptcha as part of schemaForm input element
 *
 * @author Julian Schlarb <js@project-deadline.com>
 */
(function () {
  'use strict'; //NOSONAR

  //noinspection JSAnnotator
  angular.module('schemaForm')
    .config(schemaFormConfig);

  /** @ngInject */
  function schemaFormConfig(schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
    var gRecaptcha = function (name, schema, options) {

      if (schema.type === 'string' && schema.format === 'gRecaptcha') {
        // Initiate a form provider
        var f = schemaFormProvider.stdFormObj(name, schema, options);
        f.key = options.path;
        f.type = 'gRecaptcha';
        // Add it to the lookup dict (for internal use)
        options.lookup[sfPathProvider.stringify(options.path)] = f;
        return f;
      }
    };

    schemaFormProvider.defaults.string.unshift(gRecaptcha);

    schemaFormDecoratorsProvider.addMapping('bootstrapDecorator', 'gRecaptcha',
      'app/shared/schemaFormGRecaptchaInput/gRecaptcha.html');
  }
})();

/* global angular */
/**
 * @ngdoc function
 * @name wageCalculator.directive:navBar
 * @description
 * # the directive for injection header into the main template
 *
 * @author Julian Schlarb <js@project-deadline.com>
 */
(function () {
  'use strict'; //NOSONAR

  angular.module('wageCalculator')
    .directive('navBar', navBar);

  /** @ngInject */
  function navBar() {
    return {
      templateUrl: 'app/shared/navBar/navBar.html',
      restrict: 'E',
      controller: NavBarController,
      controllerAs: 'navBar'
    };
  }

  /** @ngInject */
  function NavBarController($rootScope) {
    var vm = this;

    vm.isNavbarOpen = false;

    /**
     * Will toggle the navbar
     */
    vm.toggleNavbar = function () {
      vm.isNavbarOpen = !vm.isNavbarOpen;
    };

    // ensure menu is closed on state change
    var deregistrationCallback = $rootScope.$on('$stateChangeStart', function () {
      if (vm.isNavbarOpen) {
        vm.isNavbarOpen = false;
      }
    });
    $rootScope.$on('$destroy', deregistrationCallback);
  }
})();

/* global tv4, angular */
/**
 * @ngdoc controller
 * @name wageCalculator.api.models.factory:AddressModel
 * @description
 * # @TODO provide some docs
 *
 * @author Marius Schmidt <marius@denktmit.de>
 * @author Julian Schlarb <js@project-deadline.com>
 */
(function () {
  'use strict'; //NOSONAR

  angular.module('wageCalculator.api.models')
    .factory('AddressModel', AddressModelFactory);

  function AddressModelFactory() {
    function AddressModel(companyName, salutation, firstName, lastName, streetAndHouseNumberOrPostbox, zipCode, city, country) {
      this.companyName = companyName;
      this.salutation = salutation;
      this.firstName = firstName;
      this.lastName = lastName;
      this.streetAndHouseNumberOrPostbox = streetAndHouseNumberOrPostbox;
      this.zipCode = zipCode;
      this.city = city;
      this.country = country;
    }

    AddressModel.schema = {
      "$schema": "http://json-schema.org/draft-04/schema#",
      "type": "object",
      "properties": {
        "salutation": {
          "type": "string",
          "enum": [
            "Herr",
            "Frau",
            "Herr Prof.",
            "Herr Dr.",
            "Frau Prof.",
            "Frau Dr."
          ]
        },
        "companyName": {
          "type": "string"
        },
        "firstName": {
          "type": "string"
        },
        "lastName": {
          "type": "string"
        },
        "streetAndHouseNumberOrPostbox": {
          "type": "string"
        },
        "zipCode": {
          "type": "string"
        },
        "city": {
          "type": "string"
        },
        "country": {
          "type": "string"
        }
      },
      "required": [
        "salutation",
        "firstName",
        "lastName",
        "streetAndHouseNumberOrPostbox",
        "zipCode",
        "city",
        "country"
      ]
    };

    AddressModel.prototype.validate = function () {
      return tv4.validateResult(self, AddressModel.schema);
    };

    AddressModel.build = function (data) {
      return new AddressModel(
        data.companyName,
        data.salutation,
        data.firstName,
        data.lastName,
        data.streetAndHouseNumberOrPostbox,
        data.zipCode,
        data.city,
        data.country);
    };

    return AddressModel;
  }
})();


/* global tv4, angular */
/**
 * @ngdoc controller
 * @name wageCalculator.api.models.factory:CalculationResponseModel
 * @description
 * # @TODO provide some docs
 *
 * @author Marius Schmidt <marius@denktmit.de>
 * @author Julian Schlarb <js@project-deadline.com>
 */
(function () {
  'use strict'; //NOSONAR
  angular.module('wageCalculator.api.models')
    .factory('CalculationResponseModel', CalculationResponseModelFactory);

  function CalculationResponseModelFactory() {

    function CalculationResponseModel(amount, scaledAmount, currency, formatted) {
      this.amount = amount;
      this.scaledAmount = scaledAmount;
      this.currency = currency;
      this.formatted = formatted;
    }

    CalculationResponseModel.prototype.validate = function () {
      var schema = {
        "$schema": "http://json-schema.org/draft-04/schema#",
        "type": "object",
        "properties": {
          "amount": {
            "type": "number"
          },
          "scaledAmount": {
            "type": "integer"
          },
          "currency": {
            "type": "string",
            "enum": [
              "EUR"
            ]
          },
          "formatted": {
            "type": "string"
          }
        },
        "required": [
          "amount",
          "scaledAmount",
          "currency",
          "formatted"
        ]
      };
      return tv4.validateResult(this, schema);
    };

    CalculationResponseModel.prototype.annual = function () {
      return this.scaledAmount * 12;
    };

    CalculationResponseModel.build = function (data) {
      return new CalculationResponseModel(data.amount, data.scaledAmount, data.currency, data.formatted);
    };

    return CalculationResponseModel;
  }
})();

/* global angular */
/**
 * @ngdoc controller
 * @name wageCalculator.api.models.factory:CalculatorInputModel
 * @description
 * # @TODO provide some docs
 *
 * @author Marius Schmidt <marius@denktmit.de>
 * @author Julian Schlarb <js@project-deadline.com>
 */
(function () {
  'use strict'; //NOSONAR
  angular.module('wageCalculator.api.models')
    .factory('CalculatorInputModel', CalculatorInputModelFactory);

  function CalculatorInputModelFactory() {
    function CalculatorInputModel(gender,
                                  workExperienceInYears,
                                  educationLevel,
                                  countOfCompanyEmployees,
                                  companyCategory,
                                  region,
                                  hierarchyLevel,
                                  myStaffSize,
                                  areaManagerScope,
                                  departmentManagerScope,
                                  individualScope) {
      this.gender = gender;
      this.workExperienceInYears = workExperienceInYears;
      this.educationLevel = educationLevel;
      this.companyCategory = companyCategory;
      this.countOfCompanyEmployees = countOfCompanyEmployees;
      this.region = region;
      this.hierarchyLevel = hierarchyLevel;
      this.myStaffSize = myStaffSize;
      this.areaManagerScope = areaManagerScope;
      this.departmentManagerScope = departmentManagerScope;
      this.individualScope = individualScope;
    }

    CalculatorInputModel.prototype.validate = function () {
      var schema = {
          "$schema": "http://json-schema.org/draft-04/schema#",
          "title": "Calculator Input",
          "type": "object",
          "additionalProperties": false,
          "properties": {
            "workExperienceInYears": {
              "type": "integer"
            },
            "countOfCompanyEmployees": {
              "type": "integer"
            },
            "myStaffSize": {
              "type": "integer"
            },
            "companyCategory": {
              "type": "string",
              "enum": [
                "BILLING_SERVICE_PROVIDER",
                "PLANT_ENGINEERING",
                "ASSET_MANAGER_OR_FINANCIAL_INVESTOR",
                "CONTRACTOR_OR_ENERGY_EFFICIENCY_CONSULTANTS",
                "ENERGY_TRADING_AND_DIRECT_MARKETING",
                "ENERGY_COMPANY_OR_SUBSIDIARY",
                "MANUFACTURER_OF_ENERGY_INSTALLATIONS",
                "ENGINEERING_COMPANY",
                "NETWORK_OPERATOR",
                "PUBLIC_SERVICE",
                "PUBLIC_UTILITY",
                "PROJECT_PLANNER_OR_PLANT_OPERATOR_RENEWABLE_ENERGY",
                "PUBLIC_UTILITY_COOPERATION",
                "SYSTEM_HOUSE_OR_IT_CONSULTANCY",
                "UNIVERSITY_OR_RESEARCH",
                "COMPANY_OUTSIDE_ENERGY_ECONOMY",
                "BUSINESS_CONSULTANCY",
                "ASSOCIATION",
                "SALES_COMPANY",
                "OTHER"
              ]
            },
            "hierarchyLevel": {
              "type": "string",
              "enum": [
                "CEO_OR_CHAIRMAN",
                "AREA_MANAGER",
                "DEPARTMENT_MANAGER",
                "TEAM_LEADER",
                "SPECIALIST",
                "FOREMAN",
                "CASE_WORKER",
                "TECHNICIAN",
                "WORKER"
              ]
            },
            "educationLevel": {
              "type": "string",
              "enum": [
                "DOCTORATE",
                "UNIVERSITY_MASTER",
                "UNIVERSITY_BACHELOR",
                "POLYTECHNIC_MASTER",
                "POLYTECHNIC_BACHELOR",
                "EDUCATION_TECHNICAL",
                "EDUCATION_FOREMAN",
                "COMPLETED_VOCATIONAL_TRAINING",
                "OTHER"
              ]
            },
            "gender": {
              "type": "string",
              "enum": [
                "MALE",
                "FEMALE"
              ]
            },
            "region": {
              "type": "string",
              "enum": [
                "BW_FREIBURG",
                "BW_KARLSRUHE",
                "BW_MANNHEIM",
                "BW_STUTTGART",
                "BW_GENERAL",
                "BY_AUGSBURG",
                "BY_REGENSBURG",
                "BY_MUNICH",
                "BY_NUREMBERG_ERLANGEN_FUERTH",
                "BY_WUERZBURG",
                "BY_GENERAL",
                "BE",
                "BB_POTSDAM",
                "BB_GENERAL",
                "HB",
                "HH",
                "HE_CENTRALEAST_KASSEL",
                "HE_RHINE_MAIN",
                "HE_GENERAL",
                "MV_GENERAL",
                "NI_BRAUNSCHWEIG_HANNOVER",
                "NI_OLDENBURG_OSNABRUECK",
                "NI_GENERAL",
                "NRW_BERGISCHES_STAEDTEDREIECK",
                "NRW_METROPOLE_RUHR",
                "NRW_REGION_AACHEN",
                "NRW_REGION_DUESSELDORF",
                "NRW_REGION_COLOGNE",
                "NRW_REGION_NIEDERRHINE",
                "NRW_REGION_OSTWESTFALIA",
                "NRW_REGION_SOUTHWESTFALIA",
                "NRW_GENERAL",
                "RP_MAINZ",
                "RP_LUDWIGSHAFEN",
                "RP_GENERAL",
                "SL_REGION_SAARBRUECKEN",
                "SN_REGION_DRESDEN",
                "SN_LEIPZIG_CHEMNITZ",
                "SN_GENERAL",
                "ST_GENERAL",
                "SH_REGION_KIEL",
                "SH_GENERAL",
                "TH_REGION_ERFURT",
                "TH_GENERAL"
              ]
            },
            "areaManagerScope": {
              "type": "string",
              "enum": [
                "HL2_01",
                "HL2_02",
                "HL2_03",
                "HL2_04",
                "HL2_05",
                "HL2_06",
                "HL2_07",
                "HL2_08",
                "HL2_09",
                "HL2_10",
                "HL2_11",
                "HL2_12",
                "HL2_13",
                "HL2_14",
                "HL2_15",
                "HL2_16",
                "HL2_17",
                "HL2_18",
                "HL2_19",
                "HL2_20"
              ]
            },
            "departmentManagerScope": {
              "type": "string",
              "enum": [
                "HL3_01",
                "HL3_02",
                "HL3_03",
                "HL3_04",
                "HL3_05",
                "HL3_06",
                "HL3_07",
                "HL3_08",
                "HL3_09",
                "HL3_10",
                "HL3_11",
                "HL3_12",
                "HL3_13",
                "HL3_14",
                "HL3_15",
                "HL3_16",
                "HL3_17",
                "HL3_18",
                "HL3_19",
                "HL3_20",
                "HL3_21",
                "HL3_22",
                "HL3_23",
                "HL3_24",
                "HL3_25",
                "HL3_26",
                "HL3_27",
                "HL3_28",
                "HL3_29",
                "HL3_30",
                "HL3_31",
                "HL3_32",
                "HL3_33",
                "HL3_34",
                "HL3_35",
                "HL3_36",
                "HL3_37",
                "HL3_38",
                "HL3_39",
                "HL3_40",
                "HL3_41",
                "HL3_42",
                "HL3_43",
                "HL3_44",
                "HL3_45",
                "HL3_46",
                "HL3_47",
                "HL3_48",
                "HL3_49",
                "HL3_50",
                "HL3_51",
                "HL3_52",
                "HL3_53",
                "HL3_54",
                "HL3_55",
                "HL3_56",
                "HL3_57",
                "HL3_58",
                "HL3_59",
                "HL3_60",
                "HL3_61",
                "HL3_62",
                "HL3_63",
                "HL3_64",
                "HL3_65",
                "HL3_66",
                "HL3_67",
                "HL3_68",
                "HL3_69",
                "HL3_70",
                "HL3_71",
                "HL3_72",
                "HL3_73",
                "HL3_74"
              ]
            },
            "individualScope": {
              "type": "string",
              "enum": [
                "HL4_01",
                "HL4_02",
                "HL4_03",
                "HL4_04",
                "HL4_05",
                "HL4_06",
                "HL4_07",
                "HL4_08",
                "HL4_09",
                "HL4_10",
                "HL4_11",
                "HL4_12",
                "HL4_13",
                "HL4_14",
                "HL4_15",
                "HL4_16",
                "HL4_17",
                "HL4_18",
                "HL4_19",
                "HL4_20",
                "HL4_21",
                "HL4_22",
                "HL4_23",
                "HL4_24",
                "HL4_25",
                "HL4_26",
                "HL4_27",
                "HL4_28",
                "HL4_29",
                "HL4_30",
                "HL4_31",
                "HL4_32",
                "HL4_33",
                "HL4_34",
                "HL4_35",
                "HL4_36",
                "HL4_37",
                "HL4_38",
                "HL4_39",
                "HL4_40",
                "HL4_41",
                "HL4_42",
                "HL4_43",
                "HL4_44",
                "HL4_45",
                "HL4_46",
                "HL4_47",
                "HL4_48",
                "HL4_49",
                "HL4_50",
                "HL4_51",
                "HL4_52",
                "HL4_53",
                "HL4_54",
                "HL4_55",
                "HL4_56",
                "HL4_57",
                "HL4_58",
                "HL4_59",
                "HL4_60"
              ]
            }
          },
          "required": [
            "workExperienceInYears",
            "countOfCompanyEmployees",
            "myStaffSize",
            "companyCategory",
            "hierarchyLevel",
            "educationLevel",
            "gender",
            "region"
          ]
        };
      // Independent validations
      var result = {errors: [], valid : true};
      if (!this.gender || !contains(schema.properties.gender.enum, this.gender)) {
        result.errors.push("gender");
        result.valid = false;
      }
      if (this.workExperienceInYears < 0 || this.workExperienceInYears > 45) {
        result.errors.push("workExperienceInYears");
        result.valid = false;
      }
      if (!this.educationLevel || !contains(schema.properties.educationLevel.enum, this.educationLevel)) {
        result.errors.push("educationLevel");
        result.valid = false;
      }
      if (!this.companyCategory || !contains(schema.properties.companyCategory.enum, this.companyCategory)) {
        result.errors.push("companyCategory");
        result.valid = false;
      }
      if (!this.countOfCompanyEmployees || this.countOfCompanyEmployees < 1 || this.countOfCompanyEmployees > 200000) {
        result.errors.push("countOfCompanyEmployees");
        result.valid = false;
      }
      if (!this.region || !contains(schema.properties.region.enum, this.region)) {
        result.errors.push("region");
        result.valid = false;
      }
      if (!this.hierarchyLevel || !contains(schema.properties.hierarchyLevel.enum, this.hierarchyLevel)) {
        result.errors.push("hierarchyLevel");
        result.valid = false;
      }
      // Dependent validations CEO
      if (this.hierarchyLevel == "CEO_OR_CHAIRMAN") {
        if (!this.myStaffSize || this.myStaffSize < 1 || this.myStaffSize > 1000) {
          result.errors.push("myStaffSize");
          result.valid = false;
        }
      }
      // Dependent validations area manager
      else if (this.hierarchyLevel == "AREA_MANAGER") {
        if (!this.myStaffSize || this.myStaffSize < 1 || this.myStaffSize > 1000) {
          result.errors.push("myStaffSize");
          result.valid = false;
        }
        if (!this.areaManagerScope || !contains(schema.properties.areaManagerScope.enum, this.areaManagerScope)) {
          result.errors.push("areaManagerScope");
          result.valid = false;
        }
      }
      // Dependent validations department manager / team leader
      else if (this.hierarchyLevel == "DEPARTMENT_MANAGER" || this.hierarchyLevel == "TEAM_LEADER") {
        if (!this.myStaffSize || this.myStaffSize < 1 || this.myStaffSize > 1000) {
          result.errors.push("myStaffSize");
          result.valid = false;
        }
        if (!this.departmentManagerScope || !contains(schema.properties.departmentManagerScope.enum, this.departmentManagerScope)) {
          result.errors.push("departmentManagerScope");
          result.valid = false;
        }
        // Dependent validations others
      } else {
        if (!this.individualScope || !contains(schema.properties.individualScope.enum, this.individualScope)) {
          result.errors.push("individualScope");
          result.valid = false;
        }
      }
      return result;
    };

    function contains(list, needle) {
      if(list.indexOf(needle) === -1) {
        return false;
      }
      return true;
    }

    CalculatorInputModel.build = function (data) {
      var gender = data.gender;
      var workExperienceInYears = parseInt(data.workExperienceInYears);
      var educationLevel = data.educationLevel;
      var countOfCompanyEmployees = parseInt(data.countOfCompanyEmployees);
      var companyCategory = data.companyCategory;
      var region = data.region;
      var hierarchyLevel = data.hierarchyLevel;
      var myStaffSize = parseInt(data.myStaffSize);
      var areaManagerScope = data.areaManagerScope;
      var departmentManagerScope = data.departmentManagerScope;
      var individualScope = data.individualScope;

      if (hierarchyLevel == "CEO_OR_CHAIRMAN") {
        areaManagerScope = null;
        departmentManagerScope = null;
        individualScope = null;
      }
      else if (hierarchyLevel == "AREA_MANAGER") {
        departmentManagerScope = null;
        individualScope = null;
      }
      else if (hierarchyLevel == "DEPARTMENT_MANAGER" || hierarchyLevel == "TEAM_LEADER") {
        areaManagerScope = null;
        individualScope = null;
      } else {
        areaManagerScope = null;
        departmentManagerScope = null;
        myStaffSize = 0;
      }

      return new CalculatorInputModel(
        gender,
        workExperienceInYears,
        educationLevel,
        countOfCompanyEmployees,
        companyCategory,
        region,
        hierarchyLevel,
        myStaffSize,
        areaManagerScope,
        departmentManagerScope,
        individualScope);
    };

    return CalculatorInputModel;
  }
})();

/* global tv4, angular */
/**
 * @ngdoc controller
 * @name wageCalculator.api.models.factory:ContactMessageModel
 * @description
 * # @TODO provide some docs
 *
 * @author Marius Schmidt <marius@denktmit.de>
 * @author Julian Schlarb <js@project-deadline.com>
 */
(function () {
  'use strict'; //NOSONAR
  angular.module('wageCalculator.api.models')
    .factory('ContactMessageModel', ContactMessageModelFactory);

  function ContactMessageModelFactory() {
    function ContactMessageModel(salutation,
                                 firstName,
                                 lastName,
                                 email,
                                 companyName,
                                 currentPosition,
                                 phone,
                                 acceptedTermsAndConditions,
                                 acceptedPrivacyPolicy,
                                 acceptedNewsletter,
                                 contactReason,
                                 message,
                                 gRecaptchaResponse) {
      this.salutation = salutation;
      this.firstName = firstName;
      this.lastName = lastName;
      this.email = email;
      this.companyName = companyName;
      this.currentPosition = currentPosition;
      this.phone = phone;
      this.acceptedTermsAndConditions = acceptedTermsAndConditions;
      this.acceptedPrivacyPolicy = acceptedPrivacyPolicy;
      this.acceptedNewsletter = acceptedNewsletter;
      this.contactReason = contactReason;
      this.message = message;
      this["g-recaptcha-response"] = gRecaptchaResponse;
    }

    ContactMessageModel.schema = {
      "$schema": "http://json-schema.org/draft-04/schema#",
      "type": "object",
      "properties": {
        "email": {
          "type": "string",
          "pattern": "^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\\.[a-zA-Z0-9-]{2,6})$",
          "validationMessage": "Das E-Mail-Adressformat ist nicht korrekt"
        },
        "salutation": {
          "type": "string",
          "enum": [
            "Herr",
            "Frau",
            "Herr Prof.",
            "Herr Dr.",
            "Frau Prof.",
            "Frau Dr."
          ]
        },
        "firstName": {
          "type": "string"
        },
        "lastName": {
          "type": "string"
        },
        "companyName": {
          "type": "string"
        },
        "currentPosition": {
          "type": "string"
        },
        "phone": {
          "type": "string"
        },
        "acceptedTermsAndConditions": {
          "type": "boolean"
        },
        "acceptedPrivacyPolicy": {
          "type": "boolean"
        },
        "acceptedNewsletter": {
          "type": "boolean"
        },
        "contactReason": {
          "type": "string",
          "enum": [
            "Anmeldung Gehaltsstudie",
            "Anmeldung Analyse Arbeitsmarkt Energie",
            "Feedback geben",
            "Vergütungsbenchmark",
            "Rückfragen Studie oder Bestellung",
            "Sonstiges"
          ]
        },
        "message": {
          "type": "string"
        },
        "g-recaptcha-response": {
          "type": "string",
          "format": "gRecaptcha"
        }
      },
      "required": [
        "email",
        "salutation",
        "firstName",
        "lastName",
        "contactReason",
        "message",
        "acceptedTermsAndConditions",
        "acceptedPrivacyPolicy",
        "g-recaptcha-response"
      ]
    };

    ContactMessageModel.form = [
      {
        "type": "fieldset",
        "title": "Ihre Kontaktinformation",
        items: [
          {
            "key": "email",
            "title": "Ihre E-Mail-Adresse*",
            "htmlClass": "row",
            "labelHtmlClass": "col-lg-3",
            "fieldHtmlClass": "col-lg-9"
          },
          {
            "key": "salutation",
            "title": "Anrede*",
            validationMessage: {302: "&nbsp;Pflichtfeld"},
            "htmlClass": "row",
            "labelHtmlClass": "col-lg-3",
            "fieldHtmlClass": "col-lg-9"
          },
          {
            "key": "firstName",
            "title": "Vorname*",
            validationMessage: {302: "&nbsp;Pflichtfeld"},
            "htmlClass": "row",
            "labelHtmlClass": "col-lg-3",
            "fieldHtmlClass": "col-lg-9"
          },
          {
            "key": "lastName",
            "title": "Nachname*",
            validationMessage: {302: "&nbsp;Pflichtfeld"},
            "htmlClass": "row",
            "labelHtmlClass": "col-lg-3",
            "fieldHtmlClass": "col-lg-9"
          },
          {
            "key": "companyName",
            "title": "Ihre derzeitiger Arbeitgeber",
            "htmlClass": "row",
            "labelHtmlClass": "col-lg-3",
            "fieldHtmlClass": "col-lg-9"
          },
          {
            "key": "currentPosition",
            "title": "Ihre derzeitige Position",
            "htmlClass": "row",
            "labelHtmlClass": "col-lg-3",
            "fieldHtmlClass": "col-lg-9"
          },
          {
            "key": "phone",
            "title": "Ihre Telefonnummer",
            "htmlClass": "row",
            "labelHtmlClass": "col-lg-3",
            "fieldHtmlClass": "col-lg-9"
          }
        ]
      },
      {
        "type": "fieldset",
        "title": "Ihre Nachricht an uns",
        items: [
          {
            "key": "contactReason",
            "title": "Grund der Kontaktaufnahme*",
            validationMessage: {302: "&nbsp;Pflichtfeld"},
            "htmlClass": "row",
            "labelHtmlClass": "col-lg-3",
            "fieldHtmlClass": "col-lg-9"
          },
          {
            "key": "message",
            "type": "textarea",
            "title": "Ihre Nachricht an uns*",
            validationMessage: {302: "&nbsp;Pflichtfeld"},
            "htmlClass": "row",
            "labelHtmlClass": "col-lg-3",
            "fieldHtmlClass": "col-lg-9"
          }
        ]
      },
      {
        "type": "fieldset",
        "title": "Nutzungsbedingungen",
        items: [
          {
            "key": "acceptedTermsAndConditions",
            "title": "&nbsp;Ich akzeptiere die <a href='/#/allgemeine_geschaeftsbedingungen.html' target='_blank'>AGB und Nutzungsbedingungen</a>*",
            validationMessage: {302: "&nbsp;Zum Aufgeben der Bestellung müssen die AGB akzeptiert werden"},
            "htmlClass": "row",
            "labelHtmlClass": "col-lg-6 col-lg-offset-3"
          },
          {
            "key": "acceptedPrivacyPolicy",
            "title": "&nbsp;Ich akzeptiere die <a href='/#/datenschutzerklaerung.html' target='_blank'>Datenschutzbestimmungen</a>*",
            validationMessage: {302: "&nbsp;Zum Aufgeben der Bestellung müssen die Datenschutzbestimmungen akzeptiert werden"},
            "htmlClass": "row",
            "labelHtmlClass": "col-lg-6 col-lg-offset-3"
          },
          {
            "key": "acceptedNewsletter",
            "title": "&nbsp;Bitte informieren Sie mich über Neuigkeiten und Stellenangebote der Callidus Energie GmbH",
            "htmlClass": "row",
            "labelHtmlClass": "col-lg-6 col-lg-offset-3"
          }
        ]
      },
      {
        "key": "g-recaptcha-response",
        "type": "gRecaptcha",
        "title": "Captcha",
        "htmlClass": "row",
        "fieldHtmlClass": "col-lg-6 col-lg-offset-3"
      },
      {
        type: "actions",
        items: [
          {
            type: "button",
            title: "Eingaben zurücksetzen",
            onClick: "contact.reset()",
            style: "btn-lg"
          },
          {
            type: "submit",
            title: "Nachricht schicken",
            style: "btn-primary btn-lg"
          }
        ]
      }
    ];

    ContactMessageModel.prototype.validate = function () {
      return tv4.validateResult(self, ContactMessageModel.schema);
    };

    ContactMessageModel.build = function (data) {
      return new ContactMessageModel(
        data.salutation,
        data.firstName,
        data.lastName,
        data.email,
        data.companyName,
        data.currentPosition,
        data.phone,
        data.acceptedTermsAndConditions,
        data.acceptedPrivacyPolicy,
        data.acceptedNewsletter,
        data.contactReason,
        data.message,
        data['g-recaptcha-response']);
    };

    return ContactMessageModel;
  }
})();

/* global tv4, angular */
/**
 * @ngdoc controller
 * @name wageCalculator.api.models.factory:SimpleInputModel
 * @description
 * # @TODO provide some docs
 *
 * @author Marius Schmidt <marius@denktmit.de>
 * @author Julian Schlarb <js@project-deadline.com>
 */
(function () {
  'use strict'; //NOSONAR
  angular.module('wageCalculator.api.models')
    .factory('SimpleInputModel', SimpleInputModelFactory);

  function SimpleInputModelFactory() {
    function SimpleInputModel(gender, workExperienceInYear, educationLevel) {
      this.gender = gender;
      this.workExperienceInYears = workExperienceInYear;
      this.educationLevel = educationLevel;
    }

    SimpleInputModel.prototype.validate = function () {
      var schema = {
        "$schema": "http://json-schema.org/draft-04/schema#",
        "type": "object",
        "properties": {
          "gender": {
            "type": "string",
            "enum": [
              "FEMALE",
              "MALE"
            ]
          },
          "workExperienceInYears": {
            "type": "integer",
            "minimum": 0,
            "maximum": 45
          },
          "educationLevel": {
            "type": "string",
            "enum": [
              "HABILITATION",
              "DOCTORATE",
              "UNIVERSITY_DIPLOMA_OR_MAGISTER",
              "UNIVERSITY_MASTER",
              "UNIVERSITY_BACHELOR",
              "POLYTECHNIC_DIPLOMA_OR_MAGISTER",
              "POLYTECHNIC_MASTER",
              "POLYTECHNIC_BACHELOR",
              "EDUCATION_TECHNICAL",
              "EDUCATION_FOREMAN",
              "EDUCATION_NOT_COMPLETED",
              "OTHER"
            ]
          }
        },
        "required": [
          "gender",
          "workExperienceInYears",
          "educationLevel"
        ]
      };
      return tv4.validateResult(this, schema);
    };

    SimpleInputModel.build = function (data) {
      return new SimpleInputModel(data.gender, parseInt(data.workExperienceInYears), data.educationLevel);
    };

    return SimpleInputModel;
  }
})();

/* global tv4, angular */
/**
 * @ngdoc controller
 * @name wageCalculator.api.models.factory:SummaryOrderModel
 * @description
 * # @TODO provide some docs
 *
 * @author Marius Schmidt <marius@denktmit.de>
 * @author Julian Schlarb <js@project-deadline.com>
 */
(function () {
  'use strict'; //NOSONAR

  angular.module('wageCalculator.api.models')
    .factory('SummaryOrderModel', SummaryOrderModelFactory);

  function SummaryOrderModelFactory() {

    function SummaryOrderModel(salutation,
                               firstName,
                               lastName,
                               email,
                               companyName,
                               currentPosition,
                               phone,
                               acceptedTermsAndConditions,
                               acceptedPrivacyPolicy,
                               acceptedNewsletter,
                               gRecaptchaResponse) {
      this.salutation = salutation;
      this.firstName = firstName;
      this.lastName = lastName;
      this.email = email;
      this.companyName = companyName;
      this.currentPosition = currentPosition;
      this.phone = phone;
      this.acceptedTermsAndConditions = acceptedTermsAndConditions;
      this.acceptedPrivacyPolicy = acceptedPrivacyPolicy;
      this.acceptedNewsletter = acceptedNewsletter;
      this["g-recaptcha-response"] = gRecaptchaResponse;
    }

    SummaryOrderModel.schema = {
      "$schema": "http://json-schema.org/draft-04/schema#",
      "type": "object",
      "properties": {
        "email": {
          "type": "string",
          "pattern": "^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\\.[a-zA-Z0-9-]{2,6})$",
          "validationMessage": "Das E-Mail-Adressformat ist nicht korrekt"
        },
        "salutation": {
          "type": "string",
          "enum": [
            "Herr",
            "Frau",
            "Herr Prof.",
            "Herr Dr.",
            "Frau Prof.",
            "Frau Dr."
          ]
        },
        "firstName": {
          "type": "string"
        },
        "lastName": {
          "type": "string"
        },
        "companyName": {
          "type": "string"
        },
        "currentPosition": {
          "type": "string"
        },
        "phone": {
          "type": "string"
        },
        "acceptedTermsAndConditions": {
          "type": "boolean"
        },
        "acceptedPrivacyPolicy": {
          "type": "boolean"
        },
        "acceptedNewsletter": {
          "type": "boolean"
        },
        "g-recaptcha-response": {
          "type": "string",
          "format": "gRecaptcha"
        }
      },
      "required": [
        "email",
        "salutation",
        "firstName",
        "lastName",
        "acceptedTermsAndConditions",
        "acceptedPrivacyPolicy",
        "g-recaptcha-response"
      ]
    };

    SummaryOrderModel.form = [
      {
        "type": "fieldset",
        "title": "Ihre Kontaktinformation",
        items: [
          {
            "key": "email",
            "title": "Ihre E-Mail-Adresse*",
            "htmlClass": "row",
            "labelHtmlClass": "col-lg-3",
            "fieldHtmlClass": "col-lg-9"
          },
          {
            "key": "salutation",
            "title": "Anrede*",
            validationMessage: {302: "&nbsp;Pflichtfeld"},
            "htmlClass": "row",
            "labelHtmlClass": "col-lg-3",
            "fieldHtmlClass": "col-lg-9"
          },
          {
            "key": "firstName",
            "title": "Vorname*",
            validationMessage: {302: "&nbsp;Pflichtfeld"},
            "htmlClass": "row",
            "labelHtmlClass": "col-lg-3",
            "fieldHtmlClass": "col-lg-9"
          },
          {
            "key": "lastName",
            "title": "Nachname*",
            validationMessage: {302: "&nbsp;Pflichtfeld"},
            "htmlClass": "row",
            "labelHtmlClass": "col-lg-3",
            "fieldHtmlClass": "col-lg-9"
          },
          {
            "key": "companyName",
            "title": "Ihre derzeitiger Arbeitgeber",
            "htmlClass": "row",
            "labelHtmlClass": "col-lg-3",
            "fieldHtmlClass": "col-lg-9"
          },
          {
            "key": "currentPosition",
            "title": "Ihre derzeitige Position",
            "htmlClass": "row",
            "labelHtmlClass": "col-lg-3",
            "fieldHtmlClass": "col-lg-9"
          },
          {
            "key": "phone",
            "title": "Ihre Telefonnummer",
            "htmlClass": "row",
            "labelHtmlClass": "col-lg-3",
            "fieldHtmlClass": "col-lg-9"
          }
        ]
      },
      {
        "type": "fieldset",
        "title": "Nutzungsbedingungen",
        items: [
          {
            "key": "acceptedTermsAndConditions",
            "title": "&nbsp;Ich akzeptiere die <a href='/#/allgemeine_geschaeftsbedingungen.html' target='_blank'>AGB und Nutzungsbedingungen</a>*",
            validationMessage: {302: "&nbsp;Zum Aufgeben der Bestellung müssen die AGB akzeptiert werden"},
            "htmlClass": "row",
            "labelHtmlClass": "col-lg-6 col-lg-offset-3"
          },
          {
            "key": "acceptedPrivacyPolicy",
            "title": "&nbsp;Ich akzeptiere die <a href='/#/datenschutzerklaerung.html' target='_blank'>Datenschutzbestimmungen</a>*",
            validationMessage: {302: "&nbsp;Zum Aufgeben der Bestellung müssen die Datenschutzbestimmungen akzeptiert werden"},
            "htmlClass": "row",
            "labelHtmlClass": "col-lg-6 col-lg-offset-3"
          },
          {
            "key": "acceptedNewsletter",
            "title": "&nbsp;Bitte informieren Sie mich über Neuigkeiten und Stellenangebote der Callidus Energie GmbH",
            "htmlClass": "row",
            "labelHtmlClass": "col-lg-6 col-lg-offset-3"
          }
        ]
      },
      {
        "key": "g-recaptcha-response",
        "type": "gRecaptcha",
        "title": "Captcha",
        "htmlClass": "row",
        "fieldHtmlClass": "col-lg-6 col-lg-offset-3"
      },
      {
        type: "actions",
        items: [
          {
            type: "button",
            title: "Eingaben zurücksetzen",
            onClick: "summaryOrder.reset()",
            style: "btn-lg"
          },
          {
            type: "submit",
            title: "Kostenlose Zusammenfassung bestellen",
            style: "btn-primary btn-lg"
          }
        ]
      }
    ];

    SummaryOrderModel.prototype.validate = function () {
      return tv4.validateResult(this, SummaryOrderModel.schema);
    };

    SummaryOrderModel.build = function (data) {
      return new SummaryOrderModel(data.salutation,
        data.firstName,
        data.lastName,
        data.email,
        data.companyName,
        data.currentPosition,
        data.phone,
        data.acceptedTermsAndConditions,
        data.acceptedPrivacyPolicy,
        data.acceptedNewsletter,
        data['g-recaptcha-response']);
    };

    return SummaryOrderModel;
  }
})();

/* global tv4, angular */
/**
 * @ngdoc controller
 * @name wageCalculator.api.models.factory:SurveyOrderModel
 * @description
 * # @TODO provide some docs
 *
 * @author Marius Schmidt <marius@denktmit.de>
 * @author Julian Schlarb <js@project-deadline.com>
 */
(function () {
  'use strict'; //NOSONAR

  angular.module('wageCalculator.api.models')
    .factory('SurveyOrderModel', SurveyOrderModelFactory);

  /** @ngInject */
  function SurveyOrderModelFactory(AddressModel) {
    function SurveyOrderModel(currentPosition,
                              email,
                              phone,
                              invoiceAddress,
                              deliveryAddress,
                              acceptedTermsAndConditions,
                              acceptedPrivacyPolicy,
                              acceptedNewsletter,
                              gRecaptchaResponse) {
      this.currentPosition = currentPosition;
      this.email = email;
      this.phone = phone;
      this.invoiceAddress = invoiceAddress;
      this.deliveryAddress = deliveryAddress;
      this.acceptedTermsAndConditions = acceptedTermsAndConditions;
      this.acceptedPrivacyPolicy = acceptedPrivacyPolicy;
      this.acceptedNewsletter = acceptedNewsletter;
      this["g-recaptcha-response"] = gRecaptchaResponse;
    }

    SurveyOrderModel.schema = {
      "$schema": "http://json-schema.org/draft-04/schema#",
      "type": "object",
      "properties": {
        "email": {
          "type": "string",
          "pattern": "^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\\.[a-zA-Z0-9-]{2,6})$",
          "validationMessage": "&nbsp;Das E-Mail-Adressformat ist nicht korrekt"
        },
        "currentPosition": {
          "type": "string"
        },
        "phone": {
          "type": "string"
        },
        "invoiceAddress": {
          "$ref": "#/definitions/address"
        },
        "hasDifferingDeliveryAddress": {
          "type": "boolean"
        },
        "deliveryAddress": {
          "$ref": "#/definitions/address"
        },
        "acceptedTermsAndConditions": {
          "type": "boolean"
        },
        "acceptedPrivacyPolicy": {
          "type": "boolean"
        },
        "acceptedNewsletter": {
          "type": "boolean"
        },
        "g-recaptcha-response": {
          "type": "string",
          "format": "gRecaptcha"
        }
      },
      "required": [
        "email",
        "invoiceAddress",
        "deliveryAddress",
        "acceptedTermsAndConditions",
        "acceptedPrivacyPolicy",
        "g-recaptcha-response"
      ],
      "definitions": {
        "address": AddressModel.schema
      }
    };

    SurveyOrderModel.form = [
      {
        "type": "fieldset",
        "title": "Rechnungsadresse",
        items: [
          {
            "key": "invoiceAddress.companyName",
            "title": "Firmenname",
            validationMessage: {302: "&nbsp;Pflichtfeld"},
            "htmlClass": "row",
            "labelHtmlClass": "col-lg-3",
            "fieldHtmlClass": "col-lg-9"
          },
          {
            "key": "invoiceAddress.salutation",
            "title": "Anrede*",
            validationMessage: {302: "&nbsp;Pflichtfeld"},
            "htmlClass": "row",
            "labelHtmlClass": "col-lg-3",
            "fieldHtmlClass": "col-lg-9"
          },
          {
            "key": "invoiceAddress.firstName",
            "title": "Vorname*",
            validationMessage: {302: "&nbsp;Pflichtfeld"},
            "htmlClass": "row",
            "labelHtmlClass": "col-lg-3",
            "fieldHtmlClass": "col-lg-9"
          },
          {
            "key": "invoiceAddress.lastName",
            "title": "Nachname*",
            validationMessage: {302: "&nbsp;Pflichtfeld"},
            "htmlClass": "row",
            "labelHtmlClass": "col-lg-3",
            "fieldHtmlClass": "col-lg-9"
          },
          {
            "key": "invoiceAddress.streetAndHouseNumberOrPostbox",
            "title": "Straße und Hausnummer / Postfach*",
            validationMessage: {302: "&nbsp;Pflichtfeld"},
            "htmlClass": "row",
            "labelHtmlClass": "col-lg-3",
            "fieldHtmlClass": "col-lg-9"
          },
          {
            "key": "invoiceAddress.zipCode",
            "title": "PLZ*",
            validationMessage: {302: "&nbsp;Pflichtfeld"},
            "htmlClass": "row",
            "labelHtmlClass": "col-lg-3",
            "fieldHtmlClass": "col-lg-9"
          },
          {
            "key": "invoiceAddress.city",
            "title": "Stadt*",
            validationMessage: {302: "&nbsp;Pflichtfeld"},
            "htmlClass": "row",
            "labelHtmlClass": "col-lg-3",
            "fieldHtmlClass": "col-lg-9"
          },
          {
            "key": "invoiceAddress.country",
            "title": "Land*",
            validationMessage: {302: "&nbsp;Pflichtfeld"},
            "htmlClass": "row",
            "labelHtmlClass": "col-lg-3",
            "fieldHtmlClass": "col-lg-9"
          },
          {
            "type": "fieldset",
            "title": "Ihre Kontaktinformation",
            items: [
              {
                "key": "email",
                "title": "Ihre E-Mail-Adresse*",
                "htmlClass": "row",
                "labelHtmlClass": "col-lg-3",
                "fieldHtmlClass": "col-lg-9"
              },
              {
                "key": "currentPosition",
                "title": "Ihre derzeitige Position",
                "htmlClass": "row",
                "labelHtmlClass": "col-lg-3",
                "fieldHtmlClass": "col-lg-9"
              },
              {
                "key": "phone",
                "title": "Ihre Telefonnummer",
                "htmlClass": "row",
                "labelHtmlClass": "col-lg-3",
                "fieldHtmlClass": "col-lg-9"
              }
            ]
          },
          {
            "key": "hasDifferingDeliveryAddress",
            "title": "&nbsp;Abweichende Lieferadresse angeben",
            "htmlClass": "row",
            "labelHtmlClass": "col-lg-6 col-lg-offset-3"
          }
        ]
      },
      {
        "type": "fieldset",
        "title": "Lieferadresse",
        "condition": "model.hasDifferingDeliveryAddress",
        "htmlClass": "fieldset-invoice-address",
        items: [
          {
            "key": "deliveryAddress.companyName",
            "title": "Firmenname",
            validationMessage: {302: "&nbsp;Pflichtfeld"},
            "htmlClass": "row",
            "labelHtmlClass": "col-lg-3",
            "fieldHtmlClass": "col-lg-9"
          },
          {
            "key": "deliveryAddress.salutation",
            "title": "Anrede*",
            validationMessage: {302: "&nbsp;Pflichtfeld"},
            "htmlClass": "row",
            "labelHtmlClass": "col-lg-3",
            "fieldHtmlClass": "col-lg-9"
          },
          {
            "key": "deliveryAddress.firstName",
            "title": "Vorname*",
            validationMessage: {302: "&nbsp;Pflichtfeld"},
            "htmlClass": "row",
            "labelHtmlClass": "col-lg-3",
            "fieldHtmlClass": "col-lg-9"
          },
          {
            "key": "deliveryAddress.lastName",
            "title": "Nachname*",
            validationMessage: {302: "&nbsp;Pflichtfeld"},
            "htmlClass": "row",
            "labelHtmlClass": "col-lg-3",
            "fieldHtmlClass": "col-lg-9"
          },
          {
            "key": "deliveryAddress.streetAndHouseNumberOrPostbox",
            "title": "Straße und Hausnummer / Postfach*",
            validationMessage: {302: "&nbsp;Pflichtfeld"},
            "htmlClass": "row",
            "labelHtmlClass": "col-lg-3",
            "fieldHtmlClass": "col-lg-9"
          },
          {
            "key": "deliveryAddress.zipCode",
            "title": "PLZ*",
            validationMessage: {302: "&nbsp;Pflichtfeld"},
            "htmlClass": "row",
            "labelHtmlClass": "col-lg-3",
            "fieldHtmlClass": "col-lg-9"
          },
          {
            "key": "deliveryAddress.city",
            "title": "Stadt*",
            validationMessage: {302: "&nbsp;Pflichtfeld"},
            "htmlClass": "row",
            "labelHtmlClass": "col-lg-3",
            "fieldHtmlClass": "col-lg-9"
          },
          {
            "key": "deliveryAddress.country",
            "title": "Land*",
            validationMessage: {302: "&nbsp;Pflichtfeld"},
            "htmlClass": "row",
            "labelHtmlClass": "col-lg-3",
            "fieldHtmlClass": "col-lg-9"
          }
        ]
      },
      {
        "type": "fieldset",
        "title": "Nutzungsbedingungen",
        items: [
          {
            "key": "acceptedTermsAndConditions",
            "title": "&nbsp;Ich akzeptiere die <a href='/#/allgemeine_geschaeftsbedingungen.html' target='_blank'>AGB und Nutzungsbedingungen</a>*",
            validationMessage: {302: "&nbsp;Zum Aufgeben der Bestellung müssen die AGB akzeptiert werden"},
            "htmlClass": "row",
            "labelHtmlClass": "col-lg-6 col-lg-offset-3"
          },
          {
            "key": "acceptedPrivacyPolicy",
            "title": "&nbsp;Ich akzeptiere die <a href='/#/datenschutzerklaerung.html' target='_blank'>Datenschutzbestimmungen</a>*",
            validationMessage: {302: "&nbsp;Zum Aufgeben der Bestellung müssen die Datenschutzbestimmungen akzeptiert werden"},
            "htmlClass": "row",
            "labelHtmlClass": "col-lg-6 col-lg-offset-3"
          },
          {
            "key": "acceptedNewsletter",
            "title": "&nbsp;Bitte informieren Sie mich über Neuigkeiten und Stellenangebote der Callidus Energie GmbH",
            "htmlClass": "row",
            "labelHtmlClass": "col-lg-6 col-lg-offset-3"
          }
        ]
      },
      {
        "key": "g-recaptcha-response",
        "type": "gRecaptcha",
        "title": "Captcha",
        "htmlClass": "row",
        "fieldHtmlClass": "col-lg-6 col-lg-offset-3"
      },
      {
        type: "actions",
        items: [
          {
            type: "button",
            title: "Eingaben zurücksetzen",
            onClick: "surveyOrder.reset()",
            style: "btn-lg"
          },
          {
            type: "submit",
            title: "Weiter",
            style: "btn-primary btn-lg"
          }
        ]
      }
    ];

    SurveyOrderModel.prototype.validate = function () {
      return tv4.validateResult(self, SurveyOrderModel.schema);
    };

    SurveyOrderModel.build = function (data) {
      var invoiceAddress = AddressModel.build(data.invoiceAddress);
      var deliveryAddress = (data.hasDifferingDeliveryAddress)? AddressModel.build(data.deliveryAddress) : invoiceAddress;
      return new SurveyOrderModel(data.currentPosition,
        data.email,
        data.phone,
        invoiceAddress,
        deliveryAddress,
        data.acceptedTermsAndConditions,
        data.acceptedPrivacyPolicy,
        data.acceptedNewsletter,
        data['g-recaptcha-response']);
    };

    return SurveyOrderModel;
  }
})();

/* global tv4, angular */
/**
 * @ngdoc controller
 * @name wageCalculator.api.models.factory:SummaryOrderResponseModel
 * @description
 * # @TODO provide some docs
 *
 * @author Marius Schmidt <marius@denktmit.de>
 * @author Julian Schlarb <js@project-deadline.com>
 */
(function () {
  'use strict'; //NOSONAR
  angular.module('wageCalculator.api.models')
    .factory('SummaryOrderResponseModel', SummaryOrderResponseModelFactory);

  function SummaryOrderResponseModelFactory() {

    function SummaryOrderResponseModel(link) {
      this.link = link;
    }

    SummaryOrderResponseModel.prototype.validate = function () {
      var schema = {
        "$schema": "http://json-schema.org/draft-04/schema#",
        "type": "object",
        "properties": {
          "link": {
            "type": "string",
            "pattern": "^https?://([\da-zA-Z.-]+)\.([a-z.]{2,6})/([?/=%&\d\w .-]*)/?$"
          }
        },
        "required": [
          "link"
        ]
      };
      return tv4.validateResult(self, schema);
    };

    SummaryOrderResponseModel.build = function (data) {
      return new SummaryOrderResponseModel(data.link);
    };

    return SummaryOrderResponseModel;
  }
})();

/* global angular */
/**
 * @ngdoc controller
 * @name wageCalculator.api.models.factory:CalculatorFormModel
 * @description
 * # @TODO provide some docs
 *
 * @author Marius Schmidt <marius@denktmit.de>
 * @author Julian Schlarb <js@project-deadline.com>
 */
(function () {
  'use strict'; //NOSONAR
  angular.module('wageCalculator.calculator')
    .factory('CalculatorFormModel', CalculatorFormModelFactory);

  function CalculatorFormModelFactory() {

    var genders = [
      {
        "value": "FEMALE",
        "name": "weiblich"
      },
      {
        "value": "MALE",
        "name": "männlich"
      }
    ];

    var workExperienceLimit = {
      "min": 0,
      "max": 45
    }

    var educations = [
      {"value": "DOCTORATE",  "name": "Promotion"},
      {"value": "UNIVERSITY_MASTER",  "name": "Master, Diplom, Magister (Uni)"},
      {"value": "UNIVERSITY_BACHELOR",  "name": "Bachelor (Uni)"},
      {"value": "POLYTECHNIC_MASTER",  "name": "Master, Diplom, Magister (FH)"},
      {"value": "POLYTECHNIC_BACHELOR",  "name": "Bachelor (FH)"},
      {"value": "EDUCATION_FOREMAN",  "name": "Meisterausbildung"},
      //{"value": "EDUCATION_TECHNICAL",  "name": "Technikerausbildung"},
      {"value": "COMPLETED_VOCATIONAL_TRAINING",  "name": "Abgeschlossene Berufsausbildung"},
      {"value": "OTHER",  "name": "Sonstige"}];

    var companyTypes = [
      {"value": "BILLING_SERVICE_PROVIDER",  "name": "Abrechnungsdienstleister"},
      //{"value": "PLANT_ENGINEERING",  "name": "Anlagenbauer"},
      {"value": "ASSET_MANAGER_OR_FINANCIAL_INVESTOR",  "name": "Assetmanager oder Finanzinvestor"},
      {"value": "CONTRACTOR_OR_ENERGY_EFFICIENCY_CONSULTANTS",  "name": "Contractor oder Energieeffizienberater"},
      {"value": "ENERGY_TRADING_AND_DIRECT_MARKETING",  "name": "Energiehandel oder Direktvermarkter"},
      {"value": "ENERGY_COMPANY_OR_SUBSIDIARY",  "name": "Energiekonzern (incl. Tochtergesellschaften)"},
      {"value": "MANUFACTURER_OF_ENERGY_INSTALLATIONS",  "name": "Hersteller von Energieanlagen"},
      {"value": "ENGINEERING_COMPANY",  "name": "Ingenieurgesellschaft"},
      {"value": "NETWORK_OPERATOR",  "name": "Netzbetreiber"},
      //{"value": "PUBLIC_SERVICE",  "name": "Öffentlicher Dienst"},
      {"value": "PROJECT_PLANNER_OR_PLANT_OPERATOR_RENEWABLE_ENERGY",  "name": "Projektplaner oder Anlagebetreiber erneuerbare Energien"},
      {"value": "PUBLIC_UTILITY",  "name": "Stadtwerke und Regionalversorger"},
      //{"value": "PUBLIC_UTILITY_COOPERATION",  "name": "Stadtwerkekooperation"},
      {"value": "SYSTEM_HOUSE_OR_IT_CONSULTANCY",  "name": "Systemhaus oder IT Beratung"},
      //{"value": "UNIVERSITY_OR_RESEARCH",  "name": "Universität und Forschung"},
      //{"value": "COMPANY_OUTSIDE_ENERGY_ECONOMY",  "name": "Gesellschaft außerhalb der Energiewirtschaft"},
      {"value": "BUSINESS_CONSULTANCY",  "name": "Unternehmensberatung"},
      //{"value": "ASSOCIATION",  "name": "Verband"},
      {"value": "SALES_COMPANY",  "name": "Vertriebsgesellschaft"},
      {"value": "OTHER",  "name": "Sonstige"}];

    var regions = [
      {"group": "Baden-Württembeg",  "value": "BW_GENERAL",  "name": "Allgemein"},
      {"group": "Baden-Württembeg",  "value": "BW_FREIBURG",  "name": "Freiburg"},
      {"group": "Baden-Württembeg",  "value": "BW_KARLSRUHE",  "name": "Karlsruhe"},
      {"group": "Baden-Württembeg",  "value": "BW_MANNHEIM",  "name": "Mannheim"},
      {"group": "Baden-Württembeg",  "value": "BW_STUTTGART",  "name": "Stuttgart"},
      {"group": "Bayern",  "value": "BY_GENERAL",  "name": "Allgemein"},
      {"group": "Bayern",  "value": "BY_AUGSBURG",  "name": "Augsburg"},
      {"group": "Bayern",  "value": "BY_REGENSBURG",  "name": "Regensburg"},
      {"group": "Bayern",  "value": "BY_MUNICH",  "name": "München"},
      {"group": "Bayern",  "value": "BY_NUREMBERG_ERLANGEN_FUERTH",  "name": "Nürnberg, Erlangen, Fürth"},
      {"group": "Bayern",  "value": "BY_WUERZBURG",  "name": "Würzburg"},
      {"group": "Berlin",  "value": "BE",  "name": "Berlin"},
      {"group": "Brandenburg",  "value": "BB_GENERAL",  "name": "Allgemein"},
      {"group": "Brandenburg",  "value": "BB_POTSDAM",  "name": "Potsdam"},
      {"group": "Bremen",  "value": "HB",  "name": "Bremen"},
      {"group": "Hamburg",  "value": "HH",  "name": "Hamburg"},
      {"group": "Hessen",  "value": "HE_GENERAL",  "name": "Allgemein"},
      {"group": "Hessen",  "value": "HE_CENTRALEAST_KASSEL",  "name": "Mittel/Osthessen, Kassel"},
      {"group": "Hessen",  "value": "HE_RHINE_MAIN",  "name": "Rhein-Main"},
      {"group": "Mecklenburg-Vorpommern",  "value": "MV_GENERAL",  "name": "Allgemein"},
      {"group": "Niedersachsen",  "value": "NI_GENERAL",  "name": "Allgemein"},
      {"group": "Niedersachsen",  "value": "NI_BRAUNSCHWEIG_HANNOVER",  "name": "Braunschweig, Hannover"},
      {"group": "Niedersachsen",  "value": "NI_OLDENBURG_OSNABRUECK",  "name": "Osnabrück"},
      {"group": "Nordrhein-Westfalen",  "value": "NRW_GENERAL",  "name": "Allgemein"},
      {"group": "Nordrhein-Westfalen",  "value": "NRW_REGION_AACHEN",  "name": "Region Aachen"},
      {"group": "Nordrhein-Westfalen",  "value": "NRW_BERGISCHES_STAEDTEDREIECK",  "name": "Bergisches Städtedreieck"},
      {"group": "Nordrhein-Westfalen",  "value": "NRW_REGION_DUESSELDORF",  "name": "Region Düsseldorf"},
      {"group": "Nordrhein-Westfalen",  "value": "NRW_REGION_COLOGNE",  "name": "Region Köln"},
      {"group": "Nordrhein-Westfalen",  "value": "NRW_METROPOLE_RUHR",  "name": "Metropole Ruhr"},
      {"group": "Nordrhein-Westfalen",  "value": "NRW_REGION_NIEDERRHINE",  "name": "Region Niederrhein"},
      {"group": "Nordrhein-Westfalen",  "value": "NRW_REGION_OSTWESTFALIA",  "name": "Region Ostwestfalen"},
      {"group": "Nordrhein-Westfalen",  "value": "NRW_REGION_SOUTHWESTFALIA",  "name": "Region Südwestfalen"},
      {"group": "Rheinland-Pfalz",  "value": "RP_GENERAL",  "name": "Allgemein"},
      {"group": "Rheinland-Pfalz",  "value": "RP_MAINZ",  "name": "Mainz"},
      {"group": "Rheinland-Pfalz",  "value": "RP_LUDWIGSHAFEN",  "name": "Ludwigshafen"},
      {"group": "Saarland",  "value": "SL_REGION_SAARBRUECKEN",  "name": "Region Saarbrücken"},
      {"group": "Sachsen",  "value": "SN_GENERAL",  "name": "Allgemein"},
      {"group": "Sachsen",  "value": "SN_REGION_DRESDEN",  "name": "Region Dresden"},
      {"group": "Sachsen",  "value": "SN_LEIPZIG_CHEMNITZ",  "name": "Region Leipzig, Chemnitz"},
      {"group": "Sachsen-Anhalt",  "value": "ST_GENERAL",  "name": "Allgemein"},
      {"group": "Schleswig-Holstein",  "value": "SH_GENERAL",  "name": "Allgemein"},
      {"group": "Schleswig-Holstein",  "value": "SH_REGION_KIEL",  "name": "Region Kiel"},
      {"group": "Thüringen",  "value": "TH_GENERAL",  "name": "Allgemein"},
      {"group": "Thüringen",  "value": "TH_REGION_ERFURT",  "name": "Region Erfurt"}];

    var hierarchyLevels = [
      {"value": "CEO_OR_CHAIRMAN",  "name": "Vorstand/Geschäftsführung"},
      {"value": "AREA_MANAGER",  "name": "Bereichsleiter"},
      {"value": "DEPARTMENT_MANAGER",  "name": "Abteilungsleiter"},
      {"value": "TEAM_LEADER",  "name": "Teamleiter"},
      {"value": "SPECIALIST",  "name": "Spezialist"},
      {"value": "CASE_WORKER",  "name": "Sachbearbeiter"},
      {"value": "FOREMAN",  "name": "Vorarbeiter"},
      {"value": "TECHNICIAN",  "name": "Facharbeiter"},
      {"value": "WORKER",  "name": "Gelernter/Ungelernter Arbeiter"}];

    var areaManagerScopes = [
      {"value": "HL2_01",  "name": "Kaufmännische Gesamtleitung"},
      {"value": "HL2_02",  "name": "Technische Gesamtleitung"},
      {"value": "HL2_03",  "name": "Abrechnung- und Kundenservice"},
      {"value": "HL2_04",  "name": "Beratung"},
      {"value": "HL2_05",  "name": "Dezentrale Erzeugung und Energiedienstleistungen (kaufm.)"},
      {"value": "HL2_06",  "name": "Dezentrale Erzeugung und Energiedienstleistungen (techn.)"},
      {"value": "HL2_07",  "name": "Energiehandel/ -Beschaffung"},
      {"value": "HL2_08",  "name": "Erneuerbare Energien"},
      {"value": "HL2_09",  "name": "Finanzen/ Einkauf"},
      {"value": "HL2_10",  "name": "Gewerbliche Dienste"},
      {"value": "HL2_11",  "name": "IT/EDV"},
      {"value": "HL2_12",  "name": "Konventionelle Erzeugung"},
      {"value": "HL2_13",  "name": "Marketing und Kommunikation"},
      {"value": "HL2_14",  "name": "Personal und Recht"},
      {"value": "HL2_15",  "name": "Strategie- und Unternehmensentwicklung"},
      {"value": "HL2_16",  "name": "Strom- und Gasnetze, Fernwärme und Speicher"},
      {"value": "HL2_17",  "name": "Vertrieb"},
      {"value": "HL2_18",  "name": "Wasser und Umwelt"},
      {"value": "HL2_19",  "name": "Sonstige (kaufm.)"},
      {"value": "HL2_20",  "name": "Sonstige (techn.)"}];

    var departmentManagerScopes = [
      {"group": "Abrechnung- und Kundenservice",  "value": "HL3_01",  "name": "Leitung Gesamtbereich"},
      {"group": "Abrechnung- und Kundenservice",  "value": "HL3_02",  "name": "Abrechnung"},
      {"group": "Abrechnung- und Kundenservice",  "value": "HL3_03",  "name": "Kundenservice"},
      {"group": "Abrechnung- und Kundenservice",  "value": "HL3_04",  "name": "Sonstige"},
      {"group": "Beratung",  "value": "HL3_05",  "name": "Leitung Gesamtbereich"},
      {"group": "Beratung",  "value": "HL3_06",  "name": "Ingenieurberatung"},
      {"group": "Beratung",  "value": "HL3_07",  "name": "IT-Beratung"},
      {"group": "Beratung",  "value": "HL3_08",  "name": "Management-Beratung"},
      {"group": "Beratung",  "value": "HL3_09",  "name": "Sonstige"},
      {"group": "Dezentrale Erzeugung und Energiedienstleistungen",  "value": "HL3_10",  "name": "Leitung Gesamtbereich"},
      {"group": "Dezentrale Erzeugung und Energiedienstleistungen",  "value": "HL3_11",  "name": "Projektentwicklung"},
      {"group": "Dezentrale Erzeugung und Energiedienstleistungen",  "value": "HL3_12",  "name": "Projektmanagement"},
      {"group": "Dezentrale Erzeugung und Energiedienstleistungen",  "value": "HL3_13",  "name": "Vertrieb Contractinglösungen"},
      {"group": "Dezentrale Erzeugung und Energiedienstleistungen",  "value": "HL3_14",  "name": "Wartung und Betrieb"},
      {"group": "Dezentrale Erzeugung und Energiedienstleistungen",  "value": "HL3_15",  "name": "Sonstige"},
      {"group": "Energiehandel/ -Beschaffung",  "value": "HL3_16",  "name": "Leitung Gesamtbereich"},
      {"group": "Energiehandel/ -Beschaffung",  "value": "HL3_17",  "name": "Analyse"},
      {"group": "Energiehandel/ -Beschaffung",  "value": "HL3_18",  "name": "Bilanzkreismanagement"},
      {"group": "Energiehandel/ -Beschaffung",  "value": "HL3_19",  "name": "Portfolio Management"},
      {"group": "Energiehandel/ -Beschaffung",  "value": "HL3_20",  "name": "Risikomanagement"},
      {"group": "Energiehandel/ -Beschaffung",  "value": "HL3_21",  "name": "Trading"},
      {"group": "Energiehandel/ -Beschaffung",  "value": "HL3_22",  "name": "Sonstige"},
      {"group": "Erneuerbare Energien",  "value": "HL3_23",  "name": "Leitung Gesamtbereich"},
      {"group": "Erneuerbare Energien",  "value": "HL3_24",  "name": "Anlagenbau"},
      {"group": "Erneuerbare Energien",  "value": "HL3_25",  "name": "Business Development/ Vertrieb"},
      {"group": "Erneuerbare Energien",  "value": "HL3_26",  "name": "Forschung & Entwicklung"},
      {"group": "Erneuerbare Energien",  "value": "HL3_27",  "name": "Projektentwicklung"},
      {"group": "Erneuerbare Energien",  "value": "HL3_28",  "name": "Wartung und Betrieb"},
      {"group": "Erneuerbare Energien",  "value": "HL3_29",  "name": "Sonstige"},
      {"group": "Finanzen/ Einkauf",  "value": "HL3_30",  "name": "Leitung Gesamtbereich"},
      {"group": "Finanzen/ Einkauf",  "value": "HL3_31",  "name": "Asset-/ Regulierungsmanagement"},
      {"group": "Finanzen/ Einkauf",  "value": "HL3_32",  "name": "Controlling"},
      {"group": "Finanzen/ Einkauf",  "value": "HL3_33",  "name": "Einkauf"},
      {"group": "Finanzen/ Einkauf",  "value": "HL3_34",  "name": "Rechnungswesen"},
      {"group": "Finanzen/ Einkauf",  "value": "HL3_35",  "name": "Risikomanagement"},
      {"group": "Finanzen/ Einkauf",  "value": "HL3_36",  "name": "Sonstige"},
      {"group": "Gewerbliche Dienste",  "value": "HL3_37",  "name": "Leitung Gesamtbereich"},
      {"group": "Gewerbliche Dienste",  "value": "HL3_38",  "name": "Sonstige"},
      {"group": "IT / EDV",  "value": "HL3_39",  "name": "Leitung Gesamtbereich"},
      {"group": "IT / EDV",  "value": "HL3_40",  "name": "Anwendungsbetreuung"},
      {"group": "IT / EDV",  "value": "HL3_41",  "name": "Anwendungsentwicklung"},
      {"group": "IT / EDV",  "value": "HL3_42",  "name": "Betrieb/ Infrastruktur"},
      {"group": "IT / EDV",  "value": "HL3_43",  "name": "IT-Beratung"},
      {"group": "IT / EDV",  "value": "HL3_44",  "name": "Projektleitung"},
      {"group": "IT / EDV",  "value": "HL3_45",  "name": "Sonstige"},
      {"group": "Konventionelle Erzeugung",  "value": "HL3_46",  "name": "Leitung Gesamtbereich"},
      {"group": "Konventionelle Erzeugung",  "value": "HL3_47",  "name": "Sonstige"},
      {"group": "Marketing und Kommunikation",  "value": "HL3_48",  "name": "Leitung Gesamtbereich"},
      {"group": "Marketing und Kommunikation",  "value": "HL3_49",  "name": "Marketing/ Produktmanagement"},
      {"group": "Marketing und Kommunikation",  "value": "HL3_50",  "name": "PR/Öffentlichkeitsarbeit"},
      {"group": "Marketing und Kommunikation",  "value": "HL3_51",  "name": "Sonstige"},
      {"group": "Personal / Recht",  "value": "HL3_52",  "name": "Leitung Gesamtbereich"},
      {"group": "Personal / Recht",  "value": "HL3_53",  "name": "Personal"},
      {"group": "Personal / Recht",  "value": "HL3_54",  "name": "Recht"},
      {"group": "Personal / Recht",  "value": "HL3_55",  "name": "Sonstige"},
      {"group": "Strategie- und Unternehmensentwicklung",  "value": "HL3_56",  "name": "Leitung Gesamtbereich"},
      {"group": "Strategie- und Unternehmensentwicklung",  "value": "HL3_57",  "name": "Energiepolitik"},
      {"group": "Strategie- und Unternehmensentwicklung",  "value": "HL3_58",  "name": "Innovationsmanagement"},
      {"group": "Strategie- und Unternehmensentwicklung",  "value": "HL3_59",  "name": "Strategie- und Unternehmensentwicklung"},
      {"group": "Strategie- und Unternehmensentwicklung",  "value": "HL3_60",  "name": "Sonstige"},
      {"group": "Strom- und Gasnetze, Fernwärme und Speicher",  "value": "HL3_61",  "name": "Leitung Gesamtbereich"},
      {"group": "Strom- und Gasnetze, Fernwärme und Speicher",  "value": "HL3_62",  "name": "Asset- /Regulierungsmanagement"},
      {"group": "Strom- und Gasnetze, Fernwärme und Speicher",  "value": "HL3_63",  "name": "Netzbau"},
      {"group": "Strom- und Gasnetze, Fernwärme und Speicher",  "value": "HL3_64",  "name": "Netzbetrieb"},
      {"group": "Strom- und Gasnetze, Fernwärme und Speicher",  "value": "HL3_65",  "name": "Netzplanung"},
      {"group": "Strom- und Gasnetze, Fernwärme und Speicher",  "value": "HL3_66",  "name": "Projektleitung"},
      {"group": "Strom- und Gasnetze, Fernwärme und Speicher",  "value": "HL3_67",  "name": "Sonstige"},
      {"group": "Vertrieb",  "value": "HL3_68",  "name": "Leitung Gesamtbereich"},
      {"group": "Vertrieb",  "value": "HL3_69",  "name": "Vertriebsinnendienst"},
      {"group": "Vertrieb",  "value": "HL3_70",  "name": "Vertrieb Contractinglösungen"},
      {"group": "Vertrieb",  "value": "HL3_71",  "name": "Vertrieb Privat- und Gewerbekunden"},
      {"group": "Vertrieb",  "value": "HL3_72",  "name": "Vertrieb Strom/Gas an Industrie/Stadtwerke"},
      {"group": "Vertrieb",  "value": "HL3_73",  "name": "Sonstige"},
      {"group": "Wasser und Umwelt",  "value": "HL3_74",  "name": "Allgemein"}];

    var individualScopes = [
      {"group": "Abrechnung- und Kundenservice",  "value": "HL4_01",  "name": "Abrechnung"},
      {"group": "Abrechnung- und Kundenservice",  "value": "HL4_02",  "name": "Kundenservice"},
      {"group": "Abrechnung- und Kundenservice",  "value": "HL4_03",  "name": "Sonstige"},
      {"group": "Beratung",  "value": "HL4_04",  "name": "Ingenieurberatung"},
      {"group": "Beratung",  "value": "HL4_05",  "name": "IT-Beratung"},
      {"group": "Beratung",  "value": "HL4_06",  "name": "Management-Beratung"},
      {"group": "Beratung",  "value": "HL4_07",  "name": "Sonstige"},
      {"group": "Dezentrale Erzeugung und Energiedienstleistungen",  "value": "HL4_08",  "name": "Projektentwicklung"},
      {"group": "Dezentrale Erzeugung und Energiedienstleistungen",  "value": "HL4_09",  "name": "Projektmanagement"},
      {"group": "Dezentrale Erzeugung und Energiedienstleistungen",  "value": "HL4_10",  "name": "Vertrieb Contractinglösungen"},
      {"group": "Dezentrale Erzeugung und Energiedienstleistungen",  "value": "HL4_11",  "name": "Wartung und Betrieb"},
      {"group": "Dezentrale Erzeugung und Energiedienstleistungen",  "value": "HL4_12",  "name": "Sonstige"},
      {"group": "Energiehandel/ -Beschaffung",  "value": "HL4_13",  "name": "Analyse"},
      {"group": "Energiehandel/ -Beschaffung",  "value": "HL4_14",  "name": "Bilanzkreismanagement"},
      {"group": "Energiehandel/ -Beschaffung",  "value": "HL4_15",  "name": "Portfolio Management"},
      {"group": "Energiehandel/ -Beschaffung",  "value": "HL4_16",  "name": "Risikomanagement"},
      {"group": "Energiehandel/ -Beschaffung",  "value": "HL4_17",  "name": "Trading"},
      {"group": "Energiehandel/ -Beschaffung",  "value": "HL4_18",  "name": "Sonstige"},
      {"group": "Erneuerbare Energien",  "value": "HL4_19",  "name": "Anlagenbau"},
      {"group": "Erneuerbare Energien",  "value": "HL4_20",  "name": "Business Development/ Vertrieb"},
      {"group": "Erneuerbare Energien",  "value": "HL4_21",  "name": "Forschung & Entwicklung"},
      {"group": "Erneuerbare Energien",  "value": "HL4_22",  "name": "Projektentwicklung"},
      {"group": "Erneuerbare Energien",  "value": "HL4_23",  "name": "Wartung und Betrieb"},
      {"group": "Erneuerbare Energien",  "value": "HL4_24",  "name": "Sonstige"},
      {"group": "Finanzen/ Einkauf",  "value": "HL4_25",  "name": "Asset-/ Regulierungsmanagement"},
      {"group": "Finanzen/ Einkauf",  "value": "HL4_26",  "name": "Controlling"},
      {"group": "Finanzen/ Einkauf",  "value": "HL4_27",  "name": "Einkauf"},
      {"group": "Finanzen/ Einkauf",  "value": "HL4_28",  "name": "Rechnungswesen"},
      {"group": "Finanzen/ Einkauf",  "value": "HL4_29",  "name": "Risikomanagement"},
      {"group": "Finanzen/ Einkauf",  "value": "HL4_30",  "name": "Sonstige"},
      {"group": "Gewerbliche Dienste",  "value": "HL4_31",  "name": "Allgemein"},
      {"group": "IT / EDV",  "value": "HL4_32",  "name": "Anwendungsbetreuung"},
      {"group": "IT / EDV",  "value": "HL4_33",  "name": "Anwendungsentwicklung"},
      {"group": "IT / EDV",  "value": "HL4_34",  "name": "Betrieb/ Infrastruktur"},
      {"group": "IT / EDV",  "value": "HL4_35",  "name": "IT-Beratung"},
      {"group": "IT / EDV",  "value": "HL4_36",  "name": "Projektleitung"},
      {"group": "IT / EDV",  "value": "HL4_37",  "name": "Sonstige"},
      {"group": "konventionelle Erzeugung",  "value": "HL4_38",  "name": "Allgemein"},
      {"group": "Marketing und Kommunikation",  "value": "HL4_39",  "name": "Marketing/ Produktmanagement"},
      {"group": "Marketing und Kommunikation",  "value": "HL4_40",  "name": "PR/Öffentlichkeitsarbeit"},
      {"group": "Marketing und Kommunikation",  "value": "HL4_41",  "name": "Sonstige"},
      {"group": "Personal / Recht",  "value": "HL4_42",  "name": "Personal"},
      {"group": "Personal / Recht",  "value": "HL4_43",  "name": "Recht"},
      {"group": "Personal / Recht",  "value": "HL4_44",  "name": "Sonstige"},
      {"group": "Strategie- und Unternehmensentwicklung",  "value": "HL4_45",  "name": "Energiepolitik"},
      {"group": "Strategie- und Unternehmensentwicklung",  "value": "HL4_46",  "name": "Innovationsmanagement"},
      {"group": "Strategie- und Unternehmensentwicklung",  "value": "HL4_47",  "name": "Strategie- und Unternehmensentwicklung"},
      {"group": "Strategie- und Unternehmensentwicklung",  "value": "HL4_48",  "name": "Sonstige"},
      {"group": "Strom- und Gasnetze, Fernwärme und Speicher",  "value": "HL4_49",  "name": "Asset- /Regulierungsmanagement"},
      {"group": "Strom- und Gasnetze, Fernwärme und Speicher",  "value": "HL4_50",  "name": "Netzbau"},
      {"group": "Strom- und Gasnetze, Fernwärme und Speicher",  "value": "HL4_51",  "name": "Netzbetrieb"},
      {"group": "Strom- und Gasnetze, Fernwärme und Speicher",  "value": "HL4_52",  "name": "Netzplanung"},
      {"group": "Strom- und Gasnetze, Fernwärme und Speicher",  "value": "HL4_53",  "name": "Projektleitung"},
      {"group": "Strom- und Gasnetze, Fernwärme und Speicher",  "value": "HL4_54",  "name": "Sonstige"},
      {"group": "Vertrieb",  "value": "HL4_55",  "name": "Vertriebsinnendienst"},
      {"group": "Vertrieb",  "value": "HL4_56",  "name": "Vertrieb Contractinglösungen"},
      {"group": "Vertrieb",  "value": "HL4_57",  "name": "Vertrieb Privat- und Gewerbekunden"},
      {"group": "Vertrieb",  "value": "HL4_58",  "name": "Vertrieb Strom/Gas an Industrie/Stadtwerke"},
      {"group": "Vertrieb",  "value": "HL4_59",  "name": "Sonstige"},
      {"group": "Wasser und Umwelt",  "value": "HL4_60",  "name": "Allgemein"}];

    function countOfCompanyEmployeesLimit(companyType) {
      var countOfCompanyEmployeesLimits = {
        "BILLING_SERVICE_PROVIDER": {"min": 1, "max": 10000},
        "PLANT_ENGINEERING": {"min": 1, "max": 10000},
        "ASSET_MANAGER_OR_FINANCIAL_INVESTOR": {"min": 1, "max": 10000},
        "CONTRACTOR_OR_ENERGY_EFFICIENCY_CONSULTANTS": {"min": 1, "max": 10000},
        "ENERGY_TRADING_AND_DIRECT_MARKETING": {"min": 1, "max": 10000},
        "ENERGY_COMPANY_OR_SUBSIDIARY": {"min": 1, "max": 60000},
        "MANUFACTURER_OF_ENERGY_INSTALLATIONS": {"min": 1, "max": 10000},
        "ENGINEERING_COMPANY": {"min": 1, "max": 10000},
        "NETWORK_OPERATOR": {"min": 1, "max": 10000},
        "MUNICIPAL_UTILITIES": {"min": 1, "max": 10000},
        "PROJECT_PLANNER_OR_PLANT_OPERATOR_RENEWABLE_ENERGY": {"min": 1, "max": 10000},
        "PUBLIC_UTILITY_COOPERATION": {"min": 1, "max": 10000},
        "SYSTEM_HOUSE_OR_IT_CONSULTANCY": {"min": 1, "max": 10000},
        "BUSINESS_CONSULTANCY": {"min": 1, "max": 10000},
        "SALES_COMPANY": {"min": 1, "max": 10000},
        "OTHER": {"min": 1, "max": 10000}
      };
      return (companyType)? countOfCompanyEmployeesLimits[companyType] : {"min": 1, "max": 1000};
    }

    function getHierarchyLevels(workExperienceInYears) {
      var workExpierenceHierarchyBoundaries = {
        "CEO_OR_CHAIRMAN": {"min": 11},
        "AREA_MANAGER": {"min": 4},
        "DEPARTMENT_MANAGER": {"min": 4},
        "TEAM_LEADER": {"min": 4},
        "TECHNICIAN": {"min": 4},
        "FOREMAN": {"min": 0},
        "SPECIALIST": {"min": 0},
        "CASE_WORKER": {"min": 0},
        "WORKER": {"min": 0}
      };
      return getFilteredOptions(hierarchyLevels, function(option) {
        return workExperienceInYears >= workExpierenceHierarchyBoundaries[option.value]["min"];
      });
    }

    function getFilteredOptions(options, filterFunction) {
      var filteredOptions = [];
      var index;
      for (index = 0; index < options.length; ++index) {
        if (filterFunction(options[index])) {
          filteredOptions.push(options[index]);
        }
      }
      return filteredOptions;
    }

    function myStaffSizeLimit(hierarchyLevel) {
      var myStaffSizeLimits = {
        "CEO_OR_CHAIRMAN": {"min": 1, "max": 1000},
        "AREA_MANAGER": {"min": 10, "max": 300},
        "DEPARTMENT_MANAGER": {"min": 5, "max": 50},
        "TEAM_LEADER": {"min": 1, "max": 20},
        "TECHNICIAN": {"min": 1, "max": 20},
        "FOREMAN": {"min": 1, "max": 20},
        "SPECIALIST": {"min": 0, "max": 0},
        "CASE_WORKER": {"min": 0, "max": 0},
        "WORKER": {"min": 0, "max": 0}
      };
      return (hierarchyLevel)? myStaffSizeLimits[hierarchyLevel] : {"min": 0, "max": 0};
    }

    function scopeType(hierarchyLevel) {
      var scopeTypes = {
        "CEO_OR_CHAIRMAN": "none",
        "AREA_MANAGER": "areaManagerScope",
        "DEPARTMENT_MANAGER": "departmentManagerScope",
        "TEAM_LEADER": "departmentManagerScope",
        "TECHNICIAN": "individual",
        "SPECIALIST": "individual",
        "FOREMAN": "individual",
        "CASE_WORKER": "individual",
        "WORKER": "individual"
      }
      return scopeTypes[hierarchyLevel];
    }

    return {
      genders: genders,
      workExperienceLimit: workExperienceLimit,
      educations: educations,
      companyTypes: companyTypes,
      countOfCompanyEmployeesLimit: countOfCompanyEmployeesLimit,
      regions: regions,
      hierarchyLevels: getHierarchyLevels,
      myStaffSizeLimit: myStaffSizeLimit,
      areaManagerScopes: areaManagerScopes,
      departmentManagerScopes: departmentManagerScopes,
      individualScopes: individualScopes,
      scopeType: scopeType
    }

  }
})();

/* global angular */
/**
 * @ngdoc controller
 * @name wageCalculator.survey.controller:SurveyController
 * @description
 * # @TODO provide some docs
 *
 * @author Marius Schmidt <marius@denktmit.de>
 * @author Julian Schlarb <js@project-deadline.com>
 */
(function () {
  'use strict'; //NOSONAR

  angular.module('wageCalculator.survey')
    .controller('SurveyController', SurveyController);

  /** @ngInject */
  function SurveyController($scope, Lightbox) {

    /**
     * @ngdoc property
     * @name vm
     * @propertyOf wageCalculator.survey.controller:SurveyOrderController
     * @description
     * Controller-wide representation of this controller instance
     */
    var vm = this;

    vm.images = [
      {
        'url': '../assets/images/img_p02-03.png',
        'thumbUrl': '../assets/images/img_preview_p02-03@2x.png'
      },
      {
        'url': '../assets/images/img_p12-13.png',
        'thumbUrl': '../assets/images/img_preview_p12-13@2x.png'
      }
    ];

    vm.openLightboxModal = function (index) {
      Lightbox.openModal(vm.images, index);
    };

  }
})();

/* global angular */
/**
 * @ngdoc controller
 * @name wageCalculator.calculator.controller:FinalCalculatorController
 * @description
 * # @TODO provide some docs
 *
 * @author Marius Schmidt <marius@denktmit.de>
 * @author Julian Schlarb <js@project-deadline.com>
 */
(function () {
  'use strict'; //NOSONAR

  angular.module('wageCalculator.calculator')
    .controller('FinalCalculatorController', FinalCalculatorController);

  /** @ngInject */
  function FinalCalculatorController($log, $timeout, $scope, $sce, CalculatorInputModel, WageCalculationService, toastr, CalculatorFormModel) {

    /**
     * @ngdoc property
     * @name vm
     * @propertyOf wageCalculator.calculator.controller:FinalCalculatorController
     * @description
     * Controller-wide representation of this controller instance
     */
    var vm = this;

    vm.educations = CalculatorFormModel.educations;
    vm.companyEmployeesLimit = {"min": 1, "max": 1000};
    vm.companyCategories = CalculatorFormModel.companyTypes;
    vm.regions = CalculatorFormModel.regions;
    vm.hierarchyLevels = CalculatorFormModel.hierarchyLevels(0);
    vm.areaManagerScopes = CalculatorFormModel.areaManagerScopes;
    vm.departmentManagerScopes = CalculatorFormModel.departmentManagerScopes;
    vm.individualScopes = CalculatorFormModel.individualScopes;

    vm.workExperienceChanged = function() {
      vm.hierarchyLevels = CalculatorFormModel.hierarchyLevels(vm.input.workExperienceInYears);
    }

    vm.workExperienceSliderOptions = {
      floor: 0,
      ceil: 45,
      onChange: vm.workExperienceChanged
    }

    vm.companyCategoryChanged = function() {
      var limit = CalculatorFormModel.countOfCompanyEmployeesLimit(vm.input.companyCategory);
      vm.companySizeSliderOptions.maxLimit = limit.max;
      vm.input.countOfCompanyEmployees = Math.min(vm.input.countOfCompanyEmployees, limit.max);
      vm.refreshSlider();
    }

    vm.companySizeSliderOptions = {
      floor: 1,
      ceil: 60000,
      maxLimit: 10000,
      logScale:true,
      step:1,
      translate: shortenNumber
    };

    vm.hierarchyLevelChanged = function() {
      var limit = CalculatorFormModel.myStaffSizeLimit(vm.input.hierarchyLevel);
      vm.subordinatesSliderOptions.floor = limit.min;
      vm.subordinatesSliderOptions.ceil = limit.max;
      vm.input.myStaffSize = Math.min(Math.max(limit.min, vm.input.myStaffSize), limit.max);
      vm.subordinatesSliderOptions.disabled = !vm.hasSubordinates();
      vm.refreshSlider();
    }

    vm.hasSubordinates = function () {
      var limit = CalculatorFormModel.myStaffSizeLimit(vm.input.hierarchyLevel);
      return (limit.max > 0);
    }

    vm.subordinatesSliderOptions = {
      floor: 0,
      ceil: 1000,
      logScale: false,
      step:1,
      disabled: true,
      translate: shortenNumber
    };

    vm.refreshSlider = function () {
      $timeout(function () {
        $scope.$broadcast('rzSliderForceRender');
      });
    };

    /**
     * @ngdoc property
     * @name initialModel
     * @function
     * @description
     * # TODO describe this feature
     */
    var initialModel = function () {
      return {
        gender: "MALE",
        workExperienceInYears: 0,
        educationLevel: null,
        countOfCompanyEmployees: 1,
        companyCategory: null,
        region: null,
        hierarchyLevel: null,
        myStaffSize: null,
        areaManagerScope: null,
        departmentManagerScope: null,
        individualScope: null
      }
    };

    vm.employeeCountSliderOpts = {
      floor: 1, ceil: 100000, logScale:true, step:1,
      translate: shortenNumber
    };

    vm.subordinatesCountSliderOpts = {
      floor: 1, ceil: 1000, logScale:true, step:1, disabled: true,
      translate: shortenNumber
    };

    vm.errors = {};

    vm.isMyStaffSizeDropdownDisabled = function() {
      return !(vm.input.hierarchyLevel === "CEO_OR_CHAIRMAN");
    };

    vm.isAreaManagerScopeDropdownDisabled = function() {
      return !(vm.input.hierarchyLevel === "AREA_MANAGER");
    };

    vm.isDepartmentManagerScopeDropdownDisabled = function() {
      return !(vm.input.hierarchyLevel === "DEPARTMENT_MANAGER" || vm.input.hierarchyLevel === "TEAM_LEADER");
    };

    vm.isIndividualScopeDropdownDisabled = function() {
      return !(vm.input.hierarchyLevel === "SPECIALIST"
        || vm.input.hierarchyLevel === "TECHNICIAN"
        || vm.input.hierarchyLevel === "FOREMAN"
        || vm.input.hierarchyLevel === "CASE_WORKER"
        || vm.input.hierarchyLevel === "WORKER");
    };

    vm.showSummaryTeaser = false;

    /**
     * @ngdoc property
     * @name input
     * @propertyOf wageCalculator.calculator.controller:FinalCalculatorController
     * @description
     * # TODO describe this feature
     */
    vm.input = initialModel();

    /**
     * @ngdoc property
     * @name doCalc
     * @function
     * @param {Event} $event
     * @propertyOf wageCalculator.calculator.controller:FinalCalculatorController
     * @description
     * # TODO describe this feature
     */
    vm.doCalc = function ($event) {
      $event.preventDefault();

      var calculatorInput = CalculatorInputModel.build(vm.input);
      var result = calculatorInput.validate();
      vm.errors = {};
      if (result.valid) {
        vm.result = 'calculating';
        WageCalculationService.calculateWage(calculatorInput)
          .then(function (calculationResponse) {
            var errors = calculationResponse.validate();
            if (errors.valid) {
              var floor = vm.formatNumber(calculationResponse.scaledAmount * 0.9, 0 , "", ".") + "€";
              var ceil = vm.formatNumber(calculationResponse.scaledAmount * 1.1, 0 , "", ".") + "€";
              vm.result = $sce.trustAsHtml(floor + " - " + ceil);
              vm.showSummaryTeaser = true;
              toastr.success('Berechnung erfolgt');
            } else {
              vm.result = 'Berechnung fehlgeschlagen';
              $log.error(angular.toJson(errors));
              toastr.error('Der Rechner hat einen ungültigen Wert \'NaN\' geliefert.');
            }
          })
          .catch(function (error) {
            $log.error(error);
            vm.result = 'Berechnung fehlgeschlagen';
            // @TODO provide a better error message
            toastr.error('Der Server ist im moment nicht verfügbar, bitte versuchen Sie es erneut');
          });
      } else {
        $log.error(angular.toJson(result));
        vm.result = "Bitte alle Felder ausfüllen";
        for (var i = 0; i < result.errors.length; i++) {
          vm.errors[result.errors[i]] = true;
        }
        //vm.errors = errors;
        // @TODO provide a better error message
        toastr.error('Das Formular ist unvollständig oder ungültig ausgefüllt');
      }
    };

    vm.formatNumber = function(/* in: float   */ number,
                               /* in: integer */ laenge,
                               /* in: String  */ sep,
                               /* in: String  */ th_sep) {
      number = Math.round( number * Math.pow(10, laenge) ) / Math.pow(10, laenge);
      var str_number = number+"";
      var arr_int = str_number.split(".");
      if(!arr_int[0]) arr_int[0] = "0";
      if(!arr_int[1]) arr_int[1] = "";
      if(arr_int[1].length < laenge){
        var nachkomma = arr_int[1];
        for(var i=arr_int[1].length+1; i <= laenge; i++){  nachkomma += "0";  }
        arr_int[1] = nachkomma;
      }
      if(th_sep != "" && arr_int[0].length > 3){
        var Begriff = arr_int[0];
        arr_int[0] = "";
        for(var j = 3; j < Begriff.length ; j+=3){
          var Extrakt = Begriff.slice(Begriff.length - j, Begriff.length - j + 3);
          arr_int[0] = th_sep + Extrakt +  arr_int[0] + "";
        }
        var str_first = Begriff.substr(0, (Begriff.length % 3 == 0)?3:(Begriff.length % 3));
        arr_int[0] = str_first + arr_int[0];
      }
      return arr_int[0]+sep+arr_int[1];
    }

    /**
     * @ngdoc property
     * @name reset
     * @function
     * @propertyOf wageCalculator.calculator.controller:FinalCalculatorController
     * @description
     * # TODO describe this feature
     */
    vm.reset = function () {
      vm.errors = {};
      vm.input = initialModel();
    }

    function shortenNumber(number) {
      if(number === null) return null;
      if(number === 0) return "0";

      var fractionSize = 1;

      if(!fractionSize || fractionSize < 0)
        fractionSize = 1;

      var abs = Math.abs(number);
      var rounder = Math.pow(10,fractionSize);
      var isNegative = number < 0;
      var key = '';
      var powers = [
        {key: "Q", value: Math.pow(10,15)},
        {key: "T", value: Math.pow(10,12)},
        {key: "B", value: Math.pow(10,9)},
        {key: "M", value: Math.pow(10,6)},
        {key: "Tsd.", value: 1000}
      ];

      for(var i = 0; i < powers.length; i++) {

        var reduced = abs / powers[i].value;

        reduced = Math.round(reduced * rounder) / rounder;

        if(reduced >= 1){
          abs = reduced;
          key = powers[i].key;
          break;
        }
      }

      return (isNegative ? '-' : '') + abs + key;
    }

  }
})();

/* global angular */
/**
 * @ngdoc controller
 * @name wageCalculator.contact.controller:ContactController
 * @description
 * # @TODO provide some docs
 *
 * @author Marius Schmidt <marius@denktmit.de>
 * @author Julian Schlarb <js@project-deadline.com>
 */
(function () {
  'use strict'; //NOSONAR

  angular.module('wageCalculator.contact')
    .controller('ContactController', ContactController);

  /** @ngInject */
  function ContactController($scope, $log, $stateParams, WageCalculationService, ContactMessageModel, toastr) {

    /**
     * @ngdoc property
     * @name vm
     * @propertyOf wageCalculator.contact.controller:ContactController
     * @description
     * Controller-wide representation of this controller instance
     */
    var vm = this;

    vm.params = $stateParams;

    /**
     * @ngdoc property
     * @name initialModel
     * @function
     * @description
     * # TODO describe this feature
     */
    var initialModel = function () {
      var validReasons = ContactMessageModel.schema.properties.contactReason.enum;
      var contactReason = (validReasons.indexOf($stateParams.contactReason) !== - 1)? $stateParams.contactReason : 'Sonstiges';
      return {
        'salutation': 'Herr',
        'contactReason': contactReason
      }
    };

    /**
     * @ngdoc property
     * @name schema
     * @propertyOf wageCalculator.survey.controller:ContactController
     * @description
     * # TODO describe this feature
     */
    vm.schema = ContactMessageModel.schema;

    /**
     * @ngdoc property
     * @name form
     * @propertyOf wageCalculator.survey.controller:ContactController
     * @description
     * # TODO describe this feature
     */
    vm.form = angular.copy(ContactMessageModel.form);

    /**
     * @ngdoc property
     * @name model
     * @propertyOf wageCalculator.survey.controller:ContactController
     * @description
     * # TODO describe this feature
     */
    vm.model = initialModel();

    /**
     * @ngdoc property
     * @name flash
     * @propertyOf wageCalculator.survey.controller:ContactController
     * @description
     * # TODO describe this feature
     */
    vm.flash = null;

    /**
     * @ngdoc property
     * @name reset
     * @function
     * @propertyOf wageCalculator.survey.controller:ContactController
     * @description
     * # TODO describe this feature
     */
    vm.reset = function () {
      if (vm.submitInProgress) {
        return;
      }
      vm.form = angular.copy(ContactMessageModel.form);
      vm.model = initialModel();
      $scope.$broadcast('schemaFormRedraw');
    };

    /**
     * Indicator to memorize, if a submit is on flight
     * @type {boolean}
     */
    vm.submitInProgress = false;

    /**
     * @ngdoc property
     * @name onSubmit
     * @function
     * @propertyOf wageCalculator.survey.controller:ContactController
     * @param {Event} $event
     * @description
     * # TODO describe this feature
     */
    vm.onSubmit = function ($event) {
      $event.preventDefault();
      if (vm.submitInProgress) {
        return;
      }
      vm.submitInProgress = true;

      // First we broadcast an event so all fields validate themselves
      $scope.$broadcast('schemaFormValidate');

      // Then we check if the form is valid
      if (vm.contactForm.$valid) {
        var contactMessage = ContactMessageModel.build(vm.model);
        WageCalculationService.sendContactMessage(contactMessage)
          .then(function (response) {
            toastr.success('Erfolgreich gesendet');
            vm.flash = response.link;
            vm.submitInProgress = false;
          })
          .catch(function (error) {
            toastr.error('Der Server ist im Moment nicht verfügbar, bitte versuchen Sie es erneut');
            $log.error(error);
            vm.submitInProgress = false;
          })
      } else {
        toastr.error('Das Formular ist unvollständig oder ungültig ausgefüllt');
        vm.submitInProgress = false;
      }
    }
  }
})();

/* global angular */
/**
 * @ngdoc controller
 * @name wageCalculator.survey.controller:SummaryOrderController
 * @description
 * # @TODO provide some docs
 *
 * @author Marius Schmidt <marius@denktmit.de>
 * @author Julian Schlarb <js@project-deadline.com>
 */
(function () {
  'use strict'; //NOSONAR

  angular.module('wageCalculator.survey')
    .controller('SummaryOrderController', SummaryOrderController);

  /** @ngInject */
  function SummaryOrderController($scope, $log, WageCalculationService, SummaryOrderModel, toastr) {

    /**
     * @ngdoc property
     * @name vm
     * @propertyOf wageCalculator.survey.controller:SummaryOrderController
     * @description
     * Controller-wide representation of this controller instance
     */
    var vm = this;

    /**
     * @ngdoc property
     * @name initialModel
     * @function
     * @description
     * # TODO describe this feature
     */
    var initialModel = function () {
      return {
        'salutation': 'Herr'
      }
    };

    /**
     * @ngdoc property
     * @name flash
     * @propertyOf wageCalculator.survey.controller:SummaryOrderController
     * @description
     * # TODO describe this feature
     */
    vm.flash = false;

    /**
     * @ngdoc property
     * @name schema
     * @propertyOf wageCalculator.survey.controller:SummaryOrderController
     * @description
     * # TODO describe this feature
     */
    vm.schema = SummaryOrderModel.schema;

    /**
     * @ngdoc property
     * @name form
     * @propertyOf wageCalculator.survey.controller:SummaryOrderController
     * @description
     * # TODO describe this feature
     */
    vm.form = angular.copy(SummaryOrderModel.form);

    /**
     * @ngdoc property
     * @name model
     * @propertyOf wageCalculator.survey.controller:SummaryOrderController
     * @description
     * # TODO describe this feature
     */
    vm.model = initialModel();

    /**
     * @ngdoc property
     * @name reset
     * @function
     * @propertyOf wageCalculator.survey.controller:SummaryOrderController
     * @description
     * # TODO describe this feature
     */
    vm.reset = function () {
      if (vm.submitInProgress) {
        return;
      }
      vm.form = angular.copy(SummaryOrderModel.form);
      vm.model = initialModel();
      $scope.$broadcast('schemaFormRedraw');
    };

    /**
     * Indicator to memorize, if a submit is on flight
     * @type {boolean}
     */
    vm.submitInProgress = false;

    /**
     * @ngdoc property
     * @name onSubmit
     * @function
     * @param {Event} $event
     * @propertyOf wageCalculator.survey.controller:SummaryOrderController
     * @description
     * # TODO describe this feature
     */
    vm.onSubmit = function ($event) {
      $event.preventDefault();
      if (vm.submitInProgress) {
        return;
      }
      vm.submitInProgress = true;

      // First we broadcast an event so all fields validate themselves
      $scope.$broadcast('schemaFormValidate');

      // Then we check if the form is valid
      if (vm.summaryOrderForm.$valid) {
        var summaryOrder = SummaryOrderModel.build(vm.model);
        WageCalculationService.sendSurveySummaryOrder(summaryOrder)
          .then(function (response) {
            toastr.success('Erfolgreich gesendet');
            vm.flash = response.link;
            vm.submitInProgress = false;
          })
          .catch(function (error) {
            toastr.error('Der Server ist im Moment nicht verfügbar, bitte versuchen Sie es erneut');
            $log.error(error);
            vm.submitInProgress = false;
          })
      } else {
        toastr.error('Das Formular ist unvollständig oder ungültig ausgefüllt');
        vm.submitInProgress = false;
      }
    }
  }
})();

/* global JsonRefs, angular */
/**
 * @ngdoc controller
 * @name wageCalculator.survey.controller:SurveyOrderController
 * @description
 * # @TODO provide some docs
 *
 * @author Marius Schmidt <marius@denktmit.de>
 * @author Julian Schlarb <js@project-deadline.com>
 */
(function () {
  'use strict'; //NOSONAR

  angular.module('wageCalculator.survey')
    .controller('SurveyOrderController', SurveyOrderController);

  /** @ngInject */
  function SurveyOrderController($scope, $log, WageCalculationService, SurveyOrderModel, toastr) {

    /**
     * @ngdoc property
     * @name vm
     * @propertyOf wageCalculator.survey.controller:SurveyOrderController
     * @description
     * Controller-wide representation of this controller instance
     */
    var vm = this;

    vm.page = {
      index: 0,
      flash: null
    }

    /**
     * @ngdoc property
     * @name initialModel
     * @function
     * @description
     * # TODO describe this feature
     */
    var initialModel = function () {
      return {
        invoiceAddress: {
          salutation: 'Herr'
        }
      }
    };

    /**
     * @ngdoc property
     * @name schema
     * @propertyOf wageCalculator.survey.controller:SurveyOrderController
     * @description
     * # TODO describe this feature
     */
    vm.schema = SurveyOrderModel.schema;

    JsonRefs.resolveRefs(SurveyOrderModel.schema).then(
      function (resolvedSchema) {
        vm.schema = resolvedSchema.resolved;
      }, function (err) {
        throw err;
      }
    );

    /**
     * @ngdoc property
     * @name form
     * @propertyOf wageCalculator.survey.controller:SurveyOrderController
     * @description
     * # TODO describe this feature
     */
    vm.form = angular.copy(SurveyOrderModel.form);

    /**
     * @ngdoc property
     * @name model
     * @propertyOf wageCalculator.survey.controller:SurveyOrderController
     * @description
     * # TODO describe this feature
     */
    vm.model = initialModel();

    /**
     * @ngdoc property
     * @name reset
     * @function
     * @propertyOf wageCalculator.survey.controller:SurveyOrderController
     * @description
     * # TODO describe this feature
     */
    vm.reset = function () {
      vm.form = angular.copy(SurveyOrderModel.form);
      vm.model = initialModel();
      vm.page = {
        index: 0,
        flash: null
      }
      $scope.$broadcast('schemaFormRedraw');
    };

    /**
     * @ngdoc property
     * @name onSubmit
     * @function
     * @param {Event} $event
     * @propertyOf wageCalculator.survey.controller:SurveyOrderController
     * @description
     * # TODO describe this feature
     */
    vm.onSubmit = function ($event) {
      $event.preventDefault();

      // Clear manual evaluation results
      $scope.$broadcast('schemaForm.error.deliveryAddress.salutation', 'deliveryAddressSalutationRequired', true);
      $scope.$broadcast('schemaForm.error.deliveryAddress.companyName', 'deliveryAddressCompanyNameRequired', true);
      $scope.$broadcast('schemaForm.error.deliveryAddress.name', 'deliveryAddressNameRequired', true);
      $scope.$broadcast('schemaForm.error.deliveryAddress.streetAndHouseNumberOrPostbox', 'deliveryAddressStreetAndHouseNumberOrPostboxRequired', true);
      $scope.$broadcast('schemaForm.error.deliveryAddress.zipCode', 'deliveryAddressZipCodeRequired', true);
      $scope.$broadcast('schemaForm.error.deliveryAddress.city', 'deliveryAddressCityRequired', true);
      $scope.$broadcast('schemaForm.error.deliveryAddress.country', 'deliveryAddressCountryRequired', true);

      // First we broadcast an event so all fields validate themselves
      $scope.$broadcast('schemaFormValidate');

      // Workaround for bug https://github.com/json-schema-form/angular-schema-form/issues/649
      if (vm.model.hasDifferingDeliveryAddress === true) {
        if (angular.isUndefined(vm.model.deliveryAddress) || vm.model.deliveryAddress === null) {
          vm.model.deliveryAddress = {
            salutation: null,
            companyName: null,
            name: null,
            streetAndHouseNumberOrPostbox: null,
            zipCode: null,
            city: null,
            country: null
          };
        }
        if (vm.model.deliveryAddress.salutation === null) {
          $scope.$broadcast('schemaForm.error.deliveryAddress.salutation', 'deliveryAddressSalutationRequired', '&nbsp;Pflichtfeld');
        }
        if (vm.model.deliveryAddress.companyName === null) {
          $scope.$broadcast('schemaForm.error.deliveryAddress.companyName', 'deliveryAddressCompanyNameRequired', '&nbsp;Pflichtfeld');
        }
        if (vm.model.deliveryAddress.name === null) {
          $scope.$broadcast('schemaForm.error.deliveryAddress.name', 'deliveryAddressNameRequired', '&nbsp;Pflichtfeld');
        }
        if (vm.model.deliveryAddress.streetAndHouseNumberOrPostbox === null) {
          $scope.$broadcast('schemaForm.error.deliveryAddress.streetAndHouseNumberOrPostbox', 'deliveryAddressStreetAndHouseNumberOrPostboxRequired', '&nbsp;Pflichtfeld');
        }
        if (vm.model.deliveryAddress.zipCode === null) {
          $scope.$broadcast('schemaForm.error.deliveryAddress.zipCode', 'deliveryAddressZipCodeRequired', '&nbsp;Pflichtfeld');
        }
        if (vm.model.deliveryAddress.city === null) {
          $scope.$broadcast('schemaForm.error.deliveryAddress.city', 'deliveryAddressCityRequired', '&nbsp;Pflichtfeld');
        }
        if (vm.model.deliveryAddress.country === null) {
          $scope.$broadcast('schemaForm.error.deliveryAddress.country', 'deliveryAddressCountryRequired', '&nbsp;Pflichtfeld');
        }
      }

      // Then we check if the form is valid
      if (vm.summaryOrderForm.$valid) {
        vm.page = {
          index: 1,
          data: SurveyOrderModel.build(vm.model)
        }
      } else {
        toastr.error('Das Formular ist unvollständig oder ungültig ausgefüllt');
      }
    };

    vm.backToPageOne = function () {
      if (vm.submitInProgress) {
        return;
      }
      vm.page = {
        index: 0,
        data: null
      }
    };

    /**
     * Indicator to memorize, if a submit is on flight
     * @type {boolean}
     */
    vm.submitInProgress = false;

    vm.doOrder = function ($event) {
      $event.preventDefault();
      if (vm.submitInProgress) {
        return;
      }
      vm.submitInProgress = true;

      WageCalculationService.sendSurveyOrder(vm.page.data)
        .then(function (response) {
          toastr.success('Erfolgreich gesendet');
          vm.page = {
            index: 2,
            data: response.link
          };
          vm.submitInProgress = false;
        })
        .catch(function (error) {
          toastr.error('Der Server ist im Moment nicht verfügbar, bitte versuchen Sie es erneut');
          $log.error(error);
          vm.submitInProgress = false;
        })
    }
  }
})();

angular.module("wageCalculator").run(["$templateCache", function($templateCache) {$templateCache.put("app/shared/footer/footer.html","<div class=\"container-fluid footer\"><!-- Footer-Wrapper --><div class=container><!-- Footer --><nav><div class=\"row footer\"><div class=col-lg-12><p>&copy; Copyright 2017-2024 <a href=http://www.callidus-energie.de target=_blank class=footer-link>Callidus Energie GmbH</a>, Frankfurt am Main<br><small><a ui-sref=terms_and_conditions ui-sref-active=active class=footer-link>AGB und Nutzungsbedingungen</a>&nbsp; <a ui-sref=data_privacy ui-sref-active=active class=footer-link>Datenschutz</a>&nbsp; <a ui-sref=contact ui-sref-active=active class=footer-link>Kontakt</a>&nbsp; <a ui-sref=legal_information ui-sref-active=active class=footer-link>Impressum</a></small></p></div></div></nav><!-- End Footer --></div><!-- End Footer-Wrapper --></div>");
$templateCache.put("app/shared/navBar/navBar.html","<div class=container><!-- Header --><div class=\"row header\"><!-- Logo--><div class=col-lg-4><div class=logo><object type=image/svg+xml data=/assets/images/Callidus-WfH_Logo_Web.svg><a ui-sref=finalcalculator><img src=/assets/images/Callidus-WfH_Logo_Web_1191px.png alt=Logo></a></object></div></div><!-- End Logo--><!-- Brand and toggle get grouped for better mobile display --><div class=\"navbar-default navbar-header\"><button type=button class=navbar-toggle ng-click=navBar.toggleNavbar()><span class=sr-only>Auswahl</span> <span class=icon-bar></span> <span class=icon-bar></span> <span class=icon-bar></span></button></div><!-- https://angular-ui.github.io/bootstrap/ --><!-- Main Nav --><div class=col-lg-8><div class=\"collapse navbar-collapse navbar-default\" uib-collapse=!navBar.isNavbarOpen><ul class=\"nav navbar-nav\"><!-- <nav class=\"navbar navbar-default\" id=\"page-top\" role=\"navigation\">\n            <ul class=\"nav navbar-nav navbar-right\"> --><li ui-sref-active=active><a ui-sref=finalcalculator>Vergütungsrechner</a></li><!-- <li ui-sref-active=\"active\"><a ui-sref=\"survey\">Studie</a></li> --><!-- <li ui-sref-active=\"active\"><a ui-sref=\"interview_dahlke\">Interviews</a></li> --><li ui-sref-active=active><a ui-sref=faq>FAQ</a></li><li ui-sref-active=active><a ui-sref=contact>Kontakt</a></li></ul></div><!-- End Main Nav --></div></div><!-- End Header-Wrapper --></div>");
$templateCache.put("app/shared/schemaFormGRecaptchaInput/gRecaptcha.html","<div class=\"form-group schema-form-{{form.type}} {{form.htmlClass}}\" ng-class=\"{\'has-error\': hasError()}\"><div ng-show=form.key step=any sf-changed=form class={{form.fieldHtmlClass}} id={{form.key.slice(-1)[0]}} ng-model-options=form.ngModelOptions ng-model=$$value$$ ng-disabled=form.readonly schema-validate=form name={{form.key.slice(-1)[0]}} vc-recaptcha aria-describedby=\"{{form.key.slice(-1)[0] + \'Status\'}}\"></div><span ng-if=\"hasError() || hasSuccess()\" id=\"{{form.key.slice(-1)[0] + \'Status\'}}\" class=sr-only>{{ hasSuccess() ? \'(success)\' : \'(error)\' }}</span><div class=\"help-block has-error\" ng-if=hasError()>Das Captcha muss ausgefüllt sein</div></div>");
$templateCache.put("app/components/static/view/data_privacy.html","<div class=row><!-- Content 12col von 12--><div class=\"col-lg-8 col-lg-push-2 lastBlock\"><h1>Datenschutzerklärung</h1><p><strong>veröffentlich am 08.05.2018</strong></p><p>Vielen Dank für Ihren Besuch unserer Webseite. Für Callidus Energie ist der Schutz und die Vertraulichkeit Ihrer Daten von besonderer Bedeutung.</p><p>Im Folgenden informieren wir Sie über die Verarbeitung personenbezogener Daten im Zusammenhang mit den Leistungen, die wir unter www.callidus-energie.de oder anderen Webseiten, die diese Datenschutzerklärung einbinden, anbieten. Personenbezogene Daten sind alle Informationen, die sich auf eine identifizierte oder identifizierbare natürliche Person beziehen (Art. 4 Nr. 1 DSGVO). Darunter fallen Informationen wie Ihr Name, Ihre E-Mail-Adresse, Ihre Postanschrift oder Ihre Telefonnummer. Informationen, die nicht direkt mit Ihrer Identität in Verbindung gebracht werden, wie z. B. die Anzahl der Nutzer einer Internetpräsenz, fallen nicht hierunter.</p><h2>1. Wer ist verantwortlich für die Verarbeitung Ihrer personenbezogenen Daten?</h2><p>Der Verantwortliche (im Folgenden als „Callidus Energie“ oder „wir“ bezeichnet) im Sinne der Datenschutz-Grundverordnung und anderer nationaler Datenschutzgesetze der Mitgliedsstaaten sowie sonstiger datenschutzrechtlicher Bestimmungen ist die:</p><p>Ron-Arne Sydow<br>Callidus Energie GmbH<br>Mainzer Landstraße 47<br>60329 Frankfurt am Main<br>Deutschland</p><p>erreichbar per Telefon unter 0049 69 401 507 420<br>und per E-Mail: r.sydow@callidus-energie.de</p><h2>2. Zwecke und Rechtsgrundlagen der Verarbeitungen sowie Dauer der Speicherung</h2><p>Im Folgenden informieren wir Sie über die verschiedenen Zwecke, zu denen wir personenbezogene Daten verarbeiten, auf welcher Rechtsgrundlage eine solche Verarbeitung jeweils erfolgt und wie lange wir die Daten dabei speichern.</p><p>Soweit wir für Verarbeitungsvorgänge personenbezogener Daten eine Einwilligung der betroffenen Person einholen, dient Art. 6 Abs. 1 lit. a EU-Datenschutzgrundverordnung (DSGVO) als Rechtsgrundlage für die Verarbeitung personenbezogener Daten. Bei der Verarbeitung von personenbezogenen Daten, die zur Erfüllung eines Vertrages, dessen Vertragspartei die betroffene Person ist, erforderlich ist, dient Art. 6 Abs. 1 lit. b DSGVO als Rechtsgrundlage. Dies gilt auch für Verarbeitungsvorgänge, die zur Durchführung vorvertraglicher Maßnahmen erforderlich sind. Soweit eine Verarbeitung personenbezogener Daten zur Erfüllung einer rechtlichen Verpflichtung erforderlich ist, der unser Unternehmen unterliegt, dient Art. 6 Abs. 1 lit. c DSGVO als Rechtsgrundlage. Ist die Verarbeitung zur Wahrung eines berechtigten Interesses unseres Unternehmens oder eines Dritten erforderlich und überwiegen die Interessen, Grundrechte und Grundfreiheiten des Betroffenen das erstgenannte Interesse nicht, so dient Art. 6 Abs. 1 lit. f DSGVO als Rechtsgrundlage für die Verarbeitung.</p><p>Die personenbezogenen Daten der betroffenen Person werden gespeichert, solange der jeweilige Zweck andauert.</p><h2>3. Datenverarbeitungen bei allgemeiner Nutzung unserer Plattformen und unserer Leistungen</h2><h3>3.1 Allgemeiner Zugriff auf unsere Plattformen</h3><p>Bei jedem Aufruf unserer Plattformen erfassen wir automatisiert Daten und Informationen des aufrufenden Gerätes und speichern diese Daten und Informationen in den Logfiles des Servers. Erfasst werden können die</p><ol><li>verwendeten Browsertypen und Versionen;</li><li>das vom zugreifenden System verwendete Betriebssystem;</li><li>die Internetseite, von welcher ein zugreifendes System auf unsere Internetseite gelangt (sogenannte Referrer);</li><li>die Unterwebseiten, welche über ein zugreifendes System auf unserer Internetseite angesteuert werden;</li><li>das Datum und die Uhrzeit eines Zugriffs auf die Internetseite;</li><li>eine Internet-Protokoll-Adresse (IP-Adresse);</li><li>der Internet-Service-Provider des zugreifenden Systems und</li><li>sonstige ähnliche Daten und Informationen, die der Gefahrenabwehr im Falle von Angriffen auf unsere informationstechnologischen Systeme dienen.</li></ol><p>Zu Sicherheitszwecken, das heißt, um im Fall von Angriffen auf unsere Plattformen den Angriff nachvollziehen zu können, speichern wir diese Daten einschließlich der IP-Adresse für einen Zeitraum von 14 Tagen und anonymisieren danach die IP Adressen oder löschen die Daten. Die IP-Adresse wird während der Verbindung benötigt, um die Inhalte unserer Plattform an Ihren Browser zu übertragen. Rechtsgrundlage für die Verarbeitung und die folgende Speicherung der IP-Adresse ist ein berechtigtes Interesse gemäß Art. 6 Abs. 1 f DS-GVO. Das berechtigte Interesse im Hinblick auf die Übermittlung der IP-Adresse liegt darin, dass diese zur Anzeige der Inhalte der Plattform erforderlich ist; ohne Übermittlung der IP-Adresse ist eine Anzeige der Webseite nicht möglich. Das berechtigte Interesse an der begrenzten Speicherung sind unsere Sicherheitsinteressen.</p><h3>3.2 Bewerbungsformular</h3><p>Wenn wir auf unseren Plattformen ein Bewerbungsformular für auf unseren Plattformen veröffentlichte Stellenanzeigen bereitstellen, und Sie dieses ausfüllen, ohne in ihren Callidus Energie Account eingeloggt zu sein und den Knopf zum Senden der Bewerbung klicken, übermitteln wir die Angaben, die Sie in das Bewerbungsformular eingegeben haben, an den Anbieter, der die Anzeige bei uns geschaltet hat. Rechtsgrundlage ist Ihre Einwilligung nach Art. 6 Abs. 1 S. 1 DSGVO.</p><h3>3.3 Newsletter</h3><p>Wenn Sie sich für einen Newsletter registrieren, nutzen wir Ihre E-Mail-Adresse zum Versand des jeweiligen Newsletters, in dem wir Sie regelmäßig zu interessanten Themen informieren. Um Ihre ordnungsgemäße Anmeldung zum Newsletter sicherzustellen, das heißt, um unautorisierte Anmeldungen im Namen Dritter zu verhindern, werden wir Ihnen nach Ihrer erstmaligen Newsletteranmeldung im Double-Opt-In-Verfahren eine Bestätigungs-E-Mail senden, in der wir um Bestätigung der Registrierung bitten. Rechtsgrundlage ist Ihre Einwilligung nach Art. 6 Abs. 1 S. 1 a DSGVO. Im Zusammenhang mit Ihrer Newsletteranmeldung speichern wir außerdem Ihre IP-Adresse und Datum sowie Uhrzeit der Anmeldung und der Bestätigung, damit wir zu einem späteren Zeitpunkt die Anmeldung nachvollziehen und beweisen können. Rechtsgrundlage für diese Speicherung ist ein berechtigtes Interesse im Sinne Art. 6 Abs. 1 lit. f DSGVO, wobei das berechtigte Interesse die Nachweismöglichkeit der Anmeldung ist. Wir speichern Ihre E-Mail-Adresse, um Ihnen den Newsletter zu senden, bis Sie sich abmelden oder wir das Senden des Newsletters an Sie beenden. Sie können jederzeit sämtlichen Arten von Newslettern von Callidus Energie widersprechen, ohne dass hierfür andere als die Übermittlungskosten nach den Basistarifen (d.h. bspw. die Kosten Ihres Internetproviders) entstehen.</p><h3>3.4 Werbewidersprüche</h3><p>Erhalten wir von Ihnen einen Widerspruch gegen Werbezwecke, können wir Ihre personenbezogenen Kontaktdaten (Name, Anschrift, Telefonnummer, Faxnummer, E-Mail-Adresse) in eine Sperrliste aufnehmen, mit deren Hilfe wir sicherstellen, dass wir Ihnen keine unerwünschte Werbung mehr übermitteln. Rechtsgrundlage ist ein berechtigtes Interesse im Sinne Art. 6 Abs. 1 lit. f DSGVO, wobei das berechtigte Interesse darin besteht, dass wir unseren Pflichten aus Ihrem Werbewiderspruch nachkommen können. Die Daten werden für diesen Zweck solange gespeichert, bis Sie den Werbewiderspruch ausdrücklich schriftlich widerrufen.</p><h3>3.5 Kontaktformular und E-Mail-Kontakt</h3><p>Auf unseren Plattformen sind Kontaktformulare vorhanden, welche für die elektronische Kontaktaufnahme genutzt werden können. Durch das Klicken des „Senden“-Buttons willigen Sie in die Übermittlung der in der Eingabemaske eingegeben Daten an uns ein. Zusätzlich speichern wir Datum und Uhrzeit Ihrer Kontaktaufnahme. Alternativ ist eine Kontaktaufnahme über die bereitgestellte E-Mail-Adresse möglich. In diesem Fall werden die mit der E-Mail übermittelten personenbezogenen Daten des Nutzers und unsere Antwort gespeichert. Die in diesem Zusammenhang freiwillig an uns übermittelten personenbezogenen Daten dienen uns zur Bearbeitung Ihrer Anfrage und zur Kontaktaufnahme mit Ihnen. Rechtsgrundlage für die Übermittlung der Daten ist Art. 6 Abs. 1 lit. a DSGVO. Wir nutzen die Daten für diesen Zweck, bis die jeweilige Konversation mit Ihnen beendet ist. Beendet ist die Konversation dann, wenn sich aus den Umständen entnehmen lässt, dass der betroffene Sachverhalt abschließend geklärt ist.</p><h3>3.6 Callidus Energie Umfragen</h3><p>Von Zeit zu Zeit veranstaltet Callidus Energie Marktforschungsumfragen. Im Rahmen dieser Umfragen werden wir keine personenbezogenen Daten erheben. Jedoch können wir am Ende der Umfrage anbieten, dass Sie an einem Gewinnspiel teilnehmen. Um am Gewinnspiel teilzunehmen, müssen Sie Ihre E-Mail-Adresse angeben und wir werden diese ausschließlich zu dem Zweck des Gewinnspiels nutzen, um Sie im Gewinnfalle zu informieren. Insbesondere werden wir Ihre E-Mail-Adresse vollständig unabhängig von Ihren Antworten zu der Umfrage speichern. Rechtsgrundlage für die Speicherung Ihrer E-Mail-Adresse ist Ihre Einwilligung nach Art. 6 para. 1 lit. a DSGVO. Wir speichern Ihre E-Mail-Adresse zu diesem Zweck bis zur Beendigung des Gewinnspiels.</p><h3>3.7 Callidus Energie Gehaltsrechner</h3><p>Callidus Energie bietet unter www.verguetung-energie.de einen Gehaltsplaner an. Dabei vergleicht Callidus Energie im Rahmen des Gehaltsplaners die von Nutzern eingegebenen Angaben zu deren aktueller beruflichen Situation, zum Gehalt, zur Berufserfahrung, zur Ausbildung, zum Alter und Geschlecht des Nutzers mit Daten anderer Nutzer in einer aggregierten, statistischen Datenbank und wertet diesen Vergleich aus, um auf dieser Basis einen Gehaltsvergleich für den Nutzer zu erstellen. Nach Eingabe der vorstehenden Angaben und Eingabe einer E-Mail-Adresse wird Callidus Energie dem Nutzer per Double-Opt-In-E-Mail einen Zugang zum Gehaltvergleich übersenden. Diese Verarbeitung erfolgt auf Grundlage Ihrer Einwilligung. Die Einwilligung erfolgt, indem Sie den Button zum Zusenden des persönlichen Gehaltsplaners anklicken. Wir speichern den für Sie erstellten Gehaltsvergleich für einen Zeitraum von 5 Jahren. Die Erbringung des Gehaltsplaners ist uns nur möglich, wenn wir die Angaben aller Nutzer statistisch auch für andere Nutzer auswerten können. Daher erfassen wir für die Erstellung des Gehaltsvergleichs nach Ziff. 3. a die von Ihnen getätigten Angaben nach Ziff. 3.a in einer statistischen Datenbank. Dabei speichern wir keinerlei Daten, die wir unmittelbar in Verbindung mit Ihrer Person bringen könnten, insbesondere speichern wir nicht Ihre E-Mail-Adresse in dieser Datenbank. Diese Verarbeitung erfolgt, weil sie zur Wahrung berechtigter Interessen von Callidus Energie erforderlich ist, nämlich den Gehaltsplaner anzubieten, und keine Ihrer Interessen oder Grundrechte und Grundfreiheiten, die den Schutz personenbezogener Daten erfordern, überwiegen.</p><h3>3.8 Einschaltung von Auftragsverarbeitern für das Hosting und Plattformsicherheit, administrative, Fehlerbehebungs- und Supportleistungen</h3><p>Zur Erbringung unserer Leistungen nutzen wir Auftragsverarbeiter, die wir im Folgenden aufführen. Die Rechtsgrundlage für die Nutzung dieser Auftragsverarbeiter ist ein berechtigtes Interesse nach Art. 6 para. 1 lit. f GDPR. Das berechtigte Interesse besteht in der Verfolgung unserer Geschäftszwecke, insbesondere zur Erbringung der im Übrigen in dieser Datenschutzerklärung beschriebenen Leistungen. Ein entgegenstehendes Interesse ist nicht ersichtlich, weil wir mit den jeweiligen Auftragnehmern einen Vertrag nach Art. 28 DSGVO abgeschlossen haben.</p><h4>3.8.1 Hosting</h4><p>Für Zwecke des Hostings unserer Plattformen und Back-Up Leistungen nutzen wir Auftragsverarbeiter, so dass personenbezogene Daten, die auf unseren Plattformen gespeichert werden, an diese Auftragsverarbeiter übermittelt werden. Diese Auftragsverarbeiter sind Host Europe GmbH, Hansestraße 111, 51149 Köln, sowie Amazon Webservices, Inc., 410 Terry Drive Ave North, WA 98109-5210 Seattle, USA. sowie Microsoft Corporation, One Microsoft Way, Redmond, WA 98052-6399, USA. Diese Auftragsverarbeiter werden personenbezogene Daten für die Dauer speichern, wie die Daten auf Basis der in dieser Datenschutzerklärung definierten Zwecke auf unseren Plattformen gespeichert werden. Amazon Webservices Inc. und Microsoft Corporation sind unter dem Privacy-Shield-Abkommen zertifiziert und bieten hierdurch eine Garantie, das europäische Datenschutzrecht einzuhalten.</p><h4>3.8.2 Projektverwaltung</h4><p>Für die Speicherung von Informationen zu Kunden, Kandidaten und Projekten, verwenden wir ein CRM-System. Dieser Auftragsverarbeiter ist Bullhorn Inc. 100 Summer Street, 17th floor, Boston, MA, USA. Personenbezogene Daten werden für die Dauer gespeichert, wie die Daten auf Basis der in dieser Datenschutzerklärung definierten Zwecke auf unseren Plattformen gespeichert werden. Bullhorn Inc. ist unter dem Privacy-Shield-Abkommen zertifiziert und bietet hierdurch eine Garantie, das europäische Datenschutzrecht einzuhalten.</p><h4>3.8.2 Versand von E-Mails und anderen Nachrichten</h4><p>Zum Versand von E-Mails und Nachrichten auf anderen elektronischen Kanälen nutzen wir im Rahmen einer Auftragsverarbeitung Dienste der Microsoft Corporation, One Microsoft Way, Redmond, WA 98052-6399, USA. Die Dienste können dementsprechend Ihre personenbezogenen Daten im Rahmen der mit uns bestehenden Auftragsverarbeitung empfangen. Die Speicherung dort erfolgt für die Dauer, für die ansonsten eine Speicherung für Zwecke nach dieser Datenschutzerklärung rechtmäßig ist, das heißt insbesondere für die im Rahmen von mit Ihnen bestehenden Verträgen zur vertraglichen Kommunikation oder im Übrigen zur werblichen Kommunikation. Microsoft Corp. ist unter dem Privacy-Shield-Abkommen zertifiziert und bietet hierdurch eine Garantie, das europäische Datenschutzrecht einzuhalten.</p><h4>3.8.4 Google reCAPTCHA</h4><p>Wir nutzen auf Grundlage unserer berechtigten Interessen (d.h. Interesse an der Korrektheit von Daten, Vermeidung von automatischen Registrierungen / Bestellungen durch sogenannte Bots und wirtschaftlichem Betrieb unseres Onlineangebotes im Sinne des Art. 6 Abs. 1 lit. f) DSGVO) in bestimmten Fällen den reCAPTCHA Dienst https://www.google.com/recaptcha/intro/ der Google Inc., 1600 Amphitheatre Parkway, Mountain View, CA 94043, USA, („Google“). Google ist unter dem Privacy-Shield-Abkommen zertifiziert und bietet hierdurch eine Garantie, das europäische Datenschutzrecht einzuhalten.</p><h4>3.8.5 Cookies und ähnliche Technologien</h4><p>Wir nutzen in unseren Webseiten Cookies. Cookies sind Textdateien, welche über einen Internetbrowser auf einem Computersystem abgelegt und gespeichert werden. Solche Cookies nutzen wir sowohl als technisches Mittel zur Erbringung von Leistungen auf unseren Plattformen als auch zur Analyse des Webseitenverhaltens unserer Besucher und darauf aufbauend der nutzergerechteren Gestaltung unserer Angebote. Zu diesem Zweck können wir auch andere Techniken, wie Tracking-Pixel oder einen Code in Apps einsetzen. Außerdem können wir diese Cookies oder andere Techniken auch nutzen, um Ihnen zielgerichtet für Sie interessante Stellenanzeigen und andere Inhalte zu übermitteln. Der besseren Übersichtlichkeit halber haben wir die Informationen zu Cookies und ähnlichen Techniken in den Abschnitt 4 dieser Datenschutzerklärung ausgelagert. Genauere Einzelheiten finden Sie dort.</p><h2>4. Datenverarbeitungen bei Nutzung eines Jobagenten oder eines Callidus Energie Account</h2><p>Callidus Energie bietet Ihnen zu Ihrer Karriereentwicklung unterschiedliche Dienste an. Callidus Energie hat als Ihr Karrierebegleiter im Internet das Ziel, Sie in allen Phasen Ihres Berufslebens zu unterstützen. Hierzu kann insbesondere ein Jobagent abonniert und ein Callidus Energie Account erstellt werden, in deren Rahmen wir personenbezogene Daten verarbeiten. In diesem Abschnitt 3.2 informieren wir Sie über die Zwecke, die jeweilige Rechtsgrundlage sowie über die Speicherdauer dieser Verarbeitungen.</p><h3>4.1 Jobagent</h3><p>Zum einen bieten wir Ihnen den Abschluss eines Vertrages über den Erhalt eines Jobagenten an. Zweck der Datenverarbeitungen im Rahmen eines Jobagenten ist, dass wir Ihnen regelmäßige E-Mails zu offenen Stellen, die einem von Ihnen vordefinierten Profil entsprechen bzw. Ihnen auf Basis Ihres Nutzungsverhaltens bei uns empfohlen werden, senden. Einzelheiten zum Jobagenten können Sie unseren Nutzungsbedingungen entnehmen. Rechtsgrundlage ist dabei Art. 6 Abs. 1 lit. b DSGVO. Wir speichern die Daten im Rahmen eines Vertrages über die Nutzung des Jobagenten für die Dauer der Vertragslaufzeit, d.h. bis Sie oder wir Ihren Jobagenten kündigen.</p><h3>4.2 Callidus Energie Account</h3><p>Zum anderen bieten wir Ihnen den Abschluss eines Vertrages über ein Callidus Energie Account an, in dessen Rahmen Sie weitere Funktionen nutzen und so den Umfang der vertraglichen Nutzung definieren können. Zwecke der im Rahmen dieses Vertrages erfolgenden Datenverarbeitungen sind, dass:</p><ol><li>wir für Sie die durch Sie über unsere Plattformen durchgeführten Bewerbungen in Ihrem Callidus Energie Account speichern, die Speicherung erfolgt solange, bis Sie eine gespeicherte Bewerbung löschen;</li><li>Sie in Ihrem Callidus Energie Account einzelne Stellenanzeigen abspeichern können;</li><li>Sie zusätzliche Funktionalitäten eines Jobagenten (s. 3.2.1) nutzen können;</li><li>Sie Callidus Energie E-Mail-Newsletter verwalten können;</li><li>Sie im Rahmen des Vertrages über ihr Callidus Energie Account ein Callidus Energie Profil erstellen können. Welche personenbezogenen Daten dabei an uns übermittelt werden, ergibt sich aus Ihren jeweiligen Uploads oder Ihren Eingaben in die entsprechenden Eingabefelder. Eventuelle hochgeladene Dokumente werden wir nach Struktur und Inhalt automatisiert analysieren, um unsere Dienste für Sie zu optimieren. Sie können den Umfang der vertraglichen Nutzung dieses Profils so definieren, dass Sie sich mit diesem entweder nur auf offene Stellenausschreibungen bewerben können (auch bei Chiffre-Bewerbungen), oder es außerdem teilweise oder vollständig potenziellen Arbeitgebern, die die als Callidus Energie Kunden die Callidus Energie-Lebenslaufdatenbank oder ähnliche Produkte nutzen, zugänglich machen, wobei wir im letzteren Fall auch Ihre Profildaten auch nutzen können, um öffentlich zugängliche berufsbezogene Social-Media-Profile zu finden und mit Ihrem Profil zu verknüpfen. Wir speichern Ihr Profil, bis Sie es löschen oder der Vertrag über Ihren Callidus Energie Account endet. Bitte beachten Sie, dass, soweit Sie Ihr Profil potenziellen Arbeitgebern zugänglich machen, der jeweilige potenzielle Arbeitgeber möglicherweise nicht seinen Sitz in der EU oder dem EWR hat. Das bedeutet, dass es im Rahmen des zwischen Ihnen und uns bestehenden Vertrages erforderlich sein kann, dass daraus aus einem Land zugegriffen wird, in dem ein datenschutzrechtlich geringeres Schutzniveau als in der EU bzw. dem EWR besteht.</li><li>Wenn Sie ein Profil angelegt haben und ein auf unseren Plattformen bereitgestelltes Bewerbungsformular für auf unseren Plattformen veröffentlichte Stellenanzeigen aufrufen, nutzen wir Ihre Profildaten, um dieses Formular vorauszufüllen und werden, wenn Sie den Button zum Senden der Bewerbung klicken, dem Anbieter, der die betreffende Anzeige bei uns veröffentlicht hat, Ihre im Formular erfassten Daten übermitteln und ihm außerdem Ihr Profil offenlegen. Bitte beachten Sie auch hier, dass der jeweilige Anbieter seinen Sitz möglicherweise nicht in der EU bzw. dem EWR hat, so dass es im Rahmen des zwischen Ihnen und uns bestehenden Vertrages erforderlich ist, die Daten in ein Land übermitteln, bzw. dass auf Ihr Profil aus einem Land zugegriffen werden kann, in dem ein datenschutzrechtlich geringeres Schutzniveau als in der EU bzw. dem EWR besteht.</li></ol><p>Im Zusammenhang mit der Registrierung eines Callidus Energie Accounts und der Einstellung der verschiedenen Funktionen speichern wir ferner Ihre jeweilige IP-Adresse und das Datum sowie die Uhrzeit zum Zeitpunkt der Registrierung oder Einstellung der Funktionen. Rechtsgrundlage für die Speicherung und Nutzung Ihrer personenbezogenen Daten im Zusammenhang mit Ihrem Callidus Energie Account ist Art. 6 Abs. 1 lit. b DSGVO.</p><p>Wir speichern Ihre personenbezogenen Daten so lange, wie dies zur Erbringung der vertraglich vereinbarten Leistung erforderlich ist. Die von Ihnen in Ihrem „Callidus Energie“ Account hinterlegten personenbezogenen Daten stehen Ihnen dabei für die Dauer der Vertragslaufzeit zur Verfügung und werden von uns für diese Dauer gespeichert. Die personenbezogenen Daten werden gelöscht, wenn Sie dies in Bezug auf einzelne Daten selber tun oder uns entsprechend darum bitten oder wenn der Vertrag endet, also wenn Sie oder wir den Vertrag kündigen.</p><p>Außerdem nutzen wir von Ihnen im Rahmen eines Profils eingestellte Informationen, um mit Hilfe eines statistischen Modells die Jobsuche und die Jobempfehlungen für Sie und andere Nutzer unserer Plattformen zu optimieren. Hierzu verwenden wir in dem statistischen Modell bestimmte aus sich heraus und auch in Kombination untereinander nicht personenbeziehbare Angaben aus Ihrem Profil sowie eine pseudonymisierte Nutzerkennung. Mit dieser allein kann aus dem statistischen Modell heraus kein Bezug auf Ihre Person hergestellt werden, ein solcher ist lediglich von außen möglich durch Pseudonymisierung der Ihrem Callidus Energie Account zugeordneten Nutzerkennung und dann folgenden Abgleich mit der im statistischen Modell gespeicherten pseudonymisierten Nutzerkennung. Soweit wir mit dem statistischen Modell für Sie die Jobsuche und die Jobempfehlungen optimieren, erfolgt dies im Rahmen Ihres Vertrages über den Callidus Energie Account auf der Rechtsgrundlage des Art. 6 Abs. 1 lit. b DSGVO. Soweit wir die Daten nutzen, um unser statistisches Modell und damit auch Leistungen für andere Nutzer generell zu verbessern, erfolgt dies auf Basis eines berechtigten Interesses nach Art. 6 Abs. 1 lit. f DSGVO. Mit Löschung Ihres Callidus Energie Accounts werden Ihre Daten im statistischen Modell vollständig anonymisiert, da die darin gespeicherte pseudonymisierte Nutzerkennung dann keinerlei Bezug mehr zu Ihrem Callidus Energie Account ermöglicht. Unser berechtigtes Interesse besteht dabei in der Verfolgung unserer Geschäftsinteressen auf Verbesserung unserer Leistungen. Ein entgegenstehendes Interesse ist nicht erkennbar, da während der Vertragslaufzeit über das Callidus Energie Account die Daten bereits zur vertragsgemäßen Leistung erforderlich sind und nach Vertragsende eine Identifizierung nicht mehr möglich ist.</p><h2>5. Datenverarbeitungen über Unternehmer oder Mitarbeiter von Unternehmen</h2><p>Unsere Dienste für Stellenanbieter zielen darauf ab, Unternehmern und Unternehmen eine möglichst große Auswahl geeigneter Kandidaten anbieten zu können. Dabei verarbeiten wir personenbezogene Daten von Unternehmern (es handelt sich bei auf Unternehmer bezogenen Daten nur dann um personenbezogene Daten, wenn der Unternehmer eine natürliche Person ist) oder von Mitarbeitern von Unternehmen. Die jeweiligen Unternehmen bzw. Unternehmer können in einer vertraglichen bzw. vorvertraglichen Beziehung mit uns stehen, in einzelnen Fällen können wir jedoch auch Daten von Unternehmen und ihren Mitarbeitern verarbeiten, wenn keine solche vor-/vertragliche Beziehung besteht. In diesem Abschnitt 3.3 informieren wir Sie über die Zwecke, die jeweilige Rechtsgrundlage sowie über die Speicherdauer dieser Verarbeitungen von Unternehmern bzw. Unternehmensmitarbeitern sowie die Datenkategorien, soweit wir die personenbezogenen Daten nicht bei der betroffenen Person erheben. Die Daten werden gelöscht, sobald Sie für die Erreichung des jeweiligen Zwecks nicht mehr erforderlich sind, das heißt, kein Vertrag mehr mit den Kunden besteht und wir auch nicht mehr beabsichtigen, einen Vertrag mit dem jeweiligen Kunden einzugehen, kein berechtigtes Interesse mehr besteht und wir im Übrigen auch nicht mehr verpflichtet sind, Unterlagen aufzubewahren, in denen personenbezogene Daten enthalten sein können.</p><h3>5.1 Datenverarbeitungen für Zwecke der Vertragsverwaltung und -vorbereitung</h3><p>Wir verarbeiten personenbezogene Daten zum Zwecke der Vertragsverwaltung, das heißt, damit wir unseren Kunden die vertragsgegenständlichen Leistungen erbringen können sowie zum Zwecke entsprechender Vertragsvorbereitungen. Handelt es sich beim Kunden um eine natürliche Person ist Rechtsgrundlage, dass die Verarbeitung für die Erfüllung eines Vertrags, oder zur Durchführung vorvertraglicher Maßnahmen gemäß Art. 6 Abs. 1 S. 1 b DSGVO erforderlich ist. Verarbeiten wir personenbezogene Daten von Mitarbeitern des Kunden ist Rechtsgrundlage ein berechtigtes Interesse nach Art. 6 Abs. 1 S. 1 f DSGVO. Das berechtigte Interesse liegt in der Durchführung unserer Geschäftstätigkeit und der des Kunden. Ein entgegenstehendes Interesse des jeweils Betroffenen besteht insoweit nicht, weil bereits aus Sicht unseres Kunden die Verarbeitung durch uns im Rahmen des bestehenden Beschäftigungsverhältnisses mit dem Betroffenen erforderlich ist (§ 26 BDSG-neu). Für diesen Zweck speichern wir personenbezogene Daten für die Laufzeit des Vertrages.</p><p>Im Übrigen speichern wir Buchungsbelege für die Dauer von zehn Jahren und Geschäftsbriefe, also jede Nachricht, die die Vorbereitung, die Durchführung oder die Rückgängigmachung eines Geschäftes zum Gegenstand hat, für die Dauer von sechs Jahren, um unsere gesetzlichen Aufbewahrungspflichten nach § 257 Abs. 1 Nr. 2 HGB und § 147 AO zu erfüllen, wobei die Frist mit dem Ende des Kalenderjahres beginnt, in dem der Geschäftsbrief empfangen oder abgesandt wurde bzw. der Buchungsbeleg entstanden ist. Rechtsgrundlage ist Art. 6 Abs. 1 lit. c DSGVO.</p><h3>5.2 Kundenberatung</h3><p>Wir verarbeiten die im Zusammenhang mit einem Vertrag oder einer Anfrage eines Interessenten erhaltenen personenbezogenen Daten des Kunden oder Interessenten bzw. seiner Mitarbeiter als Ansprechpartner, auch nach Vertragsende bzw., wenn kein Vertrag zu Stande kommt, zum Zwecke der Kundenberatung und um bei einer erneuten Anfrage des Kunden oder Interessenten, auf Basis der vorherigen Vertragsabschlüsse oder Anfragen passende Leistungen empfehlen zu können. Rechtsgrundlage ist ein berechtigtes Interesse nach Art. 6 Abs. 1 S. 1 f DSGVO. Das berechtigte Interesse liegt in der Durchführung unserer Geschäftstätigkeit. Für diesen Zweck speichern wir personenbezogene Daten solange wir davon ausgehen, dass der jeweilige Kunde zukünftig einen weiteren oder erstmaligen Vertrag mit uns abschließen kann, was dann der Fall ist, bis der betreffende Kunde uns gegenüber erklärt, dass er unter keinen Umständen jemals einen Vertrag mit uns schließen wird.</p><p>Handelt es sich beim Kunden um eine natürliche Person ist Rechtsgrundlage, dass die Verarbeitung für die Erfüllung eines Vertrags, oder zur Durchführung vorvertraglicher Maßnahmen gemäß Art. 6 Abs. 1 S. 1 b DSGVO erforderlich ist. Verarbeiten wir personenbezogene Daten von Mitarbeitern des Kunden ist Rechtsgrundlage ein berechtigtes Interesse nach Art. 6 Abs. 1 S. 1 f DSGVO. Das berechtigte Interesse liegt in der Durchführung unserer Geschäftstätigkeit und der des Kunden. Ein entgegenstehendes Interesse des jeweils Betroffenen besteht insoweit nicht, weil bereits aus Sicht unseres Kunden die Verarbeitung durch uns im Rahmen des bestehenden Beschäftigungsverhältnisses mit dem Betroffenen erforderlich ist (§ 26 BDSG-neu). Zu diesem Zweck speichern wir die Daten für die Dauer des Vertrages über die Nutzung des Callidus Energie Kundencenters.</p><p>Darüber hinaus nutzen wir die so erhobenen Daten in anonymisierter Form, um Statistiken über das generelle Verhalten der Kunden der Direct Search Database zu erstellen. Dies ermöglicht uns, die Dienste kundenfreundlicher zu gestalten. Rechtsgrundlage ist dabei ein berechtigtes Interesse nach Art. 6 Abs. 1 S. 1 f DSGVO. Das berechtigte Interesse liegt in der Durchführung unserer Geschäftstätigkeit.</p><h3>5.3 Datenverarbeitungen bei der Veröffentlichung von Anzeigenprodukten</h3><p>Wenn unsere Kunden auf unserer Plattform Anzeigenprodukte oder Firmenporträts veröffentlichen, verarbeiten wir, soweit es sich bei dem Kunden um eine natürliche Person handelt, personenbezogene Daten des Kunden, soweit unser Kunde in einem Anzeigenprodukt Kontaktdaten eines Mitarbeiters angibt, verarbeiten wir dessen personenbezogene Daten, um diese jeweiligen Daten als Teil der Anzeige auf unserer Plattform unseren Nutzern bereitzustellen und um die Auffindbarkeit der Anzeige über die Suchfunktionalität auf unseren Plattformen zu gewährleisten. Um die Reichweite der Anzeige durch Übermittlung an unsere Kooperationspartner zu erhöhen, können wir die Anzeigeninhalte ganz oder teilweise an unsere Kooperationspartner übermitteln, die die Anzeige oder eine Vorschau darauf auf ihrer Webseite bereitstellen. Rechtsgrundlage ist, soweit es sich bei dem Kunden um eine natürliche Person handelt, dass die Verarbeitung für die Erfüllung eines Vertrags gemäß Art. 6 Abs. 1 S. 1 b DSGVO erforderlich ist. Sind in der Anzeige Kontaktdaten von Mitarbeitern des Kunden enthalten, ist Rechtsgrundlage ein berechtigtes Interesse nach Art. 6 Abs. 1 S. 1 f DSGVO. Das berechtigte Interesse liegt in der Durchführung unserer Geschäftstätigkeit und der des Kunden. Ein entgegenstehendes Interesse des jeweils Betroffenen besteht insoweit nicht, weil bereits aus Sicht unseres Kunden die Verarbeitung durch uns im Rahmen des bestehenden Beschäftigungsverhältnisses mit dem Betroffenen erforderlich ist (§ 26 BDSG-neu). Wir speichern die Daten für diesen Zweck für die Dauer, während der die Anzeige nach den vertraglichen Vereinbarungen auf unseren Plattformen verfügbar ist.</p><h3>5.4 Online Bestellungen</h3><p>Wenn Sie auf unserer Webseite eine Online Bestellung durchführen, erheben wir verschiedene, zum Vertragsschluss erforderliche Daten. Rechtsgrundlage ist der Abschluss und die Durchführung eines Vertrages nach Art. 6 Abs. 1 S. 1 b DSGVO. Die Daten werden für die Dauer des Vertrages entsprechend obiger Ziff. 3.3.1 gespeichert.</p><h3>5.5 Datenverarbeitungen für allgemeine Werbezwecke</h3><p>Wir verarbeiten personenbezogene Daten unserer Kunden sowie anderer, nicht mit uns in einer Geschäftsbeziehung stehenden Unternehmer und Unternehmen und in diesem Zusammenhang gegebenenfalls jeweils auch von den dortigen Ansprechpartnern zum Zweck der Direktwerbung, soweit rechtlich zulässig. Soweit wir diese Daten nicht direkt vom jeweiligen Betroffenen erhoben haben, können wir Kontaktdaten des Betroffenen auch aus öffentlichen Quellen entnehmen, wie insbesondere der Webseite des jeweiligen Unternehmens, Branchenverzeichnissen oder vom Unternehmen geschalteten Stellenanzeigen. Im Zusammenhang mit diesen Direktwerbezwecken können wir auch die bisherigen Vertragsabschlüsse von unseren Kunden und Unternehmensspezifika wie Branchenzugehörigkeit oder Betriebsgröße des jeweiligen Unternehmens/Unternehmers berücksichtigen, um die Werbung möglichst passend zu gestalten. Rechtsgrundlage ist ein berechtigtes Interesse im Sinne des Art. 6 Abs. 1 S. 1 f DSGVO. Das berechtigte Interesse besteht in der Verarbeitung personenbezogener Daten zum Zwecke der Direktwerbung selbst (vgl. Erwägungsgrund 47 DSGVO). Die Betroffenen haben das Recht jederzeit Widerspruch gegen die Verarbeitung sie betreffender personenbezogener Daten zum Zwecke derartiger Werbung einzulegen. Diesen Widerspruch können Sie jederzeit unter den in Ziff. 1 genannten Kontaktdaten erheben, im Fall von Werbung per E-Mail finden Sie einen Opt-Out Link auch direkt in der jeweiligen E-Mail. Wir speichern die Daten für diesen Zweck solange wie wir daran interessiert sind, mit dem betreffenden Unternehmen einen Vertrag abzuschließen oder bis ein Widerspruch erklärt wurde.</p><h2>6. Cookies und ähnliche Technologien</h2><p>Wir nutzen in unseren Webseiten derzeit keine Cookies. Cookies sind Textdateien, welche über einen Internetbrowser auf einem Computersystem abgelegt und gespeichert werden. Solche Cookies nutzen wir sowohl als technisches Mittel zur Erbringung von Leistungen auf unseren Plattformen, ermöglichen bspw. bestimmte Funktionalitäten, als auch zur Analyse des Webseitenverhaltens unserer Besucher und darauf aufbauend der nutzergerechteren Gestaltung unserer Angebote. Zu diesem Zweck können wir auch andere Techniken, wie Tracking-Pixel oder einen Code in Apps einsetzen. Außerdem können wir diese Cookies oder anderen Techniken auch nutzen, um Ihnen zielgerichtet für Sie interessante Stellenanzeigen und andere Inhalte zu übermitteln.</p><p>Einige der von uns verwendeten Cookies werden nach dem Ende der Browser-Sitzung, also nach Schließen Ihres Browsers, wieder gelöscht (sog. Sitzungs-Cookies). Andere Cookies verbleiben auf Ihrem Endgerät und ermöglichen uns oder unseren Partnerunternehmen, Ihren Browser beim nächsten Besuch wiederzuerkennen (persistente Cookies).</p><p>Die genaue Speicherdauer eines Cookies können Sie, soweit unten noch nicht spezifisch angegeben, dem jeweiligen Cookie entnehmen, indem Sie den Cookie in Ihrem Browser anzeigen lassen.</p><p>Sie können Ihren Browser so einstellen, dass Sie über das Setzen von Cookies informiert werden und einzeln über deren Annahme entscheiden oder die Annahme von Cookies für bestimmte Fälle oder generell ausschließen. Bei der Nichtannahme von Cookies kann die Funktionalität unserer Website eingeschränkt sein. Im Folgenden gehen wir auf konkrete Cookies und ähnliche Technologien ein.</p><p>Wir nutzen derzeit auch keine technischen Cookies. Dies sind solche, die ausschließlich zum Erfassen einiger Informationen auf unseren Plattformen erforderlich sind, um eine von Ihnen als Nutzer angeforderte oder erwünschte Leistung zu erbringen. Dies umfasst Navigations- bzw. Sitzungscookies, die eine reibungslose Navigation und Nutzung der Webseite ermöglichen (und beispielsweise den Zugang zum zugangsbeschränkten Bereich erlauben); Analyse-Cookies, die direkt von uns gesetzt werden, um gesammelte Informationen über die Anzahl der Besucher und deren Nutzerverhalten zu erfassen; Funktions-Cookies, die Ihnen im Sinne einer Serviceoptimierung die Navigation nach einigen ausgewählten Kriterien (z. B. Sprachwahl, zum Kauf ausgewählte Produkte) ermöglichen. Rechtsgrundlage für diese Cookies ist ein berechtigtes Interesse nach Art. 6 Abs. 1 S. 1 f DSGVO, nämlich die Verfolgung unserer Geschäftszwecke.</p><h2>7. Rechte der betroffenen Person</h2><p>Werden personenbezogene Daten von Ihnen verarbeitet, sind Sie Betroffener i.S.d. DSGVO und es stehen Ihnen folgende Rechte gegenüber dem Verantwortlichen zu:</p><h3>7.1 Auskunftsrecht</h3><p>Sie können von uns eine Bestätigung darüber verlangen, ob personenbezogene Daten, die Sie betreffen, von uns verarbeitet werden. Liegt eine solche Verarbeitung vor, können Sie von uns über folgende Informationen Auskunft verlangen:</p><ol><li>die Zwecke, zu denen die personenbezogenen Daten verarbeitet werden;</li><li>die Kategorien von personenbezogenen Daten, welche verarbeitet werden;</li><li>die Empfänger bzw. die Kategorien von Empfängern, gegenüber denen die Sie betreffenden personenbezogenen Daten offengelegt wurden oder noch offengelegt werden;</li><li>die geplante Dauer der Speicherung der Sie betreffenden personenbezogenen Daten oder, falls konkrete Angaben hierzu nicht möglich sind, Kriterien für die Festlegung der Speicherdauer;</li><li>das Bestehen eines Rechts auf Berichtigung oder Löschung der Sie betreffenden personenbezogenen Daten, eines Rechts auf Einschränkung der Verarbeitung durch den Verantwortlichen oder eines Widerspruchsrechts gegen diese Verarbeitung;</li><li>das Bestehen eines Beschwerderechts bei einer Aufsichtsbehörde;</li><li>alle verfügbaren Informationen über die Herkunft der Daten, wenn die personenbezogenen Daten nicht bei der betroffenen Person erhoben werden;</li><li>das Bestehen einer automatisierten Entscheidungsfindung einschließlich Profiling gemäß Art. 22 Abs. 1 und 4 DSGVO und – zumindest in diesen Fällen – aussagekräftige Informationen über die involvierte Logik sowie die Tragweite und die angestrebten Auswirkungen einer derartigen Verarbeitung für die betroffene Person.</li></ol><p>Ihnen steht das Recht zu, Auskunft darüber zu verlangen, ob die Sie betreffenden personenbezogenen Daten in ein Drittland oder an eine internationale Organisation übermittelt werden. In diesem Zusammenhang können Sie verlangen, über die geeigneten Garantien gem. Art. 46 DSGVO im Zusammenhang mit der Übermittlung unterrichtet zu werden.</p><p>Dieses Auskunftsrecht kann insoweit beschränkt werden, als es voraussichtlich die Verwirklichung der Statistikzwecke unmöglich macht oder ernsthaft beeinträchtigt und die Beschränkung für die Erfüllung der Statistikzwecke notwendig ist.</p><h3>7.2 Recht auf Berichtigung</h3><p>Sie haben ein Recht auf Berichtigung und/oder Vervollständigung gegenüber dem Verantwortlichen, sofern die verarbeiteten personenbezogenen Daten, die Sie betreffen, unrichtig oder unvollständig sind. Der Verantwortliche hat die Berichtigung unverzüglich vorzunehmen. Ihr Recht auf Berichtigung kann insoweit beschränkt werden, als es voraussichtlich die Verwirklichung der Statistikzwecke unmöglich macht oder ernsthaft beeinträchtigt und die Beschränkung für die Erfüllung der Statistikzwecke notwendig ist.</p><h3>7.3 Recht auf Einschränkung der Verarbeitung</h3><p>Unter den folgenden Voraussetzungen können Sie die Einschränkung der Verarbeitung der Sie betreffenden personenbezogenen Daten verlangen:</p><ol><li>wenn Sie die Richtigkeit der Sie betreffenden personenbezogenen für eine Dauer bestreiten, die es uns ermöglicht, die Richtigkeit der personenbezogenen Daten zu überprüfen;</li><li>die Verarbeitung unrechtmäßig ist und Sie die Löschung der personenbezogenen Daten ablehnen und stattdessen die Einschränkung der Nutzung der personenbezogenen Daten verlangen;</li><li>wir die personenbezogenen Daten für die Zwecke der Verarbeitung nicht länger benötigen, Sie diese jedoch zur Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen benötigen, oder</li><li>wenn Sie Widerspruch gegen die Verarbeitung gemäß Art. 21 Abs. 1 DSGVO eingelegt haben und noch nicht feststeht, ob unsere berechtigten Gründe gegenüber Ihren Gründen überwiegen.</li></ol><p>Wurde die Verarbeitung der Sie betreffenden personenbezogenen Daten eingeschränkt, dürfen diese Daten – von ihrer Speicherung abgesehen – nur mit Ihrer Einwilligung oder zur Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen oder zum Schutz der Rechte einer anderen natürlichen oder juristischen Person oder aus Gründen eines wichtigen öffentlichen Interesses der Union oder eines Mitgliedstaats verarbeitet werden.</p><p>Wurde die Einschränkung der Verarbeitung nach den o.g. Voraussetzungen eingeschränkt, werden Sie von uns unterrichtet bevor die Einschränkung aufgehoben wird.</p><p>Ihr Recht auf Einschränkung der Verarbeitung kann insoweit beschränkt werden, als es voraussichtlich die Verwirklichung der Statistikzwecke unmöglich macht oder ernsthaft beeinträchtigt und die Beschränkung für die Erfüllung der Statistikzwecke notwendig ist.</p><h3>7.4 Recht auf Löschung</h3><h4>7.4.1 Löschungspflicht</h4><p>Sie können von uns verlangen, dass die Sie betreffenden personenbezogenen Daten unverzüglich gelöscht werden, und wir sind verpflichtet, diese Daten unverzüglich zu löschen, sofern einer der folgenden Gründe zutrifft:</p><ol><li>Die Sie betreffenden personenbezogenen Daten sind für die Zwecke, für die sie erhoben oder auf sonstige Weise verarbeitet wurden, nicht mehr notwendig.</li><li>Sie widerrufen Ihre Einwilligung, auf die sich die Verarbeitung gem. Art. 6 Abs. 1 lit. a oder Art. 9 Abs. 2 lit. a DSGVO stützte, und es fehlt an einer anderweitigen Rechtsgrundlage für die Verarbeitung.</li><li>Sie legen gem. Art. 21 Abs. 1 DSGVO Widerspruch gegen die Verarbeitung ein und es liegen keine vorrangigen berechtigten Gründe für die Verarbeitung vor, oder Sie legen gem. Art. 21 Abs. 2 DSGVO Widerspruch gegen die Verarbeitung ein.</li><li>Die Sie betreffenden personenbezogenen Daten wurden unrechtmäßig verarbeitet.</li><li>Die Löschung der Sie betreffenden personenbezogenen Daten ist zur Erfüllung einer rechtlichen Verpflichtung nach dem Unionsrecht oder dem Recht der Mitgliedstaaten erforderlich, dem wir unterliegen.</li><li>Die Sie betreffenden personenbezogenen Daten wurden in Bezug auf angebotene Dienste der Informationsgesellschaft gemäß Art. 8 Abs. 1 DSGVO erhoben.</li></ol><h4>7.4.2 Information an Dritte</h4><p>Haben wir die die Sie betreffenden personenbezogenen Daten öffentlich gemacht und sind wir gem. Art. 17 Abs. 1 DSGVO zu deren Löschung verpflichtet, so treffen wir unter Berücksichtigung der verfügbaren Technologie und der Implementierungskosten angemessene Maßnahmen, auch technischer Art, um für die Datenverarbeitung Verantwortliche, die die personenbezogenen Daten verarbeiten, darüber zu informieren, dass Sie als betroffene Person von ihnen die Löschung aller Links zu diesen personenbezogenen Daten oder von Kopien oder Replikationen dieser personenbezogenen Daten verlangt haben.</p><h4>7.4.3 Ausnahmen</h4><p>Das Recht auf Löschung besteht nicht, soweit die Verarbeitung erforderlich ist</p><ol><li>zur Ausübung des Rechts auf freie Meinungsäußerung und Information;</li><li>zur Erfüllung einer rechtlichen Verpflichtung, die die Verarbeitung nach dem Recht der Union oder der Mitgliedstaaten, dem der Verantwortliche unterliegt, erfordert, oder zur Wahrnehmung einer Aufgabe, die im öffentlichen Interesse liegt oder in Ausübung öffentlicher Gewalt erfolgt, die dem Verantwortlichen übertragen wurde;</li><li>aus Gründen des öffentlichen Interesses im Bereich der öffentlichen Gesundheit gemäß Art. 9 Abs. 2 lit. h und i sowie Art. 9 Abs. 3 DSGVO;</li><li>für im öffentlichen Interesse liegende Archivzwecke, wissenschaftliche oder historische Forschungszwecke oder für statistische Zwecke gem. Art. 89 Abs. 1 DSGVO, soweit das unter Abschnitt a)<br>genannte Recht voraussichtlich die Verwirklichung der Ziele dieser Verarbeitung unmöglich macht oder ernsthaft beeinträchtigt, oder</li><li>zur Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen.</li></ol><h3>7.5 Recht auf Datenübertragbarkeit</h3><p>Sie haben das Recht, die Sie betreffenden personenbezogenen Daten, die Sie uns bereitgestellt haben, in einem strukturierten, gängigen und maschinenlesbaren Format zu erhalten. Außerdem haben Sie das Recht diese Daten einem anderen Verantwortlichen ohne Behinderung durch uns zu übermitteln, sofern</p><ol><li>die Verarbeitung auf einer Einwilligung gem. Art. 6 Abs. 1 lit. a DSGVO oder Art. 9 Abs. 2 lit. a DSGVO oder auf einem Vertrag gem. Art. 6 Abs. 1 lit. b DSGVO beruht und</li><li>die Verarbeitung mithilfe automatisierter Verfahren erfolgt.</li></ol><p>In Ausübung dieses Rechts haben Sie ferner das Recht, zu erwirken, dass die Sie betreffenden personenbezogenen Daten direkt von einem Verantwortlichen einem anderen Verantwortlichen übermittelt werden, soweit dies technisch machbar ist. Freiheiten und Rechte anderer Personen dürfen hierdurch nicht beeinträchtigt werden.</p><p>Das Recht auf Datenübertragbarkeit gilt nicht für eine Verarbeitung personenbezogener Daten, die für die Wahrnehmung einer Aufgabe erforderlich ist, die im öffentlichen Interesse liegt oder in Ausübung öffentlicher Gewalt erfolgt, die uns übertragen wurde.</p><h3>7.6 Widerspruchsrecht</h3><p>Sie haben das Recht, aus Gründen, die sich aus ihrer besonderen Situation ergeben, jederzeit gegen die Verarbeitung der Sie betreffenden personenbezogenen Daten, die aufgrund von Art. 6 Abs. 1 lit. e oder f DSGVO erfolgt, Widerspruch einzulegen; dies gilt auch für ein auf diese Bestimmungen gestütztes Profiling.</p><p>Wir verarbeiten dann die Sie betreffenden personenbezogenen Daten nicht mehr, es sei denn, wir können zwingende schutzwürdige Gründe für die Verarbeitung nachweisen, die Ihre Interessen, Rechte und Freiheiten überwiegen, oder die Verarbeitung dient der Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen.</p><p>Werden die Sie betreffenden personenbezogenen Daten verarbeitet, um Direktwerbung zu betreiben, haben Sie das Recht, jederzeit Widerspruch gegen die Verarbeitung der Sie betreffenden personenbezogenen Daten zum Zwecke derartiger Werbung einzulegen; dies gilt auch für das Profiling, soweit es mit solcher Direktwerbung in Verbindung steht.</p><p>Widersprechen Sie der Verarbeitung für Zwecke der Direktwerbung, so werden die Sie betreffenden personenbezogenen Daten nicht mehr für diese Zwecke verarbeitet.</p><p>Sie haben die Möglichkeit, im Zusammenhang mit der Nutzung von Diensten der Informationsgesellschaft – ungeachtet der Richtlinie 2002/58/EG – Ihr Widerspruchsrecht mittels automatisierter Verfahren auszuüben, bei denen technische Spezifikationen verwendet werden.</p><p>Sie haben auch das Recht, aus Gründen, die sich aus Ihrer besonderen Situation ergeben, bei der Verarbeitung Sie betreffender personenbezogener Daten, die zu statistischen Zwecken gem. Art. 89 Abs. 1 DSGVO erfolgt, dieser zu widersprechen.</p><p>Ihr Widerspruchsrecht kann insoweit beschränkt werden, als es voraussichtlich die Verwirklichung der Statistikzwecke unmöglich macht oder ernsthaft beeinträchtigt und die Beschränkung für die Erfüllung Statistikzwecke notwendig ist.</p><h3>7.7 Recht auf Widerruf der datenschutzrechtlichen Einwilligungserklärung</h3><p>Sie haben das Recht, Ihre datenschutzrechtliche Einwilligungserklärung jederzeit zu widerrufen. Durch den Widerruf der Einwilligung wird die Rechtmäßigkeit der aufgrund der Einwilligung bis zum Widerruf erfolgten Verarbeitung nicht berührt.</p><h3>7.8 Automatisierte Entscheidung im Einzelfall einschließlich Profiling</h3><p>Sie haben das Recht, nicht einer ausschließlich auf einer automatisierten Verarbeitung – einschließlich Profiling – beruhenden Entscheidung unterworfen zu werden, die Ihnen gegenüber rechtliche Wirkung entfaltet oder Sie in ähnlicher Weise erheblich beeinträchtigt. Dies gilt nicht, wenn die Entscheidung</p><ol><li>für den Abschluss oder die Erfüllung eines Vertrags zwischen Ihnen und dem Verantwortlichen erforderlich ist;</li><li>aufgrund von Rechtsvorschriften der Union oder der Mitgliedstaaten, denen der Verantwortliche unterliegt, zulässig ist und diese Rechtsvorschriften angemessene Maßnahmen zur Wahrung Ihrer Rechte und Freiheiten sowie Ihrer berechtigten Interessen enthalten oder</li><li>mit Ihrer ausdrücklichen Einwilligung erfolgt.</li></ol><p>Allerdings dürfen diese Entscheidungen nicht auf besonderen Kategorien personenbezogener Daten nach Art. 9 Abs. 1 DSGVO beruhen, sofern nicht Art. 9 Abs. 2 lit. a oder g gilt und angemessene Maßnahmen zum Schutz der Rechte und Freiheiten sowie Ihrer berechtigten Interessen getroffen wurden.</p><p>Hinsichtlich der in (1) und (3) genannten Fälle treffen wir angemessene Maßnahmen, um die Rechte und Freiheiten sowie Ihre berechtigten Interessen zu wahren, wozu mindestens das Recht auf Erwirkung des Eingreifens einer Person seitens des Verantwortlichen, auf Darlegung des eigenen Standpunkts und auf Anfechtung der Entscheidung gehört.</p><h3>7.9 Recht auf Beschwerde bei einer Aufsichtsbehörde</h3><p>Unbeschadet eines anderweitigen verwaltungsrechtlichen oder gerichtlichen Rechtsbehelfs steht Ihnen das Recht auf Beschwerde bei einer Aufsichtsbehörde, insbesondere in dem Mitgliedstaat ihres Aufenthaltsorts, ihres Arbeitsplatzes oder des Orts des mutmaßlichen Verstoßes, zu, wenn Sie der Ansicht sind, dass die Verarbeitung der Sie betreffenden personenbezogenen Daten gegen die DSGVO verstößt.</p><p>Die Aufsichtsbehörde, bei der die Beschwerde eingereicht wurde, unterrichtet den Beschwerdeführer über den Stand und die Ergebnisse der Beschwerde einschließlich der Möglichkeit eines gerichtlichen Rechtsbehelfs nach Art. 78 DSGVO.</p><h2>8. Änderung der Datenschutzerklärung; Zweckänderung</h2><p>Wir behalten uns das Recht vor, diese Datenschutzerklärung unter Beachtung der datenschutzrechtlichen Vorgaben zu ändern. Die jeweils aktuelle Fassung finden Sie jeweils an dieser Stelle oder einer anderen entsprechenden, leicht auffindbaren Stelle unserer Webseite oder App. Wenn wir beabsichtigen, Ihre Daten für andere Zwecke zu verarbeiten, also jene für die sie erhoben wurden, teilen wir Ihnen dies unter Beachtung der gesetzlichen Bestimmungen im Voraus mit.</p></div></div>");
$templateCache.put("app/components/static/view/faq.html","<div class=row><!-- Content 12col von 12--><div class=col-lg-8><h1>Häufige Fragen</h1></div><div class=\"col-lg-5 col-lg-push-1\"><dl><dt>Wie werden die Vergütungswerte berechnet?</dt><dd>Die dargestellten Vergütungswerte beruhen auf der statistischen Analyse eines Datensatzes, es sind also berechnete Werte. Grundlage sind die Angaben von 1.666 Fach- und Führungskräften, die an der Befragung für die Studie Vergütung Energie 2016 teilgenommen haben.</dd><dt>Wie akkurat sind die vom Rechner ausgegeben Vergütungswerte?</dt><dd>Die vom Gehaltsrechner ausgegebenen Werte wurden durch eine multivariate Regression auf das logarithmierte Gehalt ermittelt. Das R2 des Regressionsmodells beträgt 79,5%, der relative Standardfehler 20,9%. Dies bedeutet, dass die tatsächlichen Gehälter mit einer Wahrscheinlichkeit von 66% in der vom Gehaltsrechner ausgegeben Spanne liegen.</dd><dt>Warum kann der Rechner keine genaueren Vergütungswerte ausgeben?</dt><dd>Hierfür gibt es mehrere Gründe. Zum einen vergüten die Unternehmen selbst bei identischen Positionen teils sehr unterschiedlich. Auch individuelle Leistungen oder Verhandlungsgeschick haben einen Einfluss auf das Gehalt, welcher aber nur schwer ermittelt werden kann. Weiterhin beruhen die ermittelten Werte auf einer Stichprobe und keiner Vollerhebung. Zuletzt ergeben sich durch die multivariate Regression modellbedingte Ungenauigkeiten, da etwa der Einfluss der Berufserfahrung auf das Gehalt zu Beginn der Karriere stärker ist als zu ihrem Ende.</dd><dt>Die vom Rechner ausgegebene Spanne weicht von meinem eigenen Gehalt deutlich ab. Woran kann das liegen?</dt><dd>Deutliche Ausreißer kommen vor. Wir kennen einzelne Personen, die aufgrund besonderer Leistungen oder Begebenheiten in ihrem Unternehmen weit mehr verdienen als andere in ähnlicher Position. Auch der umgekehrte Fall ist leider in der Realität anzutreffen. Auf den Durchschnittswert wirken sich solche Ausreißer jedoch kaum aus. Wir sind aber sehr an Ihrer Meinung interessiert: Schicken Sie uns die von Ihnen eingegeben Parameter und nennen Sie uns jenen Vergütungswert, der aus Ihrer Sicht herauskommen sollte. Diese Informationen sind wichtig für das Fragebogendesign bei unserer nächsten Studie.</dd></dl></div><div class=\"col-lg-5 col-lg-push-1\"><dt>Sollte ich den Rechner für meine nächste Gehaltsverhandlung nutzen?</dt><dd>Der Vergütungsrechner kann Ihnen Anhaltspunkte für eine marktgerechte Vergütung liefern. Wir empfehlen Ihnen allerdings für ihre Gehaltsverhandlungen noch weitere Argumente ins Feld zu führen, etwa ihre eigenen Erfolge und Leistungen.</dd><dt>Welche Gehaltskomponenten werden für das Bruttojahresgehalt berücksichtigt?</dt><dd>Bei der ausgegebenen Gehaltsspanne handelt es sich um das jährliche Jahresbruttogehalt, inklusive aller Zusatzleistungen und Boni. Dies umschließt im Beispiel das Weihnachtsgeld, ebenso wie ein ÖPNV-Ticket oder einen Firmenwagen.</dd><dt>Warum stehen nicht alle Regionen und Berufe zur Auswahl zur Verfügung?</dt><dd>Der Vergütungsrechner basiert auf einer größeren Stichprobe. Für einige Berufe und Regionen lagen aber nur sehr wenige Werte vor, was aber nicht ausreicht um statistisch haltbare Aussagen treffen zu können. Helfen Sie uns einen noch besseren Vergütungsrechner zu erstellen und nehmen Sie an unserer nächsten Vergütungsstudie teil.</dd><dt>Warum sind die Wertebereiche bei den Eingabefeldern teilweise beschränkt?</dt><dd>Der Vergütungsrechner liefert in jenen Bereichen gute Werte, die auch in der Stichprobe in einer ähnlichen Kombination vorkommen. Wertekombination, die offensichtlich keinen Sinn ergeben wurden gesperrt.</dd><dt>Ist bereits eine neue Gehaltsstudie in Planung?</dt><dd>Ja, und wir freuen uns schon sehr. Wir halten Sie aber gerne auf dem Laufenden. Abonnieren Sie unsere regelmäßig erscheinende Studie Arbeitsmarkt Energie.</dd><!-- End Col --></div><!-- End Content --></div><!-- End Row -->");
$templateCache.put("app/components/static/view/interview_dahlke.html","<div class=row><!-- Content 12col von 12--><div class=col-lg-8><h1>Interviews zur Vergütungsstudie</h1><p class=lead>Für die Erstellung der Studie Vergütung Energie 2016/17 wurden neben empirischen Befunden auch zahlreiche Interviews mit Führungskräften aus den unterschiedlichsten Bereichen der Energiewirtschaft geführt. Ziel der Interviews war insbesondere, die Ergebnisse aus den unterschiedlichen Datensätzen differenzierter betrachten zu können. Im Folgenden finden Sie einige ausgewählte, aus unserer Sicht besonders interessante Gespräche.</p></div><hr><div class=\"col-lg-7 lastBlock\"><h3>Interview mit <span class=itvw>Dr. Kay Dahlke</span>,<br>Geschäftsführer bei der UKA Meißen</h3><hr><p class=itvw_question>Welche Rolle spielt die Vergütung bei der Gewinnung von Mitarbeitern?</p><p>Diese ist ein entscheidender Faktor, wenn auch vielleicht nicht mehr so dominant wie früher. Das Thema Homeoffice und die Begrenzung auf zwei Tage Anwesenheit wird immer wichtiger.</p><p class=itvw_question>Die UKA hat Standorte in West- sowie Ostdeutschland. Was bedeutet das für das Gehaltsgefüge?</p><p>Wir haben in Ostdeutschland insgesamt um die 400 Mitarbeiter und in Westdeutschland rund 50 Mitarbeiter. In Westdeutschland haben wir bei den Sachbearbeitern und Gruppen-leitern, also bei der 2. und 3. Ebene, kein Problem gehabt. Da sind die Gehälter auch nicht höher als hier bei uns im Osten. Die Leitungspositionen in Westdeutschland haben wir überwiegend mit erfahrenen Mitarbeitern aus der UKA-Gruppe besetzt.</p><p class=itvw_question>Welche Rolle spielen erfolgsbasierte Gehaltsbestandteile?</p><p>Die sind schon wichtig. Rein prozentual haben sie bei allen einen Anteil von mindestens einem Sechstel oder erheblich höher. Der erfolgsbasierte Anteil richtet sich nach dem Unternehmenserfolg bzw. dem Output der unterschiedlichen Gruppen. Bei uns verdienen die erfolgreichen Leute fast 60 Prozent ihres Gehaltes mit erfolgsabhängigen Anteilen.</p><p class=itvw_question>Ist das auf den Vertrieb beschränkt oder gilt das auch für andere Bereiche?</p><p>Es geht eigentlich um die Projekterfolge, die erbracht werden.</p><p class=itvw_question>Sehen Sie eine deutliche Veränderung im Engagement von Mitarbeitern, die Boni oder variable Vergütung erhalten?</p><p>Ja, bei uns bekommen alle einen Bonus. Die Tantieme ist dabei ein wesentlicher Bestandteil der Vergütung. Die Mitarbeiter nehmen ihren Beitrag für den Projekterfolg so deutlicher wahr.</p><p class=itvw_question>Haben Sie auch auf Sachbearbeitungsebene individuelle Bonibestandteile?</p><p>Ja. Wir haben in unserer Projektentwicklung eine Vielzahl von Gruppen, die aus 3 bis 5 Leuten bestehen und am Erfolg der eigenen Gruppe partizipieren.</p><p class=itvw_question>Wenn Sie die Vergütungsstrukturen in Ihrem Unternehmen frei von allen Restriktionen verändern könnten, was würden Sie machen?</p><p>Unsere Unternehmensgruppe hat in den letzten fünf Jahren stark expandiert, was mit einer Verdopplung der Mitarbeiterzahl und dem Aufbau sieben weiterer Standorte einherging. Hatten wir ursprünglich einen klaren hierarchischen Organisationsaufbau ist die Struktur inzwischen viel komplexer geworden. Aus der Historie heraus bekommt jede Ebene so und so viel. Inzwischen haben wir aber realisiert, dass wir beim Gehaltsgefüge für Spezialisten mehr Spielraum benötigen. Für einige Berufe mit anspruchsvolleren Aufgaben muss man einfach mehr zahlen.</p><p class=itvw_question>Sie haben sowohl im kommunalen Umfeld gearbeitet als auch jetzt bei einem Projektierer. Was waren für Sie die größten Unterschiede, als Sie nach Meißen gekommen sind?</p><p>Es gibt einen Unterschied zwischen Konzernstrukturen und inhabergeführten Unternehmen. Entscheidungen werden in letzteren schneller getroffen und Entscheidungswege sind nicht so strikt formalisiert. Es ist schon sehr unternehmerisch geprägt. Bei dem Stadtwerkebereich ist der Ertrag auch wichtig, aber in der Regel werden Ziele formuliert.</p><p class=itvw_question>Sehen Sie einen Unterschied in der Mentalität der Mitarbeiter?</p><p>Es ist schwer zu sagen, weil es im Stadtwerkebereich immer kleine Einheiten gab, wo die Leute mitgezogen haben, aber sonst herrscht bei den Stadtwerken eine behördenorientierte Struktur, wo jeder stärker an seinen Aufgaben hängt. Beim Projektierer ist dies flexibler. Es wird auch manchmal in Bereichen mit Engpässen quer ausgeholfen und die Strukturen sind nicht ganz so verfestigt. Der größte Unterschied ist, dass Betriebsräte in der Entwickler-branche keine Rolle spielen. Für die Unternehmensleitung ist natürlich auch alles etwas flexibler und einfacher.</p><p class=itvw_question>Haben Mitarbeiter von kommunalen Arbeitgebern gute Chancen, wenn sie sich bei einem Projektierer bewerben?</p><p>Es geht um die konkrete Erfahrung. Wir haben den ein oder anderen schon mal eingestellt. Die haben dann in der Regel Projektentwicklung gemacht. Es geht nur darum, ob die Erfahrung da ist, die man braucht, und wo die gesammelt wurde.</p><p class=itvw_question>Was sind aus Ihrer Sicht die größten Herausforderungen für Projektierer in den kommenden Jahren?</p><p>Die größte Herausforderung für Projektierer wird in den kommenden Jahren darin bestehen, den im Zuge einer Halbierung des Umsatzes stärkeren Wettbewerb anzunehmen.</p><p class=itvw_question>Erwarten Sie dann ähnliche Entwicklungen, wie es sie in der Solarbranche vor einigen Jahren gab, als viele Unternehmen in Insolvenz gegangen sind oder massiv Stellen abgebaut haben?</p><p>Ich glaube nicht, dass Projektentwickler in die Insolvenz gehen. Es muss eine Konsolidierung kommen, so dass die größeren Projektierer die kleineren übernehmen. Wenn Größere übernommen werden, werden diese meist an Energieversorger verkauft. Dies wird aber nicht flächendeckend der Fall sein, da sich die großen und erfolgreichen Projektierer in den letzten Jahren zu finanzstarken Unternehmen entwickelt haben, die schneller und flexibler als die Energieversorger sind. Der Preisverfall wird nicht so stark sein wie im PV-Bereich. Es wird zu Übernahmen kommen, Zusammenschlüssen oder engeren Kooperationen. Die meisten sind zudem schon im Ausland tätig. Uns als einem der TOP-3-Windparkprojektierer im deutschen Onshore-Markt kommt diese Entwicklung eher entgegen, da wir als Partner von anderen Projektieren gesucht werden.</p><p class=itvw_question>Was bedeuten die Entwicklungen in der kommenden Zeit für die Beschäftigten bei Projektierern?</p><p>Die Anforderungen werden steigen durch den stärkeren Wettbewerb.</p><p class=itvw_question>In welchen Bereichen wird die Nachfrage nach Mitarbeitern eventuell ansteigen?</p><p>In der Projektentwicklung, da die Projekte immer arbeitsintensiver werden. Der Aufwand wird durch das neu im EEG verankerte Ausschreibungsverfahren größer. Bei einigen Wettbewerbern sehe ich schon, dass durch regulatorische Ausbaubegrenzungen von Wind-energie ein aktiver Abbau in den betroffenen Bundesländern stattfindet. Die Leute gehen dann an andere Standorte.</p><p class=itvw_question>Welche Mitarbeiter werden es aus Ihrer Sicht im Bereich der erneuerbaren Energien eher schwer haben?</p><p>Die schlechter ausgebildeten Leute. Die gut ausgebildeten Leute, die viel Erfahrung haben, werden es nicht so schwer haben. Mitarbeiter, die direkt aus dem Studium kommen, die werden wir zunehmend weniger einstellen. Wir müssen stark auf erfahrene Leute zurückgreifen mit entsprechender Berufserfahrung.</p><p class=itvw_question>Was würden Sie einem jungen Menschen raten, der vor seinem Studium steht und sich für erneuerbare Energien interessiert?</p><p>Am besten, dass man die Ausbildung so praktisch, wie es geht, macht. Nicht sich zu stark einschränken. Ich würde immer etwas Klassisches studieren und Spezialerfahrung über Praktika sammeln oder Studentenjobs. Am besten ist, wenn man schon im Studium viele praktische Erfahrungen sammeln konnte.</p><hr><h4>Lesen Sie als nächstes:<br>unser <a class=link ui-sref=interview_graefrath>Interview mit Norbert Graefrath</a>, Arbeitsdirektor bei der Rheinenergie AG</h4></div><div class=\"col-lg-4 col-lg-push-1\"><div class=\"panel panel-info\"><div class=panel-body><h2>Alle weiteren Interviews auf einen Blick</h2><p><strong>Norbert Graefrath</strong>, Arbeitsdirektor Rheinenergie AG <a class=panel-link role=button ui-sref=interview_graefrath><span class=\"glyphicon glyphicon-circle-arrow-right\"></span> Interview lesen</a></p><p><strong>Heike Heim</strong>, Vorstandsvorsitzende EVO AG Offenbach <a class=panel-link role=button ui-sref=interview_heim><span class=\"glyphicon glyphicon-circle-arrow-right\"></span> Interview lesen</a></p><p><strong>Jan Rücker</strong>, Betriebsratsvorsitzender Avacon AG <a class=panel-link role=button ui-sref=interview_ruecker><span class=\"glyphicon glyphicon-circle-arrow-right\"></span> Interview lesen</a></p></div></div><!-- End Col --></div><!-- End Content --></div><!-- End Row -->");
$templateCache.put("app/components/static/view/interview_graefrath.html","<div class=row><!-- Content 12col von 12--><div class=col-lg-8><h1>Interviews zur Vergütungsstudie</h1><p class=lead>Für die Erstellung der Studie Vergütung Energie 2016/17 wurden neben empirischen Befunden auch zahlreiche Interviews mit Führungskräften aus den unterschiedlichsten Bereichen der Energiewirtschaft geführt. Ziel der Interviews war insbesondere, die Ergebnisse aus den unterschiedlichen Datensätzen differenzierter betrachten zu können. Im Folgenden finden Sie einige ausgewählte, aus unserer Sicht besonders interessante Gespräche.</p></div><hr><div class=\"col-lg-7 lastBlock\"><h3>Interview mit <span class=itvw>Norbert Graefrath</span>,<br>Arbeitsdirektor bei der Rheinenergie AG</h3><hr><p class=itvw_question>Welche Erwartungen haben Mitarbeiter an die Vergütungsstrukturen im Unternehmen?</p><p>Die Mitarbeiterinnen und Mitarbeiter erwarten völlig zu Recht, dass die Vergütungsstrukturen fair und leistungsgerecht sind. Gleichzeitig sehen wir aber auch, dass sich die Anforderungen der Mitarbeiter verändert haben und stark vom jeweiligen Lebensabschnitt abhängig sind.</p><p class=itvw_question>Welche Leistungen erwarten sich die Mitarbeiter dann heute von einem Arbeitgeber?</p><p>Das kommt drauf an. Die Jüngeren bis 40 interessiert vor allem die Vereinbarkeit von Familie und Beruf. Es geht ihnen um familienfreundliche Arbeitszeiten und um Flexibilität, um Teil- und Gleitzeitlösungen oder die Möglichkeit, auch einmal vom Homeoffice aus zu arbeiten. Ältere Mitarbeiter interessiert dagegen stärker die Altersvorsorge, da denken Jüngere noch nicht dran.</p><p class=itvw_question>Welche Möglichkeiten ergeben sich bei der Gestaltung der Vergütungsstruktur innerhalb des Tarifrahmens?</p><p>Wir sind im Tarifvertrag für Versorgungsbetriebe. Ich finde, dass man dem TV-V ein wenig Unrecht tut, wenn man ihn immer wieder nur als eng anliegendes, starres Regelungskorsett begreift. Er bietet durchaus seine Möglichkeiten und Handlungsoptionen, und die nutzen wir auch erfolgreich. Große Spielräume gibt es daneben im außertariflichen Bereich.</p><p class=itvw_question>Gibt es dennoch etwas, das sich aus Ihrer Sicht am TV-V verändern sollte?</p><p>Ich halte die Entgelt-Eingruppierung nach Betriebszugehörigkeitsstufen für nicht mehr zeitgemäß. In einer Zeit der Patchwork-Lebensläufe, in welcher der Beschäftigte sein \"Schicksal\" nicht mehr über Jahrzehnte hinweg an einen einzigen Arbeitgeber knüpft und das auch seitens des Arbeitsgebers gar nicht mehr unbedingt gewünscht ist, weil er in anderen Arbeitszusammenhängen gesammelte Erfahrungen als Horizonterweiterungen honoriert, halte ich solche Bleibeprämien für antiquiert.</p><p class=itvw_question>Welche Rolle spielen erfolgsbasierte Gehaltsbestandteile in der Vergütung?</p><p>Bei der RheinEnergie haben wir solche variablen Vergütungsbestandteile …</p><p class=itvw_question>… und sehen Sie eine deutliche Veränderung im Engagement von Mitarbeitern und Führungskräften, die Boni erhalten?</p><p>Ehrlich gesagt: Nein, nicht wirklich.</p><p class=itvw_question>Welches sind mit Blick auf die Beschäftigen in der Energiewirtschaft aus Ihrer Sicht die größten Herausforderungen?</p><p>Die Branche steht unter einem enormen Kosten- und Verhandlungsdruck. Gleichzeitig wird aufgrund der Altersstruktur unserer Beschäftigten ein Drittel von ihnen in den nächsten 10 Jahren in den Ruhestand gehen.</p><p class=itvw_question>Inwiefern verändern sich die Stellenanforderungen durch die Herausforderungen der Unternehmen?</p><p>Die Energiewirtschaft befindet sich inmitten eines Transformationsprozesses. Die Digitalisierung, die Dezentralisierung, der Trend zum Smart Home, Phänomene wie Connected-Building-Lösungen verändern massiv die Anforderungen. Dieser Wandel ist mit Risiken und Chancen verbunden. Wenn der Wind der Veränderung weht, sollte man nicht Mauern bauen, sondern Windmühlen. Daran arbeiten wir.</p><p class=itvw_question>Welchen Einfluss wird die Digitalisierung auf die Beschäftigung in der Energiewirtschaft haben?</p><p>Die Digitalisierung ist einer der wichtigsten Veränderungsagenten in der Energiewirtschaft. Die Stellenanforderungen werden sich durch sie weiter verändern. Es braucht dafür nicht allein Fachleute mit technischem und IT-Know-how, sondern vor allem solche mit der Schlüsselkompetenz, sich permanent in neue technische Herausforderungen hineindenken zu können. Der Tellerrand als natürliche Wissensgrenze hat heute mehr denn je ausgedient.</p><p class=itvw_question>Welche Rolle spielt das Personalwesen bei Veränderungsprozessen?</p><p>Das HR-Management fungiert als begleitender Moderator des Veränderungsprozesses. Dieser selbst aber wird von den Führungskräften und dem Topmanagement getragen.</p><p class=itvw_question>Inwiefern hat sich die Kultur in Ihrem Unternehmen in den letzten Jahren verändert?</p><p>Der Kulturwandel hat gewiss eingesetzt, es liegt aber auch noch ein weiter Weg vor uns. Man kann die Kultur eines Unternehmens, das auf eine lange Historie zurückblickt, nicht einfach per Dikret über Nacht ändern. So funktionieren Menschen nicht. Das sind keine revolutionären, sondern evolutionäre Prozesse.</p><p class=itvw_question>Viele Mitarbeiter haben in ihrem Berufsleben nie außerhalb der Energiewirtschaft gearbeitet. Inwiefern wirkt sich dies auf deren Veränderungsbereitschaft aus?</p><p>Grundsätzlich ist dazu zu sagen, dass die individuelle Veränderungsbereitschaft von Mitarbeiter zu Mitarbeiter ganz unterschiedlich ausgeprägt ist. Allerdings ist es schon so, dass insbesondere bei jenen, die bereits länger dabei sind, das Beharrungsvermögen oft stärker ausgeprägt ist als der Veränderungswille.</p><p class=itvw_question>Stellen Sie Unterschiede in der Einstellung oder im Verhalten derjenigen Mitarbeiter fest, die zuvor in anderen Branchen tätig waren?</p><p>Ja, die sind durchaus festzustellen. Der Blick auf Abläufe im Unternehmen ist natürlicherweise ein anderer, wenn Prozesse noch als neu wahrgenommen und dadurch stärker reflektiert werden. Auf der anderen Seite nutzt sich die Innovationskraft eines solchen Blickes von außen recht schnell ab: Neue Mitarbeiter passen sich zügig an die vorhandene Kultur an.</p><p class=itvw_question>In welchen Bereichen werden sich auch zukünftig in der Energiewirtschaft gute Karriereperspektiven ergeben?</p><p>Angesichts der hohen Veränderungsdynamik, welche die Energiewirtschaft mit der Energiewende, der Digitalisierung und der Dezentralisierung erfasst hat und auch weiterhin im Griff hält, ist es nicht so einfach, belastbare Prognosen und Qualifizierungsempfehlungen abzugeben. Lebens- und Berufsabläufe verlaufen nicht mehr linear wie noch in den 70er Jahren. Müsste ich meinem Kind aus heutiger Sicht dennoch eine Empfehlung geben, so würde ich wohl den Zweig der Elektrotechnik nennen. Dieser bildet eine wichtige Grundlage für eine Vielfalt an Berufsbildern.</p><hr><h4>Lesen Sie als nächstes:<br>unser <a class=link ui-sref=interview_heim>Interview mit Heike Heim</a>, Vorstandsvorsitzende EVO AG Offenbach</h4></div><div class=\"col-lg-4 col-lg-push-1\"><div class=\"panel panel-info\"><div class=panel-body><h2>Alle weiteren Interviews auf einen Blick</h2><p><strong>Dr. Kay Dahlke</strong>, Geschäftsführer bei der UKA Meißen <a class=panel-link role=button ui-sref=interview_dahlke><span class=\"glyphicon glyphicon-circle-arrow-right\"></span> Interview lesen</a></p><p><strong>Heike Heim</strong>, Vorstandsvorsitzende EVO AG Offenbach <a class=panel-link role=button ui-sref=interview_heim><span class=\"glyphicon glyphicon-circle-arrow-right\"></span> Interview lesen</a></p><p><strong>Jan Rücker</strong>, Betriebsratsvorsitzender Avacon AG <a class=panel-link role=button ui-sref=interview_ruecker><span class=\"glyphicon glyphicon-circle-arrow-right\"></span> Interview lesen</a></p></div></div><!-- End Col --></div><!-- End Content --></div><!-- End Row -->");
$templateCache.put("app/components/static/view/interview_heim.html","<div class=row><!-- Content 12col von 12--><div class=col-lg-8><h1>Interviews zur Vergütungsstudie</h1><p class=lead>Für die Erstellung der Studie Vergütung Energie 2016/17 wurden neben empirischen Befunden auch zahlreiche Interviews mit Führungskräften aus den unterschiedlichsten Bereichen der Energiewirtschaft geführt. Ziel der Interviews war insbesondere, die Ergebnisse aus den unterschiedlichen Datensätzen differenzierter betrachten zu können. Im Folgenden finden Sie einige ausgewählte, aus unserer Sicht besonders interessante Gespräche.</p></div><hr><div class=\"col-lg-7 lastBlock\"><h3>Interview mit <span class=itvw>Heike Heim</span>,<br>Vorstandsvorsitzende der EVO AG Offenbach</h3><hr><p class=itvw_question>Sie sind die erste Frau an der Spitze in der über 150-jährigen Geschichte in der EVO. Hatten Sie zu Beginn mit Ressentiments zu kämpfen?</p><p>Nein. Ich habe eher positives Erstaunen hervorgerufen, weil ich mich als Ingenieurin auf Augenhöhe mit dem technischen Kollegen austauschen kann. Ich habe nicht mit Ressentiments zu kämpfen gehabt, sondern eher mit der Wahrnehmung: „Jetzt kommt ein Vorstand aus der MVV Energie AG, Controllerin, Unternehmensberaterin, …“ Also, es lag sicher nicht an meinem Geschlecht, sondern eher an meiner Vita, die dann vielleicht in der Richtung Ressentiments hervorgerufen hat.</p><p class=itvw_question>Gerade einmal 9 Prozent aller Vorstände der größten 50 Energieunternehmen sind weiblich. Haben es Frauen in der Energiewirtschaft immer noch schwerer, Karriere zu machen, als Männer?</p><p>Ich denke, es gibt mehrere Mechanismen, die es für eine Frau schwermachen, in höhere Führungspositionen aufzusteigen: zunächst gibt es eine kulturelle oder funktionale Ablehnung qua Geschlecht, weil Frauen von Männern als Störfaktor empfunden werden. Dann gibt es auch den Anspruch, dass in gewissen Führungspositionen Härte gefragt ist, harte Frauen sind oft jedoch wie Männer im Rock, also nicht authentisch. Wenn man sich die Altersstruktur der Energiewirtschaft anschaut, dann sieht man, dass die leitenden Stellen momentan oft noch am oberen Altersende besetzt sind. Das bringt häufig auch ein traditionelles Rollenbild mit sich. In Summe ist dies eine etwas schwierige Gemengelage für junge Frauen, die in Führungspositionen aufsteigen möchten – gerade in der Energiewirtschaft. Es ist auch ein bisschen eine Auseinandersetzung zwischen Führungskräften, die flexibel, zukunftsorientiert, auch leistungsorientiert bewerten, gegenüber solchen, die einem traditionellen, bewahrenden Rollenbild folgen.</p><p class=itvw_question>Hilft es aus Ihrer individuellen Erfahrung heraus, wenn sich eine Frau eher wie ein Mann benimmt?</p><p>Für Führungspersönlichkeiten ist Authentizität absolut entscheidend. Und ich bin nicht authentisch, wenn ich versuche, mich an Rollenbilder anzugleichen, an vermeintliche Rollenvorgaben. Dies hält man nur bedingt lange durch, egal ob männlich oder weiblich.</p><p class=itvw_question>Sind Führungskräfte bei Männern fehlertoleranter als gegenüber Frauen?</p><p>Ich glaube, im Kern nicht, aber weil immer noch zu wenige Frauen in Führungspositionen sind, fallen die Fehler dieser Frauen mehr auf. Männer möchten Karriere machen, das wird schon fast erwartet.</p><p class=itvw_question>Mussten Sie immer Ihren Führungsanspruch gegenüber Vorgesetzten betonen, unterstreichen, dass Sie Karriere machen möchten?</p><p>Nicht mehr als meine männlichen Kollegen. Ich habe meinen Karriereanspruch immer klar formuliert. Als Frau muss man vielleicht immer etwas über seinen eigenen Schatten springen, was das Thema Selbstkritik oder auch Selbsthinterfragung angeht. Aber ansonsten habe ich diesbezüglich überhaupt keine negativen Erfahrungen gemacht. Es ist ebenfalls wichtig, dass man die richtigen Mentoren und Förderer während des Berufslebens an seiner Seite hat, Leute, die einem den Mut geben.</p><p class=itvw_question>Wie findet Mann oder Frau einen Mentor?</p><p>Ich habe meine Mentorinnen teilweise qua Funktion erhalten, ich war zehn Jahre in der Beratung, wo das Modell Counsellor ein sehr ausgeprägtes ist. In meinem alten Unternehmen war es so, dass man immer einen Mentor zur Verfügung gestellt bekam, welcher mindestens zwei Karrierestufen über einem steht und der jenseits des disziplinarischen Vorgesetzten Karriereentwicklungsfragen und auch Engagements bespricht.</p><p class=itvw_question>In den letzten 5 Jahren wurden knapp 15 Prozent aller Vorstandspositionen bei den Top-50-Unternehmen in der Energiewirtschaft mit Frauen besetzt. Dies entspricht interessanterweise genau dem Anteil von Frauen in der Energiewirtschaft. Ist damit nicht der Gerechtigkeit Genüge getan?</p><p>Nein, glaube ich nicht. Frauen in Führungspositionen, insbesondere in der Energiewirtschaft, bedingen einen Mentalitätswechsel, und ich glaube, 15 Prozent sind zu wenig, um einen wirklichen Mentalitätswechsel herbeizuführen. Nichts hilft so sehr, wie ein Rollenmodell vorzuleben, und das kann man nur mit einem signifikanten Anteil weiblicher Führungskräfte.</p><p class=itvw_question>Gibt es Bereiche, in denen Frauen aus Ihrer Sicht leichter Karriere machen können, und Bereiche, in denen es schwerer sein dürfte?</p><p>Nein, kann ich Ihnen nicht beantworten. Ich glaube, es hält sich die Waage, was Vor- und Nachteile angeht. Es sollten sich jedoch mehr Frauen in klassischen operativen Verantwortungen einbringen und weniger stark in Querschnittsfunktionen.</p><p class=itvw_question>Ist es aus Ihrer Sicht schwierig, geeignete Frauen zu finden?</p><p>Im sehr technisch orientierten Umfeld ja. Ansonsten eher nein. Es ist in Summe momentan ein absoluter Bewerbermarkt und dies stellt den Arbeitgeber vor eine Herausforderung, die richtigen Talente zu gewinnen.</p><p class=itvw_question>Was sollten Unternehmen in der Energiewirtschaft noch machen, um Frauen zu fördern?</p><p>An der Unternehmenskultur arbeiten, also eine eher leistungsorientierte, innovative Unternehmenskultur ausprägen. Traditionelle Rollenbilder durch moderne ersetzen, indem versucht wird, Frauen in Führungspositionen zu bringen und das Thema Familie und Karriere nicht ausschließlich den Frauen anzuhängen, denn es betrifft die Männer genauso. Das Thema Flexibilität deutlich zu erhöhen und auch die Möglichkeiten des mobilen Arbeitens einer Führungskraft in Teilzeit zu ermöglichen. Die Rahmenbedingungen müssen verbessert werden.</p><p class=itvw_question>Welche Tipps würden Sie einer jungen Frau geben, die in der Energiewirtschaft Karriere machen möchte?</p><p>Den Mut zu haben, Opportunitäten, die sich bieten, zu ergreifen. Ein klares Herausarbeiten von zwei bis drei energiewirtschaftlichen Schwerpunktthemen. Auch P&L-Verantwortung zu übernehmen.</p><hr><h4>Lesen Sie als nächstes:<br>unser <a class=link ui-sref=interview_ruecker>Interview mit Jan Rücker</a>, Betriebsratsvorsitzender Avacon AG</h4></div><div class=\"col-lg-4 col-lg-push-1\"><div class=\"panel panel-info\"><div class=panel-body><h2>Alle weiteren Interviews auf einen Blick</h2><p><strong>Dr. Kay Dahlke</strong>, Geschäftsführer bei der UKA Meißen <a class=panel-link role=button ui-sref=interview_dahlke><span class=\"glyphicon glyphicon-circle-arrow-right\"></span> Interview lesen</a></p><p><strong>Norbert Graefrath</strong>, Arbeitsdirektor Rheinenergie AG <a class=panel-link role=button ui-sref=interview_graefrath><span class=\"glyphicon glyphicon-circle-arrow-right\"></span> Interview lesen</a></p><p><strong>Jan Rücker</strong>, Betriebsratsvorsitzender Avacon AG <a class=panel-link role=button ui-sref=interview_ruecker><span class=\"glyphicon glyphicon-circle-arrow-right\"></span> Interview lesen</a></p></div></div><!-- End Col --></div><!-- End Content --></div><!-- End Row -->");
$templateCache.put("app/components/static/view/interview_ruecker.html","<div class=row><!-- Content 12col von 12--><div class=col-lg-8><h1>Interviews zur Vergütungsstudie</h1><p class=lead>Für die Erstellung der Studie Vergütung Energie 2016/17 wurden neben empirischen Befunden auch zahlreiche Interviews mit Führungskräften aus den unterschiedlichsten Bereichen der Energiewirtschaft geführt. Ziel der Interviews war insbesondere, die Ergebnisse aus den unterschiedlichen Datensätzen differenzierter betrachten zu können. Im Folgenden finden Sie einige ausgewählte, aus unserer Sicht besonders interessante Gespräche.</p></div><hr><div class=\"col-lg-7 lastBlock\"><h3>Interview mit <span class=itvw>Jan Rücker</span>,<br>Betriebsratsvorsitzender Avacon AG</h3><hr><p class=itvw_question>Welche Erwartungen haben die Beschäftigten aus Ihrer Sicht an die Vergütungsstrukturen?</p><p>Unsere Vergütungsstruktur ist ausgewogen. Es gibt, glaube ich, bei uns niemanden im Konzern, der sich über seinen Verdienst beklagen kann. Das Problem dabei ist, dass die Vergütungsstrukturen relativ fix sind. Die Erwartungen der Beschäftigten gehen schon in die Richtung, dass man da etwas ändert.</p><p class=itvw_question>Welche Faktoren sind aus der Erfahrung heraus neben dem reinen Gehalt für die Beschäftigten noch wichtig?</p><p>Arbeitszeit ist immer ein sehr wichtiges Thema, das bewegt die Menschen sehr. Wie lange muss ich arbeiten, wie lange darf ich arbeiten, wie lange werde ich hier überhaupt noch gebraucht? Informationen sind sehr wichtig, wenn man etwas wissen möchte bei uns, dann muss man sich darum kümmern, ansonsten bekommt man diese nicht. Das soziale Miteinander ist neben dem Gehalt ebenfalls sehr wichtig. Dinge, die auch ein Stück weit Verbundenheit mit dem Unternehmen signalisieren.</p><p class=itvw_question>Tarifstufen auf Basis der Betriebszugehörigkeit werden wegen des fehlenden Leistungsbezugs häufig kritisch gesehen. Ist das System aus Ihrer Sicht überholt?</p><p>Rücker: Nein, das ist alles andere als überholt. Ich bin hier in einem Betriebsstandort mit Kollegen, die im Außendienst arbeiten, und ich habe schon jemanden besucht, der das schon seit mehr als 40 Jahren macht. Der ist seit über 30 Jahren im Bereitschaftsdienst. Das ist so eine Woche, wo Ihnen auch so ein Stück weit Ihre Freiheit geraubt wird. Die müssen sieben Tage lang 24 Stunden lang am Telefon sein und auch in der Nacht bei Regen, Eis und Schnee losfahren zu Leuten, bei denen es beispielsweise in der Wohnung nach Gas riecht. Da gehört es sich natürlich auch, dass diese Mitarbeiter entsprechend bezahlt werden. Tarifstufen auf Basis der Betriebszugehörigkeit sind keine antiquierte Regelung, sondern gut investiertes Geld. Bei AVACON bzw. im E.ON-Tarif gibt es auch eine Leistungskomponente. Also, Leistung wird noch mal individuell und extra vergütet oder eben nicht.</p><p class=itvw_question>Wie funktioniert das? Gilt das für jeden?</p><p>Das gilt für jeden Tarifangestellten. Es funktioniert es so, dass man im Rahmen von Mitarbeitergesprächen zwischen Teamleiter und Mitarbeiter Ziele festlegt, die dann auch bewertet werden. Ansonsten wird nur Leistung bewertet.</p><p class=itvw_question>Spüren Sie, dass solche Bestandteile einen Einfluss auf die Motivation oder die Leistung der Mitarbeiter hat?</p><p>Wenn Sie als Führungskraft bei engagierten Mitarbeitern Leistung honorieren, dann ist das für Balsam für die Seele.</p><p class=itvw_question>Wenn Sie die Vergütungsstrukturen in Ihrem Unternehmen frei von allen Restriktionen gestalten könnten – was würden Sie verändern?</p><p>Die Vergütungsstrukturen, die wir derzeit haben, sind durchaus gut. Es gibt keine Unterschiede zwischen Mann und Frau, die Vergütung ist bei uns gleich. Leistung wird bewertet. Ich denke mal, man müsste die Tätigkeiten, die sich im Laufe der Jahre verändert haben teilweise neu bewerten.</p><p class=itvw_question>In der Vergangenheit galten Arbeitsplätze, vor allem im Konzern, immer als absolut sicher. Sind diese Zeiten endgültig vorbei aus Ihrer Sicht?</p><p>Die Arbeitsplätze bei AVACON sind so lange sicher, bis jemand einen Trick erfindet, wie man sich Strom abfüllen kann. Solange wir leitungsgebundene Energieträger haben, sind auch die Arbeitsplätze in den Netzen sicher. Ob die Bezahlung auf dem heutigen Niveau bleibt, ist eine andere Frage, da wird sicher noch das ein oder andere passieren, aber Arbeitsplätze, also diejenigen, die Netze betreiben und Netze bebauen, braucht man auch.</p><p class=itvw_question>In den letzten 15 Jahren haben viele Energieversorger im Bereich Asset Service Personal eingespart, auch vor dem Hintergrund sinkender Erlöspfade. Hatte das bei der AVACON keine personellen Auswirkungen?</p><p>Doch, natürlich hatte das Auswirkungen. Wir haben 1999 mit 3.500 Menschen angefangen und haben zwischendurch den Vertrieb und den Shared Service ausgegliedert. Wir haben ebenfalls den Einkauf optimiert. Die Arbeitsintensität nahm durch die Konzentration von Aufgaben ständig zu. Was heute eine Person macht, haben früher drei gemacht.</p><p class=itvw_question>Ist der Tiefpunkt aus Ihrer Sicht erreicht, also das Potenzial dessen, was man nehmen konnte, oder sagen Sie, dass man weiterhin versuchen wird, Personaleinsparungen vorzunehmen?</p><p>Das ist nicht mehr möglich. Die durchgeklonten Herren in Nadelstreifen sind hier erschienen und haben in der Regel nicht gewusst, wie es geht, und haben auch nicht verstanden, wie Energieversorgung funktioniert. Wir kaufen nichts ein, so funktioniert Energieversorgung nicht, es ist nicht wie bei VW.</p><p class=itvw_question>Ab wann wird sich der demografische Wandel aus Ihrer Sicht bemerkbar machen?</p><p>Wahrscheinlich schon ab 2018, das Durchschnittsalter der Beschäftigten liegt derzeit bei 48 Jahren. Aber wir sind auch ganz gut gerüstet. Wir haben über Personalcontrolling eine genaue Aufstellung gemacht. Geclustert nach der Anzahl der Kaufleute, Anzahl der Ingenieure usw. Wir haben Gegenmaßnahmen ergriffen: Wir fahren unsere Ausbildungszahlen entsprechend runter. Von dem Moment, zu dem die junge Frau oder der junge Mann nach der Schule einen Ausbildungsvertrag unterschreibt, bis zu dem Moment, zu dem diese Frau oder dieser Mann in vollem Umfang für unseren Bereitschaftsdienst zur Verfügung steht, vergehen sieben Jahre. Wenn wir heute merken, dass wir jemanden für das Jahr 2018 brauchen, dann hätten wir schon vor sieben Jahren mit der Ausbildung anfangen müssen, sonst wird 2018 knapp. Das ist das Problem, das wir gerade haben.</p><p class=itvw_question>Wo werden die größten Engpässe entstehen oder umgekehrt, wo werden Menschen die größten Chancen haben?</p><p>Junge Menschen werden die größten Chancen haben, wenn sie flexibel sind. Junge Menschen, die sagen, sie möchten einen interessanten Job, der technisch anspruchsvoll ist, und denen es egal ist, wo in Deutschland sie eingesetzt sind, die werden große Chancen haben.</p><hr><h4>Lesen Sie als nächstes:<br>unser <a class=link ui-sref=interview_dahlke>Interview mit Dr. Kay Dahlke</a>, Geschäftsführer bei der UKA Meißen</h4></div><div class=\"col-lg-4 col-lg-push-1\"><div class=\"panel panel-info\"><div class=panel-body><h2>Alle weiteren Interviews auf einen Blick</h2><p><strong>Dr. Kay Dahlke</strong>, Geschäftsführer bei der UKA Meißen <a class=panel-link role=button ui-sref=interview_dahlke><span class=\"glyphicon glyphicon-circle-arrow-right\"></span> Interview lesen</a></p><p><strong>Norbert Graefrath</strong>, Arbeitsdirektor Rheinenergie AG <a class=panel-link role=button ui-sref=interview_graefrath><span class=\"glyphicon glyphicon-circle-arrow-right\"></span> Interview lesen</a></p><p><strong>Heike Heim</strong>, Vorstandsvorsitzende EVO AG Offenbach <a class=panel-link role=button ui-sref=interview_heim><span class=\"glyphicon glyphicon-circle-arrow-right\"></span> Interview lesen</a></p></div></div><!-- End Col --></div><!-- End Content --></div><!-- End Row -->");
$templateCache.put("app/components/static/view/legal_information.html","<div class=row><div class=\"col-lg-8 col-lg-push-4 lastBlock\"><h1>Impressum</h1><p>Callidus Energie GmbH<br>Postanschrift:<br>Mainzer Landstraße 47<br>60329 Frankfurt am Main</p><p>Geschäftsführer:<br>Ron-Arne Sydow, Jonathan Lichter</p><p>Registergericht:<br>Amtsgericht Frankfurt am Main, HRB 101349</p><p>Umsatzsteuer-Identifikationsnummer:<br>DE298420757</p><p>Inhaltlich Verantwortlicher gemäß § 6 MDStV:<br>Ron-Arne Sydow</p></div></div>");
$templateCache.put("app/components/static/view/terms_and_conditions.html","<div class=row><div class=\"col-lg-8 col-lg-push-2 lastBlock\"><h1>Allgemeine Geschäftsbedingungen</h1><h4>Unsere Geschäftsbedingungen Stand 12/2016</h4><ol><li>Die nachfolgenden Geschäftsbedingungen gelten für alle von der Callidus Energie GmbH, Mainzer Landstraße 47, 60329 Frankfurt am Main, angebotenen Dienste/Services in Zusammenhang mit der Studie Vergütung Energie 2016/17 sowie dem Vergütungsrechner Energie, und dabei insbesondere für diejenigen auf den Webseiten www.verguetung-energie.de sowie www.callidus-energie.de angebotenen Leistungen.</li><li>Kauf der Vergütungsstudie Energie: Der Kauf erfolgt auf Rechnungsstellung mit einem vierzehntägigen Zahlungsziel. Sie können gelieferte Ware ohne Angabe von Gründen innerhalb von 14 Tagen nach Erhalt der Ware zurückgeben. Der Kaufvertrag wird nach Erhalt der Ware durch Ihre Billigung bindend. Die Billigung gilt als erfolgt, wenn Sie uns innerhalb der 14-tägigen Billigungsfrist weder eine anderweitige Nachricht zukommen lassen, noch die gelieferte Ware zurücksenden. Nach der Billigung steht Ihnen darüber hinaus das nachfolgend beschriebene Widerrufsrecht zu.</li><li>Die auf dieser Website genannten Preise sind Online-Preise in Euro (einschließlich der gesetzlichen Mehrwertsteuer). Bestellungen und Lieferungen sind versandkostenfrei nur innerhalb Deutschlands möglich. Sollten Sie eine Lieferung ins Ausland wünschen, so versuchen wir gerne Ihnen weiterzuhelfen. Die Abgabe von Artikeln erfolgt nur in haushaltsüblichen Mengen.</li><li>Zahlung: Sie können grundsätzlich per Rechnung bezahlen, das Zahlungsziel beträgt 14 Tage. In Einzelfällen behalten wir uns vor, die Ware erst nach einer Anzahlung auszuliefern. Nach Eingang der Bestellung werden wir dies mit dem Kunden abstimmen. Bis zur vollständigen Bezahlung bleibt die Ware unser Eigentum.</li><li><p>Widerrufsbelehrung: Sie haben das Recht, binnen vierzehn Tagen ohne Angabe von Gründen diesen Vertrag zu widerrufen. Die Widerrufsfrist beträgt vierzehn Tage ab dem Tag an dem Sie oder ein von Ihnen benannter Dritter, der nicht der Beförderer ist, die letzte Ware in Besitz genommen haben bzw. hat. Die Frist beginnt jedoch nicht, bevor der Kaufvertrag durch Ihre Billigung des gekauften Gegenstandes für Sie bindend geworden ist.</p><p>Um Ihr Widerrufsrecht auszuüben, müssen Sie uns (Callidus Energie GmbH) mittels einer eindeutigen Erklärung (z.B. ein mit der Post versandter Brief, Telefax oder E-Mail) über Ihren Entschluss, diesen Vertrag zu widerrufen, informieren. Zur Wahrung der Widerrufsfrist reicht es aus, dass Sie die Mitteilung über die Ausübung des Widerrufsrechts vor Ablauf der Widerrufsfrist absenden.</p><h4>Folgen des Widerrufs</h4><p>Wenn Sie diesen Vertrag widerrufen, haben wir Ihnen alle Zahlungen, die wir von Ihnen erhalten haben, unverzüglich und spätestens binnen vierzehn Tagen ab dem Tag zurückzuzahlen, an dem die Mitteilung über Ihren Widerruf dieses Vertrags bei uns eingegangen ist. Für diese Rückzahlung verwenden wir die von Ihnen angegebene Kontoverbindung; in keinem Fall werden Ihnen wegen dieser Rückzahlung Entgelte berechnet. Wir können die Rückzahlung verweigern, bis wir die Ware wieder zurückerhalten haben oder bis Sie den Nachweis erbracht haben, dass Sie die Waren zurückgesandt haben, je nachdem, welches der frühere Zeitpunkt ist.</p><p>Sie haben die Studie unverzüglich und in jedem Fall spätestens binnen vierzehn Tagen ab dem Tag, an dem Sie uns über den Widerruf dieses Vertrags unterrichten, an uns zurückzusenden. Die Frist ist gewahrt, wenn Sie die Waren vor Ablauf der Frist von vierzehn Tagen absenden. Wir tragen die Kosten der Rücksendung der Ware.</p><p>Sie müssen für einen etwaigen Wertverlust der Waren nur aufkommen, wenn dieser Wertverlust auf einen zur Prüfung der Beschaffenheit, Eigenschaften und Funktionsweise der Waren nicht notwendigen Umgang mit ihnen zurückzuführen ist.</p></li></ol></div><hr><div class=\"col-lg-8 col-lg-push-2 lastBlock\"><h2>Haftungshinweis / Haftungsausschluss</h2><ol><li><h4>Inhalt des Onlineangebotes</h4>Der Autor übernimmt keinerlei Gewähr für die Aktualität, Korrektheit, Vollständigkeit oder Qualität der bereitgestellten Informationen. Haftungsansprüche gegen den Autor, welche sich auf Schäden materieller oder ideeller Art beziehen, die durch die Nutzung oder Nichtnutzung der dargebotenen Informationen bzw. durch die Nutzung fehlerhafter und unvollständiger Informationen verursacht wurden, sind grundsätzlich ausgeschlossen, sofern seitens des Autors kein nachweislich vorsätzliches oder grob fahrlässiges Verschulden vorliegt. Alle Angebote sind freibleibend und unverbindlich. Der Autor behält es sich ausdrücklich vor, Teile der Seiten oder das gesamte Angebot ohne gesonderte Ankündigung zu verändern, zu ergänzen, zu löschen oder die Veröffentlichung zeitweise oder endgültig einzustellen.</li><li><h4>Verweise und Links</h4>Bei direkten oder indirekten Verweisen auf fremde Webseiten (Hyperlinks), die außerhalb des Verantwortungsbereiches des Autors liegen, würde eine Haftungsverpflichtung ausschließlich in dem Fall in Kraft treten, in dem der Autor von den Inhalten Kenntnis hat und es ihm technisch möglich und zumutbar wäre, die Nutzung im Falle rechtswidriger Inhalte zu verhindern. Der Autor erklärt hiermit ausdrücklich, dass zum Zeitpunkt der Linksetzung keine illegalen Inhalte auf den zu verlinkenden Seiten erkennbar waren. Auf die aktuelle und zukünftige Gestaltung, die Inhalte oder die Urheberschaft der verlinkten/verknüpften Seiten hat der Autor keinerlei Einfluss. Deshalb distanziert er sich hiermit ausdrücklich von allen Inhalten aller verlinkten/verknüpften Seiten, die nach der Linksetzung verändert wurden. Diese Feststellung gilt für alle innerhalb des eigenen Internetangebotes gesetzten Links und Verweise sowie für Fremdeinträge in vom Autor eingerichteten Gästebüchern, Diskussionsforen, Linkverzeichnissen, Mailinglisten und in allen anderen Formen von Datenbanken, auf deren Inhalt externe Schreibzugriffe möglich sind. Für illegale, fehlerhafte oder unvollständige Inhalte und insbesondere für Schäden, die aus der Nutzung oder Nichtnutzung solcherart dargebotener Informationen entstehen, haftet allein der Anbieter der Seite, auf welche verwiesen wurde, nicht derjenige, der über Links auf die jeweilige Veröffentlichung lediglich verweist.</li><li><h4>Urheber- und Kennzeichenrecht</h4>Der Autor ist bestrebt, in allen Publikationen die Urheberrechte der verwendeten Grafiken, Tondokumente, Videosequenzen und Texte zu beachten, von ihm selbst erstellte Grafiken, Tondokumente, Videosequenzen und Texte zu nutzen oder auf lizenzfreie Grafiken, Tondokumente, Videosequenzen und Texte zurückzugreifen. Alle innerhalb des Internetangebotes genannten und ggf. durch Dritte geschützten Marken- und Warenzeichen unterliegen uneingeschränkt den Bestimmungen des jeweils gültigen Kennzeichenrechts und den Besitzrechten der jeweiligen eingetragenen Eigentümer. Allein aufgrund der bloßen Nennung ist nicht der Schluss zu ziehen, dass Markenzeichen nicht durch Rechte Dritter geschützt sind! Das Copyright für veröffentlichte, vom Autor selbst erstellte Objekte bleibt allein beim Autor der Seiten. Eine Vervielfältigung oder Verwendung solcher Grafiken, Tondokumente, Videosequenzen und Texte in anderen elektronischen oder gedruckten Publikationen ist ohne ausdrückliche Zustimmung des Autors nicht gestattet.</li><li><h4>Datenschutz</h4>Sofern innerhalb des Internetangebotes die Möglichkeit zur Eingabe persönlicher oder geschäftlicher Daten (E-Mail-Adressen, Namen, Anschriften) besteht, so erfolgt die Preisgabe dieser Daten seitens des Nutzers auf ausdrücklich freiwilliger Basis. Die Inanspruchnahme und Bezahlung aller angebotenen Dienste ist – soweit technisch möglich und zumutbar – auch ohne Angabe solcher Daten bzw. unter Angabe anonymisierter Daten oder eines Pseudonyms gestattet. Die Nutzung der im Rahmen des Impressums oder vergleichbarer Angaben veröffentlichten Kontaktdaten wie Postanschriften, Telefon- und Faxnummern sowie E-Mail-Adressen durch Dritte zur Übersendung von nicht ausdrücklich angeforderten Informationen ist nicht gestattet. Rechtliche Schritte gegen die Versender von sogenannten Spam-Mails bei Verstößen gegen dieses Verbot sind ausdrücklich vorbehalten.</li><li><h4>Rechtswirksamkeit dieses Haftungsausschlusses</h4>Dieser Haftungsausschluss ist als Teil des Internetangebotes zu betrachten, von dem aus auf diese Seite verwiesen wurde. Sofern Teile oder einzelne Formulierungen dieses Textes der geltenden Rechtslage nicht, nicht mehr oder nicht vollständig entsprechen sollten, bleiben die übrigen Teile des Dokumentes in ihrem Inhalt und ihrer Gültigkeit davon unberührt.</li></ol></div></div>");
$templateCache.put("app/components/survey/view/survey.html","<div class=row><!-- Content 12col von 12--><div class=col-lg-12><!-- Jumbotron --><section><div class=jumbotron><h1>Ver&shy;gütung Energie 2016/17</h1><p>Die Studie Vergütung Energie 2016/17 wurde von Callidus Energie in Zusammenarbeit mit Prof. Bontrup von der Westfälischen Hochschule erstellt und umfasst 56 Seiten. In die Analyse sind 1.666 Vergütungswerte von Fach- und Führungskräften ebenso eingegangen wie Mikrozensus-Daten des statistischen Bundesamts, Jahresabschlussberichte von Energieunternehmen, aktuelle Forschungsergebnisse zu Vergütungsthemen sowie Interviews mit Top-Führungskräften aus der Branche.</p></div></section><!-- End Jumbotron --><!-- Previewblock --><div class=\"row previewBox\"><!-- Preview --><div class=\"col-lg-8 .col-lg-push-4\"><p>Neben der Analyse von Vergütungsstrukturen enthält die Studie einen Überblick über den aktuellen Stellenmarkt in der Energiewirtschaft und betrachtet die potentiellen Auswirkungen von Megatrends wie Dezentralisierung, Digitalisierung sowie des demographischen Wandels auf die Beschäftigung. Anhand von 140 Werdegängen von Top-Managern aus der Energiewirtschaft wurde untersucht, inwiefern sich die Werdegänge der jüngeren von denen der älteren Top-Manager unterscheiden. Ferner wurden knapp 1.000 Fach- und Führungskräfte darüber befragt, wie zufrieden sie mit ihrem Gehalt sind und was sie als die größten Probleme ihres Unternehmens erachten.</p><div><img ng-src=../assets/images/img_ve2016-17_title@2x.png class=ve-previewTitle alt=\"Studie Vergütung Energie 2016/17 – Voransicht\"><!--<img class=\"ve-preview1p\" src=\"../assets/images/VE201617_Titel.png\" alt=\"Studie Vergütung Energie 2016/17 – Titelseite\">--></div></div><div class=\"col-lg-4 .col-lg-pull-8\"><div class=ve-preview2p><a ng-click=survey.openLightboxModal(0)><img ng-src={{survey.images[0].thumbUrl}} class=ve-preview1p alt=\"Studie Vergütung Energie 2016/17 – Doppelseite\"> </a><!-- <img ng-src=\"../assets/images/icon_scale@2x.png\" class=\"ve-scale\" alt=\"Lupen Icon\"> --></div><div class=ve-preview2p><a ng-click=survey.openLightboxModal(1)><img ng-src={{survey.images[1].thumbUrl}} class=ve-preview1p alt=\"Studie Vergütung Energie 2016/17 – Doppelseite\"> </a><!-- <img ng-src=\"../assets/images/icon_scale@2x.png\" class=\"ve-scale\" alt=\"Lupen Icon\"> --></div></div></div><!-- Bestell-Block --><div class=row><div class=col-lg-6><div class=orderBox><h2>Studienexemplar bestellen</h2><ul><li>Broschüre</li><li>56 Seiten, ca. 18.000 Worte, 23 Grafiken und Tabellen</li><li>Zahlung auf Rechnung</li><li>Preis: 299,– EUR (inkl. 19% Mwst.)</li></ul><a ui-sref=surveySurveyOrder class=\"btn btn-lg btn-primary\">Kostenpflichtig bestellen</a></div></div><div class=col-lg-6><div class=orderBox><h2>Zusammenfassung bestellen</h2><ul><li>Digital im PDF-Format</li><li>8 Seiten</li><li>Bereitstellung per E-Mail</li><li>Preis: 0,– EUR</li></ul><a ui-sref=surveySummaryorder class=\"btn btn-lg btn-primary\">Kostenfrei bestellen</a></div></div></div><!-- End Block --><!-- Info-Block --><div class=\"row newBlock\"><!-- Kontakt-Block --><div class=col-lg-4><h2>Kontakt / Rückfragen</h2><p>Sie haben Rückfragen zur Studie oder bezüglich des Bestellvorgangs? Senden Sie uns eine Nachricht oder rufen Sie uns an. Gerne beantworten wir Ihnen ihre Fragen.</p><a class=\"btn btn-primary\" role=button ui-sref=\"contact({contactReason: \'Rückfragen Studie oder Bestellung\'})\">Kontakt Fragen Studie / Bestellung</a></div><div class=\"col-lg-8 lastBlock\"><h2>Vergütungsbenchmark für Unternehmen</h2><p>Konsistente und marktgerechte Vergütungs- und Anreizsysteme sind essentiell für die Personalgewinnung und die Bindung von Mitarbeitern. Vom Benchmarking einzelner Positionen bis hin zum Abgleich ihrer gesamten Vergütungsstruktur – gerne unterbreiten wir Ihnen ein individuelles Angebot für ihr Unternehmen.</p><a class=\"btn btn-primary\" role=button ui-sref=\"contact({contactReason: \'Vergütungsbenchmark\'})\">Kontakt Vergütungsbenchmark</a></div><!-- End Block --></div><!-- End Row --><!-- End Infoblock --></div><!-- End Col --></div><!-- End Content -->");
$templateCache.put("app/components/calculator/controllers/finalcalculator/finalcalculator.html","<!-- Jumbotron --><section><div class=jumbotron><h1>Ver&shy;gütungs&shy;rech&shy;ner Energie</h1><p>Wieviel verdient ein Bereichsleiter Vertrieb im Stadtwerk? Wieviel ein Spezialist im Energiehandel oder in der Projektierung für erneuerbare Energieanlagen? Welchen Einfluss haben etwa die Ausbildung oder das Geschlecht auf das Gehalt? Finden Sie es mit nur wenigen Klicks heraus.</p></div></section><!-- End Jumbotron --><!-- Infoblock --><!--\n<section>\n  <div class=\"row\">\n    <div class=\"col-lg-9 col-lg-push-1\">\n      <p class=\"small info\">Bitte beachten Sie, dass individuelle Faktoren wie Arbeitsleistung oder Verhandlungsgeschick in der Erhebung und Analyse der Daten nicht berücksichtigt werden konnten, wodurch Abweichungen von den tatsächlichen Gehaltswerten möglich sind.\n      </p>\n    </div>\n  </div>\n</section>\n--><!-- End Infoblock --><!-- Persoenlich --><div class=\"row newBlock\"><div class=col-lg-12><div class=box><form class=form-horizontal novalidate><fieldset><legend>Persönliche Angaben</legend><div class=form-group ng-class=\"{\'has-error\': calculator.errors.gender}\"><label class=\"col-lg-3 control-label\">Geschlecht</label><div class=col-lg-9><div class=radio><label for=input.gender.female><input type=radio ng-model=calculator.input.gender name=input.gender id=input.gender.female value=FEMALE> weiblich</label><label for=input.gender.male><input type=radio ng-model=calculator.input.gender name=input.gender id=input.gender.male value=MALE> männlich</label></div></div></div><div class=form-group ng-class=\"{\'has-error\': calculator.errors.workExperienceInYears}\"><label for=calculator.input.workExperienceInYears class=\"col-lg-3 control-label\">Berufserfahrung<br><small>(ohne Studienzeiten o.ä.)</small></label><div class=col-lg-9><rzslider rz-slider-options=\"{floor: 0, ceil: 45, onChange: calculator.workExperienceChanged()}\" rz-slider-model=calculator.input.workExperienceInYears></rzslider></div></div><div class=form-group ng-class=\"{\'has-error\': calculator.errors.educationLevel}\"><label for=calculator.input.educationLevel class=\"col-lg-3 control-label\">Höchster Bildungsgrad</label><div class=col-lg-9><select id=calculator.input.educationLevel class=form-control ng-model=calculator.input.educationLevel ng-options=\"education.value as education.name for education in calculator.educations\"><option value=\"\">-- Bitte auswählen --</option></select></div></div></fieldset></form></div></div></div><!-- Unternehmen --><div class=row><div class=col-lg-12><div class=box><form class=form-horizontal novalidate><fieldset><legend>Angaben zum Unternehmen</legend><div class=form-group ng-class=\"{\'has-error\': calculator.errors.companyCategory}\"><label for=input.companyCategory class=\"col-lg-3 control-label\">Art des Unternehmens</label><div class=col-lg-9><select id=input.companyCategory class=form-control ng-model=calculator.input.companyCategory ng-change=calculator.companyCategoryChanged() ng-options=\"category.value as category.name for category in calculator.companyCategories\"><option value=\"\">-- Bitte auswählen --</option></select></div></div><div class=form-group ng-class=\"{\'has-error\': calculator.errors.countOfCompanyEmployees}\"><label class=\"col-lg-3 control-label\" for=input.countOfCompanyEmployees>Anzahl Mitarbeiter</label><div class=col-lg-9><rzslider rz-slider-options=calculator.companySizeSliderOptions rz-slider-model=calculator.input.countOfCompanyEmployees></rzslider></div></div><div class=form-group ng-class=\"{\'has-error\': calculator.errors.region}\"><label for=calculator.input.region class=\"col-lg-3 control-label\">Region</label><div class=col-lg-9><select id=calculator.input.region class=form-control ng-model=calculator.input.region ng-options=\"region.value as region.name group by region.group for region in calculator.regions\"><option value=\"\">-- Bitte auswählen --</option></select></div></div></fieldset></form></div></div></div><!-- Tätigkeit --><div class=row><div class=col-lg-12><div class=box><form class=form-horizontal novalidate><fieldset><legend>Angaben zur Position</legend><div class=form-group ng-class=\"{\'has-error\': calculator.errors.hierarchyLevel}\"><label for=input.hierarchyLevel class=\"col-lg-3 control-label\">Hierarchielevel</label><div class=col-lg-9><select id=input.hierarchyLevel class=form-control ng-model=calculator.input.hierarchyLevel ng-change=calculator.hierarchyLevelChanged() ng-options=\"level.value as level.name for level in calculator.hierarchyLevels\"><option value=\"\">-- Bitte auswählen --</option></select></div></div><div class=form-group ng-hide=!calculator.hasSubordinates() ng-class=\"{\'has-error\': calculator.errors.myStaffSize}\"><label for=input.myStaffSize class=\"col-lg-3 control-label\">Personalverantwortung (Anzahl MA)</label><div class=col-lg-9><rzslider rz-slider-options=calculator.subordinatesSliderOptions rz-slider-model=calculator.input.myStaffSize></rzslider></div></div><div class=form-group ng-hide=calculator.isAreaManagerScopeDropdownDisabled() ng-class=\"{\'has-error\': calculator.errors.areaManagerScope}\"><label for=input.areaManagerScope class=\"col-lg-3 control-label\">Aufgabenbereich</label><div class=col-lg-9><select ng-disabled=calculator.isAreaManagerScopeDropdownDisabled() class=form-control id=input.areaManagerScope ng-model=calculator.input.areaManagerScope ng-options=\"scope.value as scope.name for scope in calculator.areaManagerScopes\"><option value=\"\">-- Bitte auswählen --</option></select></div></div><div class=form-group ng-hide=calculator.isDepartmentManagerScopeDropdownDisabled() ng-class=\"{\'has-error\': calculator.errors.departmentManagerScope}\"><label for=input.departmentManagerScope class=\"col-lg-3 control-label\">Aufgabenbereich</label><div class=col-lg-9><select ng-disabled=calculator.isDepartmentManagerScopeDropdownDisabled() class=form-control id=input.departmentManagerScope ng-model=calculator.input.departmentManagerScope ng-options=\"scope.value as scope.name group by scope.group for scope in calculator.departmentManagerScopes\"><option value=\"\">-- Bitte auswählen --</option></select></div></div><div class=form-group ng-hide=calculator.isIndividualScopeDropdownDisabled() ng-class=\"{\'has-error\': calculator.errors.individualScope}\"><label for=input.individualScope class=\"col-lg-3 control-label\">Aufgabenbereich</label><div class=col-lg-9><select ng-disabled=calculator.isIndividualScopeDropdownDisabled() class=form-control id=input.individualScope ng-model=calculator.input.individualScope ng-options=\"scope.value as scope.name group by scope.group for scope in calculator.individualScopes\"><option value=\"\">-- Bitte auswählen --</option></select></div></div></fieldset></form></div></div></div><div class=row><div class=col-lg-12><div class=box><form class=form-horizontal><fieldset><legend>Bruttojahresgehalt*</legend><div class=\"col-lg-6 col-lg-offset-3\"><p class=gehalt><span style=\"color: #fff\"></span> {{calculator.result || \'---\'}} <span style=\"color: #fff\"></span></p><!-- <button type=\"calculator.reset\" class=\"btn btn-warning btn-lg\">Eingaben zurücksetzen</button>\n            <button class=\"btn btn-primary btn-lg\">Gehalt neu berechnen</button> --><div class=\"btn-group btn-group\"><a ui-sref=finalcalculator class=\"btn btn-default btn-lg\" ng-click=calculator.reset()>Eingaben zurücksetzen</a> <button id=doCalc ng-click=calculator.doCalc($event) href=# class=\"btn btn-primary btn-lg\">Gehalt berechnen</button></div></div><div class=col-lg-3><p class=\"small info\">Die angegebene Gehaltsspanne berücksichtigt alle Gehaltskomponenten, inklusive geldwerter Zusatzleistungen und Boni. Sie beruht auf statistischen Berechnungen, tatsächliche Werte können von der angegebenen Spanne abweichen. Für Details hinsichtlich der Methodik beachten Sie bitte den Bereich Häufige Fragen.</p></div></fieldset></form></div></div></div><!-- Newsletter --><div class=row ng-show=calculator.showSummaryTeaser><div class=col-lg-12><div class=actionBox><form class=form-horizontal><fieldset><legend>Vergütung Energie 2016/17</legend><!-- <div class=\"col-lg-6 col-lg-offset-3\"> --><p>Bestellen Sie kostenfrei eine Zusammenfassung der Ergebnisse per Email, und erfahren Sie mehr über die Vergütungsstrukturen in der Energiewirtschaft. <a ui-sref=surveySummaryorder class=\"btn btn-lg btn-primary\">Kostenfrei bestellen</a></p></fieldset></form></div></div></div><!-- End Newsletter --><!-- Infoblock --><div class=\"row newBlock\"><div class=\"col-lg-7 col-lg-push-1 lastBlock\"><h2>Bleiben Sie informiert</h2><p>Die Energiewirtschaft verändert sich! Erhalten Sie jedes Quartal eine Analyse zu den aktuellen Entwicklungen am Arbeitsmarkt. Welche Unternehmen stellen ein? Wer wird gesucht? Welche Trends zeichnen sich ab? Melden Sie sich an und erhalten Sie jedes Quartal kostenfrei den aktuellsten Report. Übrigens – wir geben ihre E-Mail-Adresse nicht an Dritte weiter. Denn wir hassen Spam-Mails sowie inhaltsleere Newsletter wahrscheinlich ebenso wie Sie.</p><a class=\"btn btn-primary\" role=button ui-sref=\"contact({contactReason: \'Anmeldung Analyse Arbeitsmarkt Energie\'})\">Anmeldung Analyse Arbeitsmarkt Energie</a><hr><h2>Stellen&shy;ange&shy;bote Energie</h2><p>Durchsuchen Sie die aktuellen Stellenangebote bei Callidus Energie und treten Sie mit uns in Kontakt. Gerne nehmen wir Sie in unsere Kartei auf und informieren Sie bei passenden Stellenangeboten.</p><a class=\"btn btn-primary\" role=button target=_blank href=http://www.callidus-energie.de/stellenangebote/ >Stellenangebote</a><hr><h2>Ihr Feed&shy;back ist uns wichtig</h2><p>In unserer Studie <a class=text-link ui-sref=survey>Vergütung Energie 2016/17</a> sowie dem Vergütungsrechner steckt viel Herzblut und Arbeit. Wir bedanken uns herzlichst bei allen, die uns bei der Realisierung unterstützt und uns etwa als Teilnehmer ihr Vertrauen geschenkt haben. Sie haben Ideen, was wir besser machen oder verändern können? Schreiben Sie uns, wir freuen uns auf Ihre Meinung.</p><a class=\"btn btn-primary\" role=button ui-sref=\"contact({contactReason: \'Feedback geben\'})\">Feedback geben</a></div><!-- Box Studie --><div class=\"col-lg-4 col-lg-push-1\"><div class=\"panel panel-info\"><div class=panel-body><h2>Studie Vergütung Energie 2016/17</h2><p>Die bisher umfassendste Studie zu Vergütungsstrukturen, Karrierefaktoren, dem Meinungsbild von Fach- und Führungskräften sowie dem Arbeitsmarkt in der Energiewirtschaft. Bestellen Sie die gesamte Studie oder die Zusammenfassung der Ergebnisse.</p><a class=panel-link role=button ui-sref=survey><span class=\"glyphicon glyphicon-circle-arrow-right\"></span> Hier informieren</a><!-- Logo Studie --><div class=ve-logo><object data=../assets/images/Verguetungenergie201617_Web.svg type=image/svg+xml><img src=../assets/images/Verguetungenergie201617_Web_800px.png alt=\"Studie Vergütung Energie 2016/17\"></object></div><!-- End Logo Studie --></div></div></div><!-- End Box --></div><!-- End Row --> <!-- End Infoblock -->");
$templateCache.put("app/components/contact/controllers/contact/contact.html","<div class=row ng-show=!!contact.flash><div class=col-lg-12><section><div class=jumbotron><h1>Nachricht gesendet</h1><p>Vielen Dank für Ihre Nachricht, wir werden uns in Kürze bei Ihnen melden.</p></div></section></div></div><div ng-show=!contact.flash><!-- Textbox „Intro“ --><section><div class=row><div class=col-lg-12><h1>Sie haben Rückfragen?</h1><p class=lead>Sie haben Fragen zum Vergütungsrechner Energie? Füllen Sie das Kontaktformular aus, wir melden uns schnellstmöglich bei Ihnen.</p></div></div><!-- End Row --></section><!-- End Textbox „Intro“ --><hr><!-- Formularelemente --><div class=row><div class=col-lg-12><div class=box><form name=contact.contactForm sf-schema=contact.schema sf-form=contact.form sf-model=contact.model ng-submit=contact.onSubmit($event)></form></div></div></div><hr></div><!-- Textbox 1-spaltig + Anzeigen --><div class=row><div class=col-lg-12><h2>So finden Sie uns</h2><p>Callidus Energie GmbH<br>Mainzer Landstraße 47<br>60329 Frankfurt am Main<br>Tel. +49 (0) 69 401507420</p></div></div><!-- End Row --><!-- End Textbox --><hr>");
$templateCache.put("app/components/survey/controllers/summary/summaryorder.html","<div ng-show=!summaryOrder.flash><!-- Textbox „Intro“ --><section><div class=row><div class=col-lg-10><h1>Bestellung Zusammenfassung der Studie Vergütung Energie 2016/17</h1><p class=lead>Füllen Sie bitte alle mit * gekennzeichneten Felder aus und klicken Sie auf \"Kostenlose Zusammenfassung bestellen\". Die Zusammenfassung steht Ihnen im Anschluss der Bestellung sofort zum Download bereit.</p></div></div><!-- End Row --></section><!-- End Textbox „Intro“ --><hr><!-- Formularelemente --><div class=box><form name=summaryOrder.summaryOrderForm sf-schema=summaryOrder.schema sf-form=summaryOrder.form sf-model=summaryOrder.model ng-submit=summaryOrder.onSubmit($event)></form></div></div><div class=row ng-show=!!summaryOrder.flash><div class=col-lg-12><section><div class=jumbotron><h1>Zusammenfassung bestellt</h1><p>Vielen Dank für Ihre Bestellung. Die Zusammenfassung der Callidus Vergütungsstudie 2016/17 steht unter diesem <a ng-href={{summaryOrder.flash}} target=_blank>Link zur Zusammenfassung der Studie</a> für Sie zum Download bereit.</p></div></section></div></div>");
$templateCache.put("app/components/survey/controllers/survey/surveyorder.html","<!-- ORDER PAGE 1 --><div ng-show=\"surveyOrder.page.index == 0\"><!-- Textbox „Intro“ --><section><div class=row><div class=col-lg-10><h1>Bestellung Printexemplar der Studie Vergütung Energie 2016/17</h1><p class=lead>Füllen Sie bitte alle mit * gekennzeichneten Felder aus und klicken Sie auf \"Weiter\", um zur Bestellübersicht zu gelangen.</p></div></div></section><hr><!-- Formularelemente --><div class=row><div class=col-lg-12><div class=box><form name=surveyOrder.summaryOrderForm sf-schema=surveyOrder.schema sf-form=surveyOrder.form sf-model=surveyOrder.model ng-submit=surveyOrder.onSubmit($event)></div></div></div></div><!-- ORDER PAGE 2 --><div ng-show=\"surveyOrder.page.index == 1\"><!-- Textbox „Intro“ --><section><div class=row><div class=col-lg-10><h1>Übersicht zur Bestellung des Printexemplars der Studie Vergütung Energie 2016/17</h1><p class=lead>Prüfen Sie hier Ihre Angaben. Klicken Sie auf \"Studie kostenpflichtig bestellen\" um ein Printexemplar der Callidus Vergütungsstudie 2016/17 verbindlich auf Rechnung zu bestellen. Die Printversion der Studie wird Ihnen innerhalb von 3-5 Tagen per Post zugestellt. Die Zusammenfassung steht Ihnen im Anschluss der Bestellung sofort zum Download bereit.</p></div></div></section><hr><!-- Formularelemente --><div class=row><div class=col-lg-12><div class=box><form class=form-horizontal novalidate><fieldset><legend>Ihre Angaben</legend><ul><li>E-Mail Adresse: {{surveyOrder.page.data.email}}</li><li>Aktuelle Position: {{surveyOrder.page.data.currentPosition}}</li><li>Telefon: {{surveyOrder.page.data.phone}}</li><li>AGB und Nutzungsbedingungen akzeptiert: {{surveyOrder.page.data.acceptedTermsAndConditions? \"Ja\" : \"Nein\"}}</li><li>Datenschutzvereinbarung akzeptiert: {{surveyOrder.page.data.acceptedPrivacyPolicy? \"Ja\" : \"Nein\"}}</li><li>Newsletter zugestimmt: {{surveyOrder.page.data.acceptedNewsletter? \"Ja\" : \"Nein\"}}</li><li>Rechnungsadresse:<ul><li>Firma: {{surveyOrder.page.data.invoiceAddress.companyName}}</li><li>Empfänger: {{surveyOrder.page.data.invoiceAddress.salutation}} {{surveyOrder.page.data.invoiceAddress.lastName}}, {{surveyOrder.page.data.invoiceAddress.firstName}}</li><li>Straße / Postfach: {{surveyOrder.page.data.invoiceAddress.streetAndHouseNumberOrPostbox}}</li><li>PLZ / Stadt: {{surveyOrder.page.data.invoiceAddress.zipCode}} {{surveyOrder.page.data.invoiceAddress.city}}</li><li>Land: {{surveyOrder.page.data.invoiceAddress.country}}</li></ul></li><li>Lieferadresse:<ul><li>Firma: {{surveyOrder.page.data.deliveryAddress.companyName}}</li><li>Empfänger: {{surveyOrder.page.data.deliveryAddress.salutation}} {{surveyOrder.page.data.deliveryAddress.lastName}}, {{surveyOrder.page.data.deliveryAddress.firstName}}</li><li>Straße / Postfach: {{surveyOrder.page.data.deliveryAddress.streetAndHouseNumberOrPostbox}}</li><li>PLZ / Stadt: {{surveyOrder.page.data.deliveryAddress.zipCode}} {{surveyOrder.page.data.deliveryAddress.city}}</li><li>Land: {{surveyOrder.page.data.deliveryAddress.country}}</li></ul></li></ul></fieldset><fieldset><legend>Bestellübersicht</legend><div class=form-group ng-class=\"{\'has-error\': calculator.errors.gender}\"><div class=col-lg-9><p>Mit dem Absenden dieses Formulars tätigen Sie einen kostenpflichtigen Rechnungskauf einer Printversion der Callidus Energiestudie 2016/17 zum Preis von 299,- EUR inkl. Versandkosten und 19% MwSt. gemäß unserer <a ui-sref=terms_and_conditions ui-sref-active=active class=footer-link target=_blank>AGB und Nutzungsbedingungen</a>.</p></div></div></fieldset><div class=\"btn-group schema-form-actions\"><!-- ngRepeat: item in form.items --> <button class=\"btn btn-lg\" type=button ng-click=surveyOrder.backToPageOne()>Zurück</button> <input type=submit class=\"btn btn-primary btn-lg\" value=\"Studie kostenpflichtig bestellen\" ng-click=surveyOrder.doOrder($event)></div></form></div></div></div></div><!-- ORDER PAGE 3 --><div class=row ng-show=\"surveyOrder.page.index == 2\"><div class=col-lg-12><section><div class=jumbotron><h1>Vergütungsstudie 2016/17 bestellt</h1><p>Vielen Dank für Ihre Bestellung, der Versand erfolgt in 3-5 Tagen. Die Zusammenfassung der Callidus Vergütungsstudie 2016/17 steht unter diesem <a ng-href={{surveyOrder.page.data}} target=_blank>Link zur Zusammenfassung der Studie</a> für Sie zum Download bereit.</p></div></section></div></div>");}]);